<template>
  <!-- <v-container v-resize="checkMobile" grid-list-md text-xs-center :style="isMobile ? 'padding: 2px !important;' : ''"> -->
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"></loading>
    <v-card>
      <v-card-title>
        <v-flex md12 :class="isMobile ? 'align-center text-center' : 'd-inline-flex align-center'
          ">
          <v-flex md12 :class="isMobile ? 'align-center text-center' : 'text-center'
            ">
            <v-flex xs12 sm12 md12>
              <v-avatar size="250px" color="grey lighten-3" class="UppyModalOpenerBtn mb-3" style="cursor: pointer;">
                <v-img 
                  v-if="car && car.avatar_url"
                  :src="car.avatar_url" 
                  :lazy-src="getDefaultImage()"
                  :alt="car.car_name"
                  class="car-avatar" 
                  height="250px" 
                  width="250px"
                  @error="onImageError">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-img 
                  v-else
                  :src="getDefaultImage()" 
                  :alt="car && car.car_name"
                  class="car-avatar" 
                  height="250px" 
                  width="250px">
                </v-img>
              </v-avatar>
              <uppy-car-avatar v-if="car.id" :max-file-size-in-bytes="50000000" :width="isMobile ? 300 : 750" :height="250"
                :theme="$vuetify.theme.dark ? 'dark' : 'light'" :car_id="car.id"
                @updateAvatar="updateAvatar($event)"></uppy-car-avatar>
            </v-flex>
            <v-flex>
              <h4 v-if="isMobile" class="text-center mb-2" :style="user_role == 'guest' ? 'display: none;' : ''">
                <v-tooltip v-if="showPriceGap" bottom color="grey darken-3"
                  open-on-click :open-on-hover="!isMobile">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" data-testid="price-gap-icon" small
                      color="warning" class="mr-1" style="cursor: help;">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div style="text-align: left; padding: 4px;" class="white--text">
                    <div v-for="line in priceGapLines" :key="line">{{ line }}</div>
                  </div>
                </v-tooltip>
                {{ car.car_name }} {{ car.code }}<br />{{ car.number }}
                <agent-marker record-type="Car" :record-id="car.id" />
              </h4>
              <h4 v-else :style="user_role == 'guest' ? 'display: none;' : ''">
                <v-tooltip v-if="showPriceGap" bottom color="grey darken-3"
                  open-on-click :open-on-hover="!isMobile">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" data-testid="price-gap-icon" small
                      color="warning" class="mr-1" style="cursor: help;">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div style="text-align: left; padding: 4px;" class="white--text">
                    <div v-for="line in priceGapLines" :key="line">{{ line }}</div>
                  </div>
                </v-tooltip>
                {{ car.car_name }} {{ car.code }} {{ car.number }}
                <!-- FT-184 REQ-12: метка «через агента» (без метки не рисуется) -->
                <agent-marker record-type="Car" :record-id="car.id" />
              </h4>
            </v-flex>
            <!-- Штрафус мониторинг штрафов -->
            <!-- Штрафус мониторинг штрафов -->
            <v-flex v-if="showFines && (car.id && company && company.fines_provider === 'shtrafus')">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row align="center">
                      <v-col cols="12" sm="12" md="12" lg="12" align="center">
                        <v-icon :color="car.shtrafus_active ? 'success' : 'grey'" size="24">
                          {{ car.shtrafus_active ? 'mdi-shield-check' : 'mdi-shield-outline' }}
                        </v-icon>
                        <span class="ml-2">
                          {{ $t("fines.fines_monitory") }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <!-- Статус. shtrafusPending — подписка/отписка ушла в джобу (см. markShtrafusPending);
                         до перезагрузки карточки кнопок нет. -->
                    <p v-if="shtrafusPending" class="warning--text" data-cy="shtrafus-pending">
                      {{ $t("fines.monitoring_status_updating") }}
                    </p>
                    <p v-else-if="car.shtrafus_active" class="success--text">{{ $t("fines.check_on") }}</p>
                    <p v-else-if="car.shtrafus_vehicle_id" class="warning--text">
                      {{ $t("fines.subscription_error") }}
                    </p>
                    <p v-else>{{ $t("fines.check_off") }}</p>

                    <!-- Действия -->
                    <v-row v-if="!shtrafusPending" class="mt-2" justify="center">
                      <!-- Разовая проверка — только если НЕ подписан и НЕ в процессе -->
                      <!-- <v-col cols="auto" v-if="car.active && !car.shtrafus_vehicle_id">
                        <v-btn small color="primary" @click="shtrafusSearchFines()"
                          :loading="isLoadingShtrafusSearch">
                          <v-icon left small>mdi-magnify</v-icon>
                          {{ $t("fines.search_fines") }}
                        </v-btn>
                      </v-col> -->
                      <!-- Подписка на мониторинг — только если ещё не подключали -->
                      <v-col cols="auto" v-if="car.active && !car.shtrafus_vehicle_id">
                        <v-btn small color="success" @click="addCarToShtrafus()"
                          :loading="isLoadingShtrafus">
                          <v-icon left small>mdi-shield-plus</v-icon>
                          {{ $t("fines.subscribe_monitoring") }}
                        </v-btn>
                      </v-col>
                      <!-- Повторить подписку — vehicle_id есть, но active ещё нет -->
                      <v-col cols="auto" v-if="car.active && car.shtrafus_vehicle_id && !car.shtrafus_active">
                        <v-btn small color="warning" @click="retryShtrafusSubscription()"
                          :loading="isLoadingShtrafus">
                          <v-icon left small>mdi-reload</v-icon>
                          {{ $t("fines.retry_subscription") }}
                        </v-btn>
                      </v-col>
                      <!-- Отписка — если vehicle_id есть -->
                      <v-col cols="auto" v-if="car.active && car.shtrafus_vehicle_id">
                        <v-btn small color="error" outlined @click="removeCarFromShtrafus()"
                          :loading="isLoadingShtrafus">
                          <v-icon left small>mdi-minus-circle</v-icon>
                          {{ $t("fines.remove_car_from_fines") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
            <!-- Действия по авто — только по загруженному: до ответа сервера
                 сохранение ушло бы PATCH /cars/undefined, задача создалась бы
                 с пустым taskable_id, prev/next некуда вести (cars_ids пуст). -->
            <v-flex v-if="car.id" class="start-tour-car-3 mt-2">
              <v-btn icon @click="prevCar()">
                <v-icon class="secondary--text" size="28">
                  mdi-chevron-left-circle-outline
                </v-icon>
              </v-btn>
              <!-- <v-icon
                :class="isMobile ? '' : 'ml-4'"
                @click="showEdit = true"
                id="registration-step-40"
                size="28"
              >
                mdi-pencil-outline
              </v-icon> -->
              <v-icon class="ml-4 green--text" @click="editSave()" data-testid="car-card-save-icon">
                mdi-content-save-all-outline
              </v-icon>
              <!-- <v-icon
                v-if="!car.archive"
                class="ml-4 red--text"
                @click="repair_dialog = true"
                size="28"
              >
                mdi-car-brake-alert
              </v-icon> -->
              <v-icon v-if="!car.active && checkAdmin()" class="ml-4 red--text" size="28" @click="deleteItem(car)"
                v-tooltip="{
                  content: $t('tooltips.remove_car'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">
                mdi-delete-forever
              </v-icon>
              <v-icon v-if="!car.archive" class="ml-4 info--text" size="28" @click="inspection_dialog = true" v-tooltip="{
                content: $t('tooltips.view_car'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 500,
                },
              }">
                mdi-cog-sync-outline
              </v-icon>
              <v-icon v-if="!car.archive" class="ml-4 secondary--text" size="28" @click="
                (store_place_dialog = true), (store_place = car.store_place)
                " v-tooltip="{
                  content: $t('tooltips.place_car'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">
                mdi-home-search-outline
              </v-icon>
              <v-icon v-if="car.archive" class="ml-4 green--text" size="28" @click="unarchiveCar()">
                mdi-archive-arrow-up
              </v-icon>
              <v-icon v-if="!car.active && !car.archive" class="ml-4 warning--text" size="28" @click="archiveCar()" data-testid="car-archive-btn">
                mdi-archive-arrow-down
              </v-icon>
              <v-menu offset-y v-if="car.state == 1 || car.state == null">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-4" size="28" v-tooltip="{
                    content: $t('states.normal'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="success">
                    mdi-thumb-up
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index" @click="updateCarState(car.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="car.state == 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-4" size="28" v-tooltip="{
                    content: $t('states.in_service'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="secondary">
                    mdi-tools
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index" @click="updateCarState(car.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="car.state == 3">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-4" size="28" v-tooltip="{
                    content: $t('states.critical'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="error">
                    mdi-alert-box
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index" @click="updateCarState(car.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="car.state == 4">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-4" size="28" v-tooltip="{
                    content: $t('states.long_rent'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="pink">
                    mdi-all-inclusive
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index" @click="updateCarState(car.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="car.state == 5">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-4" size="28" v-tooltip="{
                    content: $t('states.no_rent'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="info">
                    mdi-airplane-off
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index" @click="updateCarState(car.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y v-if="car.state == 6">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-4" size="28" v-tooltip="{
                    content: $t('states.service_needed_2'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }" v-bind="attrs" v-on="on" color="orange">
                    mdi-alarm-light
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(state, index) in states" :key="index" @click="updateCarState(car.id, state.id)">
                    <v-list-item-title>
                      {{ state.state }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon v-if="car.id && !car.archive" class="ml-4 green--text" size="28" @click="sell_dialog = true">
                mdi-cash-multiple
              </v-icon>
              <!-- FT-173 REQ-11: точка входа в мастер «Аренда с выкупом», car_id
                   в query подставляется в шаг 2 (REQ-02, ContractWizard.vue).
                   STEP-22 (F9, REQ-21): v-btn icon, не голый кликабельный
                   v-icon — тот не входит в таб-порядок и не реагирует на
                   Enter/Space, aria-label его не чинит. Соседние v-icon
                   (mdi-cash-multiple и др.) намеренно не тронуты. -->
              <v-btn
                v-if="car.id && rentToOwnEntryVisible"
                icon
                class="ml-4"
                :aria-label="$t('rent_to_own.wizard.entry_button')"
                data-testid="rent-to-own-entry-car-button"
                @click="openRentToOwnWizard"
                v-tooltip="{
                  content: $t('rent_to_own.wizard.entry_button'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: { show: 500, hide: 500 },
                }"
              >
                <v-icon size="28">mdi-car-key</v-icon>
              </v-btn>
              <!-- FT-076: добавить задачу по авто -->
              <v-icon v-if="isStaff"
                class="ml-4" size="28" @click="taskDialog = true" v-tooltip="{
                  content: $t('tasks.new_task'),
                  placement: 'bottom-center',
                  classes: ['black--text', 'white'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: { show: 500, hide: 500 },
                }">
                mdi-checkbox-marked-circle-plus-outline
              </v-icon>
              <v-btn icon @click="nextCar()" class="ml-4">
                <v-icon class="secondary--text" size="28">
                  mdi-chevron-right-circle-outline
                </v-icon>
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn v-if="car.id && !car.active" :small="isMobile ? true : false" :loading="isLoadinSaveCarActive" color="success"
              class="ma-2 mt-4 white--text" @click="saveCarActive()" id="registration-step-471" v-tooltip="{
                content: $t('tooltips.activate_car'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 1000,
                },
              }">
              {{ $t("custom.activate") }}
              <v-icon right dark> mdi-alpha-a-circle-outline </v-icon>
            </v-btn>
            <v-btn v-else-if="car.id" color="grey" :small="isMobile ? true : false" class="ma-2 mt-4 white--text"
              @click="disactivateCar()" :loading="isLoadingDisactivateCar" id="registration-step-471" v-tooltip="{
                content: $t('tooltips.deactivate_car'),
                placement: 'bottom-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 500,
                  hide: 1000,
                },
              }">
              {{ $t("custom.deactivate") }}
              <v-icon right dark> mdi-car-off </v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
        <v-flex md12 v-if="car.store_place">
          <h5 class="grey--text text--lighten-1 text-center">
            {{ $t("home.location") }}: {{ car.store_place }}
          </h5>
        </v-flex>
      </v-card-title>
      <!-- Начальная загрузка не удалась (обычно обрыв мобильной сети) — вместо
           пустой карточки даём повторить запрос без перезагрузки страницы -->
      <load-failed-retry v-if="loadFailed && !car.id && !isLoading" :message="loadFailedMessage"
        @retry="loadCarCardData()" />
      <!-- FT-076: задачи по авто — сворачиваемая панель вверху карточки -->
      <!-- FT-076: задачи по авто — секция только если есть задачи (создание из иконки в шапке).
           Обёрнута в v-card-text + v-container как таб-контент → совпадает по ширине. -->
      <v-card-text v-if="car && car.id" class="pt-2 pb-0" :style="isMobile ? 'padding: 2px !important;' : ''">
        <v-container class="py-0" :style="isMobile ? 'padding: 2px !important;' : ''">
          <task-card-section taskable-type="Car" :taskable-id="car.id"
            :initial-section="cardSections.tasks" :initial-users-section="cardSections.task_users"
            :initial-entity-id="cardSectionsEntityId" />
        </v-container>
      </v-card-text>
      <task-form-dialog v-model="taskDialog" taskable-type="Car" :taskable-id="car.id" @saved="onTaskSaved" />
      <!-- Вкладки — только по загруженному авто: все 81 поле с v-model="car.*"
           живут внутри, и до ответа сервера править их нечему (прод 18.09.2026). -->
      <v-tabs v-if="car.id" light v-model="tabs" :fixed-tabs="!isMobile" :centered="!isMobile"
        class="start-tour-car-1 start-tour-car-2">
        <v-tab>
          {{ $t("custom.bookings") }}
        </v-tab>
        <v-tab>
          {{ $t("custom.characteristics") }}
        </v-tab>
        <v-tab>
          {{ $t("custom.prices") }}
        </v-tab>
        <v-tab>
          {{ $t("custom.service") }}
        </v-tab>
        <v-tab>
          {{ $t("custom.files") }}
        </v-tab>
        <v-tab v-if="isAdminPlus ||
          isPartner || isGuest
        ">
          {{ $t("custom.analitics") }}
        </v-tab>
        <v-tab v-else>
          {{ $t("custom.expences") }}
        </v-tab>
        <v-tab>
          {{ $t("to.to") }}
        </v-tab>
        <v-tab>
          {{ $t("store.store") }}
        </v-tab>
        <v-tab>
          {{ $t("companies.integrations") }}
        </v-tab>
        <v-tab v-if="isTaxiMode">
          <v-icon left>mdi-taxi</v-icon>
          {{ $t("taxi.terminology.taxi_info") }}
        </v-tab>
        <v-tab v-if="isStarlineMode">
          StarLine
        </v-tab>
        <v-tab v-if="isWialonMode">
          Wialon
        </v-tab>
        <v-tab v-if="isAutofonMode">
          AutoFon
        </v-tab>
        <v-tab v-if="isTraccarMode">
          Traccar
        </v-tab>
        <v-tab v-if="damageControlAvailable">
          {{ $t("damage_control.passport.title") }}
        </v-tab>
        <v-tabs-items v-model="tabs" touchless>
          <!-- Брони 0-->
          <v-tab-item>
            <v-card flat>
              <v-card-text :style="isMobile ? 'padding: 2px !important;' : ''">
                <v-container :style="isMobile ? 'padding: 2px !important;' : ''">
                  <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
                    <v-spacer></v-spacer>
                    <v-row align="center" class="ml-4">
                      <v-text-field :dense="isMobile" v-model="search_bookings" prepend-icon="mdi-magnify"
                        :label="$t('custom.search')" single-line clearable hide-details></v-text-field>
                    </v-row>
                  </v-toolbar>
                  <v-card-text>
                    <v-container fill-height>
                      <v-row justify="center" align="center">
                        <v-col cols="12">
                          <!-- FT-116: календарь грузит только видимый диапазон месяцев и
                               догружает новые при листании (v-calendar 2.4.2 эмитит эти
                               события через $listeners). -->
                          <vc-date-picker :value="new Date()" :attributes="calendar_attributes" title-position="left"
                            :columns="$screens({ default: 1, md: 2, lg: 4 })" :is-expanded="true" :locale="$i18n.locale"
                            :is-dark="$vuetify.theme.dark"
                            @update:from-page="onCalendarPageChange($event, null)"
                            @update:to-page="onCalendarPageChange(null, $event)" />
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-divider class="mt-3 mb-3"></v-divider>

                    <!-- FT-116: серверная таблица. :search снят намеренно — клиентский фильтр
                         Vuetify поверх серверного поиска выбрасывал бы найденные строки при
                         ненулевом total. Вариант «все строки» (-1) убран из футера: он
                         возвращал бы выгрузку всей истории одним кликом. sort-by="sort" убран:
                         колонки sort в заголовках нет, и с :options.sync это имя уехало бы на
                         сервер и молча свалилось в дефолт. -->
                    <v-data-table :headers="bookings_headers" :items="bookings"
                      :server-items-length="bookings_total" :options.sync="bookings_options"
                      :loading="isLoading" :loading-text="$t('custom.loading_table')"
                      item-key="id" :items-per-page="20" mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'"
                      dense :footer-props="tableFooterProps([20, 50, 100])">
                      <template slot="item" slot-scope="props">
                        <tr @dblclick="replaceToBooking(props.item)" style="cursor: pointer" :class="!props.item.technical ? '' : 'blue-grey lighten-4'
                          ">
                          <td class="text-center" :key="props.item.id">
                            <rent-to-own-number-chip v-if="props.item.rent_to_own === true" small :booking="props.item" />
                            <router-link v-else :to="{
                              name: 'BookingCard',
                              params: { id: props.item.id },
                            }">{{ props.item.id }}</router-link>
                          </td>
                          <td nowrap class="text-center">
                            {{ returnDate(props.item.created_at) }}
                          </td>
                          <td class="text-center">
                            <v-flex class="d-flex text-center justify-center">
                              <v-icon class="mr-2" v-if="props.item.in_rent" color="primary" :title="$t('bookings.in_rent')">
                                mdi-car
                              </v-icon>
                              <v-icon v-if="props.item.active && !props.item.in_rent" class="mr-2" style="z-index: 1"
                                color="secondary" :title="$t('bookings.booked')">
                                mdi-clock-outline
                              </v-icon>
                              <v-icon v-if="props.item.failure" :title="$t('bookings.decline')">
                                mdi-close-circle-outline
                              </v-icon>
                            </v-flex>
                          </td>
                          <td class="text-center">
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                  <v-btn :color="getStateColor(props.item.state)" icon
                                    :loading="isLoadingSaveBookingState && updatingBookingId == props.item.id" :title="getStateTooltip(props.item.state)">
                                    <v-icon>
                                      {{ getStateIcon(props.item.state) }}
                                    </v-icon>
                                  </v-btn>
                                </span>
                              </template>
                              <v-list dense>
                                <v-list-item v-for="(state, index) in bookings_states" :key="index"
                                  @click="saveBookingState(state.value, props.item.id)">
                                  <v-list-item-icon>
                                    <v-icon :color="getStateColor(state.value)">{{ getStateIcon(state.value) }}</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-title>
                                    {{ state.text }}
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                          <td class="text-center" nowrap v-if="!props.item.entity" :style="user_role == 'guest' ? 'display: none;' : ''
                            ">
                            <router-link :to="{
                              name: 'ClientCard',
                              params: { id: props.item.client_id },
                            }">
                              {{
                                props.item.last_name ? props.item.last_name : ""
                              }}
                              {{
                                props.item.first_name
                                  ? props.item.first_name[0]
                                  : ""
                              }}.
                              {{
                                props.item.middle_name
                                  ? props.item.middle_name[0]
                                  : ""
                              }}.
                            </router-link>
                          </td>
                          <td class="text-center" v-else :style="user_role == 'guest' ? 'display: none;' : ''
                            ">
                            <router-link :to="{
                              name: 'ClientCard',
                              params: { id: props.item.client_id },
                            }">{{ props.item.entity_name }}</router-link>
                          </td>
                          <td v-if="!isMobile" nowrap class="text-center">
                            {{ formatDateBookingDates(props.item.start_date) }}
                            <br />
                            {{ formatTimeBookingDates(props.item.start_date) }}
                          </td>
                          <td v-else nowrap class="text-center">
                            {{ shortFormatBookingDates(props.item.start_date) }}
                          </td>
                          <td class="text-center" nowrap v-if="!isMobile && !props.item.active">
                            {{ formatDateBookingDates(props.item.end_date) }}
                            <br />
                            {{ formatTimeBookingDates(props.item.end_date) }}
                          </td>
                          <td class="text-center" nowrap v-if="isMobile && !props.item.active">
                            {{ shortFormatBookingDates(props.item.end_date) }}
                          </td>
                          <td class="text-center" nowrap v-if="!isMobile && props.item.active"
                            :style="checkLateDate(props.item.end_date)">
                            {{ formatDateBookingDates(props.item.end_date) }}
                            <br />
                            {{ formatTimeBookingDates(props.item.end_date) }}
                          </td>
                          <td class="text-center" nowrap v-if="isMobile && props.item.active"
                            :style="checkLateDate(props.item.end_date)">
                            {{ shortFormatBookingDates(props.item.end_date) }}
                          </td>
                          <td class="text-center">{{ props.item.days }}</td>
                          <td class="text-center">
                            {{ props.item.location_start }}
                          </td>
                          <td class="text-center">
                            {{ props.item.location_end }}
                          </td>
                          <td class="text-truncate" style="max-width: 200px" @click="
                            (showDescriptionEditId = props.item.id),
                            (descriptionEdit = props.item.description),
                            (showDescriptionEditDialog = true)
                            " v-tooltip="{
                              content: `${props.item.description}`,
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                            {{ props.item.description }}
                          </td>
                        </tr>
                      </template>
                      <template slot="no-data">
                        {{ $t("custom.no_data_in_table") }}
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                        {{
                          $t("tables.no_search_result", {
                            msg: search_inspections,
                          })
                        }}
                      </v-alert>
                    </v-data-table>
                    <!-- </v-layout> -->
                  </v-card-text>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Характеристики 1-->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.trim="car.car_name" class="mx-1 mb-2" :label="$t('cars.name_full')" dense
                        outlined :rules="[(v) => !!v || $t('cars.name_full_required')]"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.trim="car.code" class="mx-1 mb-2" required :label="$t('cars.code')" dense
                        outlined
                        :rules="[(v) => !!v || $t('cars.code_required'), (v) => !v || v.length <= 8 || $t('cars.code_length')]"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.number="car.sort" class="mx-1 mb-2" :label="$t('cars.sort_number')" dense
                        outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.trim="car.number" class="mx-1 mb-2" :label="$t('cars.gov_number')" dense
                        outlined :style="user_role == 'guest' ? 'display: none;' : ''"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.trim="car.vin" class="mx-1 mb-2" :label="$t('cars.vin')" dense outlined
                        :style="user_role == 'guest' ? 'display: none;' : ''"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.trim="car.body_number" class="mx-1 mb-2" :label="$t('cars.body_number')"
                        dense outlined :style="user_role == 'guest' ? 'display: none;' : ''"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.trim="car.pts" class="mx-1 mb-2" :label="$t('cars.reg_number')" dense
                        outlined :style="user_role == 'guest' ? 'display: none;' : ''"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.trim="car.registration_certificate" class="mx-1 mb-2"
                        :label="$t('cars.sts_number')" dense outlined
                        :style="user_role == 'guest' ? 'display: none;' : ''"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select v-model="car.car_type" class="mx-1 mb-2" :items="current_object_types" item-text="text"
                        item-value="value" dense :label="$t('cars.body_type')" outlined></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="car.color" class="mx-1 mb-2" :label="$t('cars.color')" dense
                        outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.number="car.year" class="mx-1 mb-2" :label="$t('cars.year')" type="number"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select v-model="car.transmission" class="mx-1 mb-2" :items="gears" dense item-text="text"
                        item-value="value" :label="$t('cars.gear')" outlined></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select v-model="car.drive_unit" class="mx-1 mb-2" :items="drive_units" dense item-text="text"
                        item-value="value" :label="$t('cars.drive_unit')" outlined></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="showFuel">
                      <v-select v-model="car.fuel" class="mx-1 mb-2" :items="fuels" dense item-text="text"
                        item-value="value" :label="$t('cars.fuel')" outlined></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="showFuel">
                      <v-text-field v-model.number="car.tank_value" class="mx-1 mb-2" :label="$t('cars.tank_value')"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="showFuel">
                      <v-text-field v-model.number="car.gas_mileage" class="mx-1 mb-2" :label="$t('cars.gas_mileage')"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-select v-model="car.steering_side" class="mx-1 mb-2" :items="steering_side" item-text="text"
                        item-value="value" dense :label="$t('cars.steering_side')" outlined></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.number="car.number_doors" class="mx-1 mb-2" :label="$t('cars.number_doors')"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.number="car.number_seats" class="mx-1 mb-2" :label="$t('cars.number_seats')"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.number="car.engine_capacity" class="mx-1 mb-2"
                        :label="$t('cars.engine_capacity')" dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.number="car.engine_power" class="mx-1 mb-2" :label="$t('cars.engine_power')"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="car.tire_size" class="mx-1 mb-2" :label="$t('cars.tire_size')" dense
                        outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="car.purchase_date" class="mx-1 mb-2" type="date"
                        :label="$t('cars.purchase_date')" dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model.number="car.purchase_price" class="mx-1 mb-2"
                        :label="$t('cars.purchase_price')" dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="car.sale_date">
                      <v-text-field v-model="car.sale_date" class="mx-1 mb-2" type="date" :label="$t('cars.sale_date')"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="car.sale_price">
                      <v-text-field v-model.number="car.sale_price" class="mx-1 mb-2" :label="$t('cars.sale_price')"
                        dense outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="showInsurance">
                      <v-text-field v-model="car.franchise" class="mx-1 mb-2" :label="$t('cars.franchise')" dense
                        outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="showFines">
                      <v-text-field v-model="car.max_fine" class="mx-1 mb-2" :label="$t('cars.max_fine')" dense
                        outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field v-model="car.repair_cost" class="mx-1 mb-2" :label="$t('cars.repair_cost')" dense
                        outlined></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-autocomplete v-model="car.company_id" class="mx-1 mb-2" item-value="id" dense outlined
                        :label="$t('custom.branche')" :items="branches" :disabled="branches.length > 0 ? false : true">
                        <template slot="selection" slot-scope="data">
                          {{ data.item.name }} - {{ data.item.city }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.name }} - {{ data.item.city }}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-checkbox v-model="car.is_electropackage" :label="$t('cars.is_electropackage')" dense
                        hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-checkbox :label="$t('cars.is_air')" v-model="car.is_air" dense hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-checkbox :label="$t('cars.climate_control')" v-model="car.climate_control" dense
                        hide-details></v-checkbox>
                    </v-flex>
                    <v-flex md12 class="mt-3">
                      <v-textarea v-model="car.description" :label="$t('cars.description')" rows="2"
                        outlined></v-textarea>
                    </v-flex>
                    <v-flex md12>
                      <v-divider class="my-3"></v-divider>
                    </v-flex>

                    <!-- Теги -->
                    <v-flex xs12 v-if="tagGroups.length > 0" class="mb-2">
                      <div class="caption grey--text mb-2 mt-1">{{ $t("tags.manage_tags") }}</div>
                      <div v-for="group in tagGroups" :key="'tg-' + group.id" class="d-flex align-center flex-wrap mb-1" style="gap: 4px">
                        <span class="caption font-weight-medium mr-2">{{ tagGroupDisplayName(group) }}:</span>
                        <v-chip-group v-model="carTagSelections[group.id]" :multiple="group.allow_multiple" class="ma-0 pa-0"
                                      @change="saveCarTags">
                          <v-chip v-for="tag in group.tags" :key="tag.id" :value="tag.id"
                                  :color="tag.color" :text-color="isLightTagColor(tag.color) ? '#333' : '#fff'"
                                  :class="{ 'tag-dimmed': isTagDimmed(group, tag) }"
                                  x-small filter>{{ tag.name }}</v-chip>
                        </v-chip-group>
                      </div>
                    </v-flex>
                    <v-flex md12 v-if="tagGroups.length > 0">
                      <v-divider class="my-3" />
                    </v-flex>

                    <!-- GPS интеграция -->
                    <v-flex md12 class="mt-3">
                      <h3 class="mb-2">{{ $t('starline.gps_integration') }}</h3>
                      <v-radio-group v-model="car.gps_integration_type" row dense>
                        <v-radio :label="$t('starline.no_integration')" value="none"></v-radio>
                        <v-radio :label="'RentProg'" value="traccar" :disabled="!main_company.beacons_on"></v-radio>
                        <v-radio :label="'StarLine'" value="starline" :disabled="!main_company.starline_on || !includedInPlan('starline')"></v-radio>
                        <v-radio :label="'Wialon'" value="wialon" :disabled="!main_company.wialon_on || !includedInPlan('wialon')"></v-radio>
                        <v-radio :label="'AutoFon'" value="autofon" :disabled="!main_company.autofon_on || !includedInPlan('autofon')"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <!-- Поля данных маяков без интеграции -->
                    <v-flex md12 :class="isMobile ? '' : 'd-flex align-middle'" v-if="car.gps_integration_type === 'none'">
                      <v-flex xs12 sm6 md3>
                        <v-text-field v-model="car.beacon_emai" class="mx-1 mb-2" :label="$t('cars.beacon_emai')" dense
                          hide-details outlined></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field v-model="car.beacon_phone" class="mx-1 mb-2" :label="$t('cars.beacon_phone')"
                          dense hide-details outlined></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field v-model="car.beacon_pin" class="mx-1 mb-2" :label="$t('cars.beacon_pin')" dense
                          hide-details outlined></v-text-field>
                      </v-flex>
                    </v-flex>

                    <!-- Traccar поля -->
                    <v-flex md12 :class="isMobile ? '' : 'd-flex align-middle'" v-if="car.gps_integration_type === 'traccar'">
                      <v-flex xs12 sm6 md3>
                        <v-text-field v-model="car.beacon_emai" class="mx-1 mb-2" :label="$t('cars.beacon_emai')" dense
                          hide-details outlined></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field v-model="car.beacon_phone" class="mx-1 mb-2" :label="$t('cars.beacon_phone')"
                          dense hide-details outlined></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field v-model="car.beacon_pin" class="mx-1 mb-2" :label="$t('cars.beacon_pin')" dense
                          hide-details outlined></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4 class="d-flex align-middle">
                        <v-btn @click="getCurrentPosition(car.id)" class="ml-2" color="info"
                          :title="$t('cars.current_position')" icon
                          :disabled="main_company.beacons_on == false || user_exists_in_traccar == false || car.traccar_id == null">
                          <v-icon>mdi-map-marker-radius-outline</v-icon>
                        </v-btn>
                        <v-btn @click="showReportDialog = true" class="ml-2" color="success"
                          :title="$t('cars.total_distance')" icon
                          :disabled="main_company.beacons_on == false || user_exists_in_traccar == false || car.traccar_id == null">
                          <v-icon>mdi-map-marker-distance</v-icon>
                        </v-btn>
                        <v-btn @click="update_total_distance(car.id)" class="ml-2" color="warning"
                          :title="$t('cars.update_total_distance')" icon
                          :disabled="main_company.beacons_on == false || user_exists_in_traccar == false || car.traccar_id == null">
                          <v-icon>mdi-reiterate</v-icon>
                        </v-btn>
                        <v-btn v-if="car.traccar_id == null" @click="addCarToTraccar(car.id)"
                          class="text-center mt-1 ml-2" elevation="2" color="pink"
                          :disabled="main_company.beacons_on == false || user_exists_in_traccar == false">
                          {{ $t("cars.add_to_traccar") }}
                          <v-icon class="ml-2">mdi-map-marker-plus-outline</v-icon>
                        </v-btn>
                        <v-btn v-if="car.traccar_id != null" @click="removeDeviceFromTraccar(car.id)"
                          class="text-center mt-1 ml-2" elevation="2" color="error"
                          :disabled="user_exists_in_traccar == false">
                          {{ $t("cars.remove_from_traccar") }}
                          <v-icon class="ml-2">mdi-map-marker-off-outline</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-flex>

                    <!-- StarLine поля -->
                    <v-flex md12 :class="isMobile ? '' : 'd-flex align-middle'" v-if="car.gps_integration_type === 'starline'">
                      <!-- Режим просмотра - показываем сохранённый Device ID -->
                      <v-flex xs12 sm6 md5 v-if="car.starline_device_id && !isEditingStarlineDevice">
                        <v-text-field
                          :value="getStarlineDeviceDisplayName(car.starline_device_id)"
                          :label="$t('starline.device_id')"
                          class="mx-1 mb-2"
                          dense
                          hide-details
                          outlined
                          readonly
                        >
                          <template v-slot:append>
                            <v-btn icon small @click="startEditingStarlineDevice" :title="$t('starline.change_device')">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-flex>
                      <!-- Режим редактирования - показываем v-autocomplete -->
                      <v-flex xs12 sm6 md5 v-else>
                        <v-autocomplete
                          v-model="car.starline_device_id"
                          :items="starlineDevices"
                          item-value="id"
                          item-text="displayName"
                          class="mx-1 mb-2"
                          :label="$t('starline.select_device')"
                          dense
                          hide-details
                          outlined
                          :loading="isLoadingStarlineDevices"
                          :no-data-text="$t('starline.no_devices')"
                          clearable
                          @focus="starlineDevices.length === 0 && loadStarlineDevices()"
                          @change="onStarlineDeviceSelected"
                        >
                          <template v-slot:prepend-item>
                            <v-list-item @click="loadStarlineDevices" :disabled="isLoadingStarlineDevices">
                              <v-list-item-icon>
                                <v-icon>mdi-refresh</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ $t('starline.refresh_devices') }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.alias || item.id }}</v-list-item-title>
                              <v-list-item-subtitle v-if="item.imei">IMEI: {{ item.imei }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                          <template v-slot:append-outer v-if="isEditingStarlineDevice">
                            <v-btn icon small @click="cancelEditingStarlineDevice" :title="$t('custom.cancel')">
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </v-flex>

                    <!-- Wialon поля -->
                    <v-flex md12 :class="isMobile ? '' : 'd-flex align-middle'" v-if="car.gps_integration_type === 'wialon'">
                      <!-- Режим просмотра - показываем сохранённый Unit ID -->
                      <v-flex xs12 sm6 md5 v-if="car.wialon_unit_id && !isEditingWialonUnit">
                        <v-text-field
                          :value="getWialonUnitDisplayName(car.wialon_unit_id)"
                          :label="$t('wialon.unit_id')"
                          class="mx-1 mb-2"
                          dense
                          hide-details
                          outlined
                          readonly
                        >
                          <template v-slot:append>
                            <v-btn icon small @click="startEditingWialonUnit" :title="$t('wialon.change_unit')">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-flex>
                      <!-- Режим редактирования - показываем v-autocomplete -->
                      <v-flex xs12 sm6 md5 v-else>
                        <v-autocomplete
                          v-model="car.wialon_unit_id"
                          :items="wialonUnits"
                          item-value="id"
                          item-text="name"
                          class="mx-1 mb-2"
                          :label="$t('wialon.select_unit')"
                          dense
                          hide-details
                          outlined
                          :loading="isLoadingWialonUnits"
                          :no-data-text="$t('wialon.no_units')"
                          clearable
                          @focus="wialonUnits.length === 0 && loadWialonUnits()"
                          @change="onWialonUnitSelected"
                        >
                          <template v-slot:prepend-item>
                            <v-list-item @click="loadWialonUnits" :disabled="isLoadingWialonUnits">
                              <v-list-item-icon>
                                <v-icon>mdi-refresh</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ $t('wialon.refresh_units') }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.name }}</v-list-item-title>
                              <v-list-item-subtitle v-if="item.imei">IMEI: {{ item.imei }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                          <template v-slot:append-outer v-if="isEditingWialonUnit">
                            <v-btn icon small @click="cancelEditingWialonUnit" :title="$t('custom.cancel')">
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </v-flex>

                    <!-- AutoFon поля -->
                    <v-flex md12 :class="isMobile ? '' : 'd-flex align-middle'" v-if="car.gps_integration_type === 'autofon'">
                      <!-- Режим просмотра - показываем сохранённый Object ID -->
                      <v-flex xs12 sm6 md5 v-if="car.autofon_object_id && !isEditingAutofonObject">
                        <v-text-field
                          :value="getAutofonObjectDisplayName(car.autofon_object_id)"
                          :label="$t('autofon.object_id')"
                          class="mx-1 mb-2"
                          dense
                          hide-details
                          outlined
                          readonly
                        >
                          <template v-slot:append>
                            <v-btn icon small @click="startEditingAutofonObject" :title="$t('autofon.change_object')">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-flex>
                      <!-- Режим редактирования - показываем v-autocomplete -->
                      <v-flex xs12 sm6 md5 v-else>
                        <v-autocomplete
                          v-model="car.autofon_object_id"
                          :items="autofonObjects"
                          item-value="id"
                          item-text="name"
                          class="mx-1 mb-2"
                          :label="$t('autofon.select_object')"
                          dense
                          hide-details
                          outlined
                          :loading="isLoadingAutofonObjects"
                          :no-data-text="$t('autofon.no_objects')"
                          clearable
                          @focus="autofonObjects.length === 0 && loadAutofonObjects()"
                          @change="onAutofonObjectSelected"
                        >
                          <template v-slot:prepend-item>
                            <v-list-item @click="loadAutofonObjects" :disabled="isLoadingAutofonObjects">
                              <v-list-item-icon>
                                <v-icon>mdi-refresh</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ $t('autofon.refresh_objects') }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.name }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <template v-slot:append-outer v-if="isEditingAutofonObject">
                            <v-btn icon small @click="cancelEditingAutofonObject" :title="$t('custom.cancel')">
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </v-flex>

                    <v-flex md12>
                      <v-divider class="my-3"></v-divider>
                    </v-flex>
                    
                    <v-flex md12 class="mt-3">
                      <v-expansion-panels v-model="showDopPanel">
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <h2 class="mb-0">
                              {{ $t("cars.extra_characteristics") }}
                            </h2>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-container>
                              <v-layout row wrap>
                                <v-flex xs12 sm6 md3>
                                  <v-select v-model="car.interior" class="mx-1 mb-2" :items="interiors" dense
                                    hide-details item-text="text" item-value="value" :label="$t('cars.interior')"
                                    outlined></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-select v-model="car.roof" class="mx-1 mb-2" :items="roofs" item-text="text"
                                    item-value="value" dense hide-details :label="$t('cars.roof')" outlined></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-text-field v-model.number="car.trunk_volume" class="mx-1 mb-2"
                                    :label="$t('cars.trunk_volume')" dense hide-details outlined></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-text-field v-model.number="car.airbags" class="mx-1 mb-2"
                                    :label="$t('cars.airbags')" dense hide-details outlined></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-text-field v-model.number="car.window_lifters" class="mx-1 mb-2"
                                    :label="$t('cars.window_lifters')" dense hide-details outlined></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-text-field v-model="car.custom_field_1" class="mx-1 mb-2"
                                    :label="$t('cars.custom_field_1')" dense hide-details outlined></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-text-field v-model="car.custom_field_2" class="mx-1 mb-2"
                                    :label="$t('cars.custom_field_2')" dense hide-details outlined></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-text-field v-model="car.custom_field_3" class="mx-1 mb-2"
                                    :label="$t('cars.custom_field_3')" dense hide-details outlined></v-text-field>
                                </v-flex>
                                <v-flex col-12> </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.rain_sensor" :label="$t('cars.rain_sensor')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.heated_windshield" :label="$t('cars.heated_windshield')"
                                    dense hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.folding_seats" :label="$t('cars.folding_seats')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.video_system" :label="$t('cars.video_system')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.tv_system" :label="$t('cars.tv_system')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.cd_system" :label="$t('cars.cd_system')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.usb_system" :label="$t('cars.usb_system')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.audio_system" :label="$t('cars.audio_system')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.wheel_adjustment" :label="$t('cars.wheel_adjustment')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.wheel_adjustment_full"
                                    :label="$t('cars.wheel_adjustment_full')" dense hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.parktronic_camera" :label="$t('cars.parktronic_camera')"
                                    dense hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.parktronic_back" :label="$t('cars.parktronic_back')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.parktronic" :label="$t('cars.parktronic')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.heated_seats_front" :label="$t('cars.heated_seats_front')"
                                    dense hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.heated_seats" :label="$t('cars.heated_seats')" dense
                                    hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox v-model="car.abs" :label="$t('cars.abs')" dense hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox :label="$t('cars.ebd')" v-model="car.ebd" dense hide-details></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-checkbox :label="$t('cars.esp')" v-model="car.esp" dense hide-details></v-checkbox>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="editSave()" :loading="isLoadingEditSave" data-testid="car-characteristics-save">
                  {{ $t("custom.save") }}
                  <v-icon class="ml-1" v-if="!isLoadingEditSave">
                    mdi-content-save-check-outline
                  </v-icon>
                  <v-icon v-else>
                    mdi-loading
                  </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <!-- Цены 2-->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <h3 class="text-center">{{ $t("bookings.daily_prices") }}</h3>
                  </v-col>
                </v-row>
                <!-- FT-217 REQ-05: предложение переноса в другую ценовую группу; ключей нет
                     для чужого филиала и не-сотрудников — тогда блока нет вовсе -->
                <v-row v-if="price_group_state && price_group_state.suggestion">
                  <v-col cols="12" class="pb-0">
                    <price-group-picker variant="suggestion" :car-id="car.id" :state="price_group_state"
                      @update:state="price_group_state = $event" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div :class="isMobile ? 'mobile-price-table-wrapper' : ''">
                      <v-simple-table>
                      <thead>
                        <tr>
                          <th class="text-no-wrap">{{ $t("cars.season") }}</th>
                          <th v-for="period in periods" :key="period.index" class="text-left text-no-wrap">
                            {{ period }} {{ $tc("bookings.days_plural", periodUpperBound(period)) }}
                          </th>
                          <th class="text-no-wrap">
                            {{
                              periods[periods.length - 1]
                                ? periods[periods.length - 1].split(" - ")[1]
                                : ""
                            }}
                            +
                            {{ $t("bookings.days_low") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(price, index) in car.prices" :key="price.index" id="registration-step-43">
                          <td v-if="price.id" class="text-no-wrap">
                            <v-text-field readonly dense :value="getSeasonValue(price.season_id)"
                              :label="$t('cars.select_season')" hide-details></v-text-field>
                          </td>
                          <td v-else class="text-no-wrap" id="registration-step-42">
                            <v-select :items="select_seasons" item-text="value" item-value="season_id"
                              :label="$t('cars.select_season')" v-model="createPricesInput.season_id" hide-details
                              dense></v-select>
                          </td>
                          <td v-for="(value, value_index) in car.prices[index]
                            .values" :key="value.index" class="text-no-wrap">
                            <v-text-field v-if="value > 0" readonly dense type="number" :value="value" hide-details
                              @click="showNewPrice(price, value_index)"></v-text-field>
                            <v-text-field v-else v-model.number="createPricesInput[value_index]" type="number"
                              :value="value" dense hide-details></v-text-field>
                          </td>
                          <td class="d-flex">
                            <v-icon v-if="price.audits && price.audits.length > 0" class="mr-2"
                              @click="showAudits(price)">
                              mdi-diversify
                            </v-icon>
                            <v-icon v-if="price.id && price.season_id" class="error--text" @click="removeSeasonPrices(price)">
                              mdi-delete
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                      </v-simple-table>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="car && car.prices.length <= seasons.length + 1">
                  <v-col cols="12" class="text-center" id="registration-step-41">
                    <v-btn v-if="showAddPriceBtn" color="info" class="my-2" @click="addPrice()">{{ $t("custom.add")
                      }}
                      <v-icon class="ml-1">
                        mdi-plus-circle-outline
                      </v-icon>
                    </v-btn>
                    <v-btn v-if="createPricesInput.hasOwnProperty('season_id')" :disabled="checkPriceInfo()"
                      color="warning" @click="saveNewPrices()" class="mt-2 my-2">{{ $t("cars.save_prices")
                      }}<v-icon class="ml-1">
                        mdi-content-save-check-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-divider class="mt-2 mb-4"></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" id="registration-step-45">
                    <v-text-field v-model.number="car.price_hour" :label="$t('cars.price_for_hour')" class="mr-2 my-2"
                      dense hide-details outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" id="registration-step-46">
                    <v-text-field v-model.number="car.deposit" :label="$t('cars.deposit')" class="my-2" dense
                      hide-details outlined></v-text-field>
                  </v-col>
                  <!-- FT-217 REQ-09: ценовая группа машины (группы филиала + «Новая группа»).
                       Действие сохраняется сразу, вне общей кнопки сохранения машины. -->
                  <v-col v-if="price_group_state" cols="12" sm="6">
                    <!-- mr-2 — как у полей левой колонки, иначе выбор шире их на отступ -->
                    <price-group-picker class="mr-2" :car-id="car.id" :state="price_group_state"
                      @update:state="price_group_state = $event" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" v-if="showMileage">
                    <v-text-field v-model.number="car.extra_mileage_km" :label="$t('cars.extra_mileage_km')"
                      class="mr-2 my-2" dense hide-details outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="showMileage">
                    <v-text-field v-model.number="car.extra_mileage_price" :label="$t('cars.extra_mileage_price')"
                      class="my-2" dense hide-details outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model.number="car.age_limit" :label="$t('cars.age_limit')" class="mr-2 my-2" dense
                      hide-details outlined type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model.number="car.driver_year_limit" :label="$t('cars.driver_year_limit')"
                      class="my-2" dense hide-details outlined type="number"></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <v-btn id="registration-step-47" color="success" @click="editSave()"
                      :block="isMobile ? true : false" :loading="isLoadingEditSave">
                      {{ $t("custom.save") }}
                      <v-icon class="ml-1" v-if="!isLoadingEditSave">
                        mdi-content-save-check-outline
                      </v-icon>
                      <v-icon v-else>
                        mdi-loading
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-divider class="mt-2 mb-4"></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <h3 class="text-center">{{ $t("bookings.hourly_prices") }}</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div :class="isMobile ? 'mobile-price-table-wrapper' : ''">
                      <v-simple-table>
                      <thead>
                        <tr>
                          <th class="text-no-wrap">{{ $t("cars.season") }}</th>
                          <th v-for="period in periodsHourly" :key="period.index" class="text-left text-no-wrap">
                            {{ period }} {{ $tc("bookings.hours_plural", periodUpperBound(period)) }}
                          </th>
                          <th class="text-no-wrap">
                            {{
                              periodsHourly[periodsHourly.length - 1]
                                ? periodsHourly[periodsHourly.length - 1].split(" - ")[1]
                                : ""
                            }}
                            +
                            {{ $t("bookings.hours") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(price, index) in car.hourly_prices" :key="price.index">
                          <td v-if="price.id" class="text-no-wrap">
                            <v-text-field readonly dense :value="getSeasonValue(price.season_id)"
                              :label="$t('cars.select_season')" hide-details></v-text-field>
                          </td>
                          <td v-else class="text-no-wrap">
                            <v-select :items="select_seasons" item-text="value" item-value="season_id"
                              :label="$t('cars.select_season')" v-model="createHourlyPricesInput.season_id"
                              hide-details dense></v-select>
                          </td>
                          <td v-for="(value, value_index) in car.hourly_prices[index]
                            .values" :key="value.index" class="text-no-wrap">
                            <v-text-field v-if="value > 0" readonly dense type="number" :value="value" hide-details
                              @click="showNewHourlyPrice(price, value_index)"></v-text-field>
                            <v-text-field v-else v-model.number="createHourlyPricesInput[value_index]" type="number"
                              :value="value" dense hide-details></v-text-field>
                          </td>
                          <td class="d-flex">
                            <v-icon v-if="price.audits && price.audits.length > 0" class="mr-2"
                              @click="showAudits(price)">
                              mdi-diversify
                            </v-icon>
                            <v-icon v-if="price.id && price.season_id" class="error--text" @click="removeSeasonHourlyPrices(price)">
                              mdi-delete
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="car && car.hourly_prices.length <= seasons.length + 1">
                <v-col cols="12" class="text-center">
                  <v-btn v-if="showAddHourlyPriceBtn" color="info" class="my-2" @click="addHourlyPrice()">{{
                    $t("custom.add") }}
                    <v-icon class="ml-1">
                      mdi-plus-circle-outline
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="createHourlyPricesInput.hasOwnProperty('season_id')"
                    :disabled="checkHourlyPriceInfo()" color="warning" @click="saveNewHourlyPrices()"
                    class="mt-2 my-2">{{ $t("cars.save_prices")
                    }}<v-icon class="ml-1">
                      mdi-content-save-check-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model.number="car.hourly_deposit" :label="$t('cars.deposit')" class="my-2" dense
                    hide-details outlined></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-divider class="mt-2 mb-4"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h3 class="text-center">{{ $t("bookings.weekly_prices") }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div :class="isMobile ? 'mobile-price-table-wrapper' : ''">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="text-no-wrap">{{ $t("cars.season") }}</th>
                          <th v-for="period in periodsWeekly" :key="period.index" class="text-left text-no-wrap">
                            {{ period }} {{ $tc("bookings.weeks_plural", periodUpperBound(period)) }}
                          </th>
                          <th class="text-no-wrap">
                            {{
                              periodsWeekly[periodsWeekly.length - 1]
                                ? periodsWeekly[periodsWeekly.length - 1].split(" - ")[1]
                                : ""
                            }}
                            +
                            {{ $t("bookings.weeks") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(price, index) in car.weekly_prices" :key="price.index">
                          <td v-if="price.id" class="text-no-wrap">
                            <v-text-field readonly dense :value="getSeasonValue(price.season_id)"
                              :label="$t('cars.select_season')" hide-details></v-text-field>
                          </td>
                          <td v-else class="text-no-wrap">
                            <v-select :items="select_seasons" item-text="value" item-value="season_id"
                              :label="$t('cars.select_season')" v-model="createWeeklyPricesInput.season_id"
                              hide-details dense></v-select>
                          </td>
                          <td v-for="(value, value_index) in car.weekly_prices[index]
                            .values" :key="value.index" class="text-no-wrap">
                            <v-text-field v-if="value > 0" readonly dense type="number" :value="value" hide-details
                              @click="showNewWeeklyPrice(price, value_index)"></v-text-field>
                            <v-text-field v-else v-model.number="createWeeklyPricesInput[value_index]" type="number"
                              :value="value" dense hide-details></v-text-field>
                          </td>
                          <td class="d-flex">
                            <v-icon v-if="price.audits && price.audits.length > 0" class="mr-2"
                              @click="showAudits(price)">
                              mdi-diversify
                            </v-icon>
                            <v-icon v-if="price.id && price.season_id" class="error--text" @click="removeSeasonWeeklyPrices(price)">
                              mdi-delete
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="car && car.weekly_prices.length <= seasons.length + 1">
                <v-col cols="12" class="text-center">
                  <v-btn v-if="showAddWeeklyPriceBtn" color="info" class="my-2" @click="addWeeklyPrice()">{{
                    $t("custom.add") }}
                    <v-icon class="ml-1">
                      mdi-plus-circle-outline
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="createWeeklyPricesInput.hasOwnProperty('season_id')"
                    :disabled="checkWeeklyPriceInfo()" color="warning" @click="saveNewWeeklyPrices()"
                    class="mt-2 my-2">{{ $t("cars.save_prices")
                    }}<v-icon class="ml-1">
                      mdi-content-save-check-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model.number="car.weekly_deposit" :label="$t('cars.deposit')" class="my-2" dense
                    hide-details outlined></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-divider class="mt-2 mb-4"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h3 class="text-center">{{ $t("bookings.monthly_prices") }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div :class="isMobile ? 'mobile-price-table-wrapper' : ''">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="text-no-wrap">{{ $t("cars.season") }}</th>
                          <th v-for="period in periodsMonthly" :key="period.index" class="text-left text-no-wrap">
                            {{ period }} {{ $tc("bookings.months_plural", periodUpperBound(period)) }}
                          </th>
                          <th class="text-no-wrap">
                            {{
                              periodsMonthly[periodsMonthly.length - 1]
                                ? periodsMonthly[periodsMonthly.length - 1].split(" - ")[1]
                                : ""
                            }}
                            +
                            {{ $t("bookings.months") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(price, index) in car.monthly_prices" :key="price.index">
                          <td v-if="price.id" class="text-no-wrap">
                            <v-text-field readonly dense :value="getSeasonValue(price.season_id)"
                              :label="$t('cars.select_season')" hide-details></v-text-field>
                          </td>
                          <td v-else class="text-no-wrap">
                            <v-select :items="select_seasons" item-text="value" item-value="season_id"
                              :label="$t('cars.select_season')" v-model="createMonthlyPricesInput.season_id"
                              hide-details dense></v-select>
                          </td>
                          <td v-for="(value, value_index) in car.monthly_prices[index]
                            .values" :key="value.index" class="text-no-wrap">
                            <v-text-field v-if="value > 0" readonly dense type="number" :value="value" hide-details
                              @click="showNewMonthlyPrice(price, value_index)"></v-text-field>
                            <v-text-field v-else v-model.number="createMonthlyPricesInput[value_index]" type="number"
                              :value="value" dense hide-details></v-text-field>
                          </td>
                          <td class="d-flex">
                            <v-icon v-if="price.audits && price.audits.length > 0" class="mr-2"
                              @click="showAudits(price)">
                              mdi-diversify
                            </v-icon>
                            <v-icon v-if="price.id && price.season_id" class="error--text" @click="removeSeasonMonthlyPrices(price)">
                              mdi-delete
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="car && car.monthly_prices.length <= seasons.length + 1">
                <v-col cols="12" class="text-center">
                  <v-btn v-if="showAddMonthlyPriceBtn" color="info" class="my-2" @click="addMonthlyPrice()">{{
                    $t("custom.add") }}
                    <v-icon class="ml-1">
                      mdi-plus-circle-outline
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="createMonthlyPricesInput.hasOwnProperty('season_id')"
                    :disabled="checkMonthlyPriceInfo()" color="warning" @click="saveNewMonthlyPrices()"
                    class="mt-2 my-2">{{ $t("cars.save_prices")
                    }}<v-icon class="ml-1">
                      mdi-content-save-check-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model.number="car.monthly_deposit" :label="$t('cars.deposit')" class="my-2" dense
                    hide-details outlined></v-text-field>
                </v-col>
              </v-row>
              <!-- FT-216 REQ-02, REQ-15: настройки машины в динамическом ценообразовании; блок приходит только
                   superadmin/admin и только при услуге в плане — иначе панели нет. Сохраняется сразу, своим запросом. -->
              <car-pricing-limits-panel v-if="dynamic_pricing_state" :car-id="car.id" :state="dynamic_pricing_state"
                @update:state="dynamic_pricing_state = $event" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="editSave()" :block="isMobile ? true : false"
                  :loading="isLoadingEditSave">
                  {{ $t("custom.save") }}
                  <v-icon class="ml-1" v-if="!isLoadingEditSave">
                    mdi-content-save-check-outline
                  </v-icon>
                  <v-icon v-else>
                    mdi-loading
                  </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-card-text>
                <v-flex md12>
                  <v-expansion-panels v-model="copyPricesPanel">
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <h4 class="mb-0 d-flex">
                          {{ $t("cars.copy_prices") }}
                        </h4>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-flex md12 :class="isMobile ? '' : 'd-flex align-middle'">
                          <v-autocomplete v-model="copy_prices_cars"
                            :item-text="item => `${item.car_name} - ${item.code}`" item-value="id" text hide-no-data
                            hide-details outlined dense multiple clearable :label="$t('cars.copy_prices_placeholder')"
                            :items="cars">
                          </v-autocomplete>
                          <v-btn color="success" @click="copyPrices()" :class="isMobile ? 'mt-2' : 'ml-2'"
                            :block="isMobile ? true : false">
                            {{ $t("cars.copy_prices") }}
                            <v-icon class="ml-1">
                              mdi-content-save-check-outline
                            </v-icon>
                          </v-btn>
                        </v-flex>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Обслуживание 3-->
          <v-tab-item :disabled="!partner_can_view_maintenances">
            <v-card flat v-if="partner_can_view_maintenances">
              <v-card-text>
                <v-layout row wrap class="mt-1">
                  <v-flex xs12 sm5 md5>
                    <v-text-field v-model.number="car.start_mileage" class="mx-1 mb-2" :label="$t('cars.start_mileage')"
                      dense hide-details outlined></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5 md5>
                    <v-text-field v-model.number="car.mileage" class="mx-1 mb-2" :label="$t('cars.mileage')" dense
                      hide-details outlined></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2 md2 class="text-center">
                    <v-btn color="success" @click="editSave()" :loading="isLoadingEditSave">
                      {{ $t("custom.save") }}
                      <v-icon class="ml-1" v-if="!isLoadingEditSave">
                        mdi-content-save-check-outline
                      </v-icon>
                      <v-icon v-else>
                        mdi-loading
                      </v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex md12>
                    <v-divider class="mt-2 mb-4"></v-divider>
                  </v-flex>
                  <v-flex md12>
                    <v-flex md12 class="d-flex align-middle">
                      <h2 class="my-2">{{ $t("maintenance.current_maintenance") }}</h2>
                      <v-btn icon color="success"
                        @click="getWorkersNames(), showNewMaintenanceDialog = true, maintenance.last_maintenanced_mileage = car.mileage">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-data-table :headers="maintenance_headers" :loading="isLoading"
                      :loading-text="$t('custom.loading_table')" :items="maintenance_items" :search="search_maintenance"
                      sort-by="id" sort-desc item-key="id" mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'"
                      dense :items-per-page="50" :footer-props="tableFooterProps([20, 50, 100, -1])">
                      <template slot="item" slot-scope="props">
                        <tr :class="selectCriticalityClass(props.item.criticality)">
                          <td class="text-center" :key="props.item.id">
                            <v-icon v-if="props.item.periodic" color="white">
                              mdi-infinity
                            </v-icon>
                            <v-icon v-else color="white">
                              mdi-repeat-once
                            </v-icon>
                          </td>
                          <td class="text-center" nowrap>
                            {{ formatDate(props.item.date_start) }}
                          </td>
                          <td class="text-center">
                            {{ props.item.title }}
                          </td>
                          <td class="text-center">
                            {{ props.item.description }}
                          </td>
                          <td class="text-center">
                            {{ props.item.maintenance_type == 0 ? props.item.mileage_step : props.item.days_step }}
                          </td>
                          <td class="text-center">
                            {{ selectLastMaintenance(props.item.last_maintenanced_date,
                              props.item.last_maintenanced_mileage) }}
                          </td>
                          <td class="text-center">
                            {{ findWorkersName(props.item.responsible) }}
                          </td>
                          <td class="text-center" nowrap>
                            <v-btn v-if="props.item.date_start && props.item.id && props.item.maintenance_type != 4"
                              icon color="success"
                              @click="maintenance = props.item, showEndMaintenanceDialog = true, maintenance.last_maintenanced_mileage = car.mileage">
                              <v-icon>mdi-check-all</v-icon>
                            </v-btn>
                            <v-btn v-if="props.item.id" icon
                              @click="maintenance = props.item, showEditMaintenanceDialog = true">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn v-if="props.item.id" icon :color="props.item.criticality == 2 ? 'white' : 'error'"
                              @click="deleteMaintenance(props.item.id)">
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <template slot="no-data">
                        {{ $t("custom.no_data_in_table") }}
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                        {{ $t("tables.no_search_result", { msg: search_maintenance }) }}
                      </v-alert>
                    </v-data-table>
                  </v-flex>
                  <v-flex md12>
                    <v-flex md12 class="d-flex align-middle">
                      <h2 class="my-2">{{ $t("maintenance.not_started_maintenance") }}</h2>
                      <v-btn icon color="success"
                        @click="getWorkersNames(), showNewMaintenanceDialog = true, maintenance.last_maintenanced_mileage = car.mileage">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-data-table :headers="maintenance_not_started_headers" :loading="isLoading"
                      :loading-text="$t('custom.loading_table')" :items="not_started_maintenance_items"
                      :search="search_not_started_maintenance" sort-by="id" sort-desc item-key="id"
                      mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'" dense :items-per-page="50"
                      :footer-props="tableFooterProps([20, 50, 100, -1])">
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td class="text-center" :key="props.item.id">
                            {{ formatDate(props.item.date_start) }}
                          </td>
                          <td class="text-center">
                            {{ props.item.title }}
                          </td>
                          <td class="text-center">
                            {{ props.item.description }}
                          </td>
                          <td class="text-center">
                            {{ props.item.maintenance_type == 0 ? props.item.mileage_step : props.item.days_step }}
                          </td>
                          <td class="text-center">
                            {{ selectLastMaintenance(props.item.last_maintenanced_date,
                              props.item.last_maintenanced_mileage) }}
                          </td>
                          <td class="text-center">
                            {{ findWorkersName(props.item.responsible) }}
                          </td>
                          <td class="text-center">
                            <v-btn v-if="props.item.date_start && props.item.id && props.item.maintenance_type != 4"
                              icon color="success"
                              @click="maintenance = props.item, showEndMaintenanceDialog = true, maintenance.last_maintenanced_mileage = car.mileage">
                              <v-icon>mdi-check-all</v-icon>
                            </v-btn>
                            <v-btn v-if="props.item.id" icon
                              @click="maintenance = props.item, showEditMaintenanceDialog = true">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn v-if="props.item.id" icon color="error" @click="deleteMaintenance(props.item.id)">
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <template slot="no-data">
                        {{ $t("custom.no_data_in_table") }}
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                        {{ $t("tables.no_search_result", { msg: search_not_started_maintenance }) }}
                      </v-alert>
                    </v-data-table>
                  </v-flex>
                  <v-flex md12>
                    <v-flex md12 class="d-flex align-middle">
                      <h2 class="my-2">{{ $t("maintenance.completed_maintenance") }}</h2>
                    </v-flex>
                    <v-data-table :headers="maintenance_completed_headers" :loading="isLoading"
                      :loading-text="$t('custom.loading_table')" :items="maintenance_completed_items"
                      :search="search_completed_maintenance" sort-by="id" sort-desc item-key="id"
                      mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'" dense :items-per-page="50"
                      :footer-props="tableFooterProps([20, 50, 100, -1])">
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td class="text-center" :key="props.item.id">
                            <v-icon v-if="props.item.periodic" color="indigo">
                              mdi-infinity
                            </v-icon>
                            <v-icon v-else color="indigo">
                              mdi-face-man-outline
                            </v-icon>
                          </td>
                          <td class="text-center">
                            {{ formatDate(props.item.date_start) }}
                          </td>
                          <td class="text-center">
                            {{ formatDate(props.item.date_completed) }}
                          </td>
                          <td class="text-center">
                            {{ props.item.title }}
                          </td>
                          <td class="text-center">
                            {{ props.item.description }}
                          </td>
                          <td class="text-center">
                            {{ props.item.maintenance_type == 0 ? props.item.mileage_step : props.item.days_step }}
                          </td>
                          <td class="text-center">
                            {{ props.item.mileage_completed }}
                          </td>
                          <td class="text-center">
                            <router-link v-if="props.item.contractor_id" :to="{
                              name: 'Contractor',
                              params: { id: props.item.contractor_id },
                            }">
                              {{ findContractorName(props.item.contractor_id) }}
                            </router-link>
                            <span v-else> - </span>
                          </td>
                          <td class="text-center">
                            {{ findWorkersName([props.item.whois_ended]) }}
                          </td>
                          <td class="text-center">
                            <v-btn v-if="props.item.id" icon color="error" @click="deleteMaintenance(props.item.id)">
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <template slot="no-data">
                        {{ $t("custom.no_data_in_table") }}
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                        {{ $t("tables.no_search_result", { msg: search_completed_maintenance }) }}
                      </v-alert>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Файлы 4-->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-expansion-panels v-model="filesPanel">
                  <!-- Файлы авто -->
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      {{ $t('custom.files') }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <gallery @updateSortCarsFiles="updateSortCarsFiles" :documents="cars_files"></gallery>
                        </v-col>
                        <v-col cols="12">
                          <uppy @updateCarsFiles="updateCarsFiles" :max-file-size-in-bytes="50000000" :width="'100%'"
                            :height="250" :theme="$vuetify.theme.dark ? 'dark' : 'light'"></uppy>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- Шаблон договора с физ -->
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      {{ $t("cars.upload_uniq_doc_fiz") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-btn small v-if="cars_doc_template_id" text :href="cars_doc_template_url" target="_blank">
                            {{ $t("other.download_car_doc_fiz") }}
                          </v-btn>
                          <v-icon v-if="cars_doc_template_id" @click="deleteCarDoc(cars_doc_template_id)"
                            color="red darken-2" v-tooltip="{
                              content: $t('tooltips.remove_car_doc_fiz'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">mdi-delete-forever</v-icon>
                          <h4 v-else class="mt-2 text-center">
                            {{ $t("cars.no_uniq_doc_fiz") }}
                          </h4>
                        </v-col>
                        <v-col cols="12">
                          <uppy-cars-doc :max-file-size-in-bytes="50000000" width="100%" height="250px"
                            :theme="$vuetify.theme.dark ? 'dark' : 'light'"></uppy-cars-doc>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- Шаблон договора с юр -->
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      {{ $t("cars.upload_uniq_doc_ur") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12">
                          <v-btn small v-if="cars_entity_doc_template_id" text :href="cars_entity_doc_template_url"
                            target="_blank">
                            {{ $t("cars.download_uniq_doc_ur") }}
                          </v-btn>
                          <v-icon v-if="cars_entity_doc_template_id"
                            @click="deleteCarEntityDoc(cars_entity_doc_template_id)" color="red darken-2" v-tooltip="{
                              content: this.$t('tooltips.remove_car_doc_ur'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">mdi-delete-forever</v-icon>
                          <h4 v-else class="mt-2 text-center">
                            {{ $t("cars.no_uniq_doc_ur") }}
                          </h4>
                        </v-col>
                        <v-col cols="12">
                          <uppy-cars-entity-doc :max-file-size-in-bytes="50000000" width="100%" height="250px"
                            :theme="$vuetify.theme.dark ? 'dark' : 'light'"></uppy-cars-entity-doc>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Аналитика 5-->
          <v-tab-item v-if="isAdminPlus ||
            isPartner || isGuest
          " :disabled="!partner_can_view_booking_card">
            <v-card flat v-if="partner_can_view_booking_card">
              <v-toolbar :height="toolbar_height" :color="$vuetify.theme.dark ? 'pt-1' : 'white pt-1'">
                <v-row align="center">
                  <v-col cols="12" lg="6" md="6" sm="12" xs="12">
                    <v-menu v-model="start_date_menu" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="start_date_format" :label="$t('custom.start_period')" readonly
                          v-bind="attrs" v-on="on" hide-details class=""></v-text-field>
                      </template>
                      <v-date-picker v-model="start_date" :locale="$i18n.locale" @input="start_date_menu = false"
                        first-day-of-week="1"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12" xs="12">
                    <v-menu v-model="end_date_menu" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="end_date_format" :label="$t('custom.end_period')" readonly v-bind="attrs"
                          v-on="on" hide-details class=""></v-text-field>
                      </template>
                      <v-date-picker v-model="end_date" :locale="$i18n.locale" @input="end_date_menu = false"
                        first-day-of-week="1"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-toolbar>
              <v-card-text>
                <v-container>
                  <v-layout row wrap>
                    <v-flex md12>
                      <Doughnut :chart-options="chartOptionsExpences" :chart-data="chartDataExpences" :height="300" />
                    </v-flex>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <h2>
                            {{ $t("analitics.finance_indicators") }}
                          </h2>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content v-if="analitics_data.loading_percentage > 0">
                          <v-simple-table dense>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">
                                    {{ $t("custom.item") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("custom.value") }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.profit_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ $t("analitics.profit") }}
                                  </td>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.profit_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ analitics_data.profit }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.average_profit_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ $t("analitics.average_profit") }}
                                  </td>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.average_profit_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ analitics_data.average_profit
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.average_month_profit_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ $t("analitics.average_month_profit") }}
                                  </td>
                                  <td v-if="analitics_data.work_days > 0" class="text-left" v-tooltip="{
                                    content: $t('analitics.average_month_profit_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{
                                      parseInt(
                                        analitics_data.average_profit /
                                        (analitics_data.work_days / 30)
                                      )
                                    }}
                                  </td>
                                  <td v-else>-</td>
                                </tr>
                                <tr>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.investment_100k_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ $t("analitics.investment_100k") }}
                                  </td>
                                  <td v-if="analitics_data.work_days > 0 && car.purchase_price > 0" class="text-left"
                                    v-tooltip="{
                                      content: $t('analitics.investment_100k_tooltip'),
                                      placement: 'top-center',
                                      classes: ['info'],
                                      targetClasses: ['it-has-a-tooltip'],
                                      delay: {
                                        show: 500,
                                        hide: 500,
                                      },
                                    }">
                                    {{
                                      parseFloat(
                                        ((analitics_data.average_profit /
                                          (analitics_data.work_days / 30)) *
                                          12 /
                                          car.purchase_price) *
                                        100
                                      ).toFixed(2)
                                    }}%
                                  </td>
                                  <td v-else>-</td>
                                </tr>
                                <tr>
                                  <td>{{ $t("analitics.work_days") }}</td>
                                  <td>{{ analitics_data.work_days }}</td>
                                </tr>
                                <tr>
                                  <td>{{ $t("analitics.days_in_rent") }}</td>
                                  <td>{{ analitics_data.bookings_days }}</td>
                                </tr>
                                <tr>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.percent_loading_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ $t("analitics.percent_loading") }}
                                  </td>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.percent_loading_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ analitics_data.loading_percentage }}%
                                  </td>
                                </tr>
                                <tr>
                                  <td>{{ $t("analitics.bookings_mileage") }}</td>
                                  <td>
                                    {{ analitics_data.bookings_mileage }}
                                    {{ $t("custom.km") }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {{ $t("analitics.average_month_mileage") }}
                                  </td>
                                  <td v-if="analitics_data.work_days > 0">
                                    {{
                                      parseInt(
                                        analitics_data.bookings_mileage /
                                        (analitics_data.work_days / 30)
                                      )
                                    }}
                                    {{ $t("custom.km") }}
                                  </td>
                                  <td v-else>-</td>
                                </tr>
                                <tr>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.km_cost_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ $t("analitics.km_cost") }}
                                  </td>
                                  <td v-if="analitics_data.work_days > 0 &&
                                    analitics_data.bookings_mileage > 0
                                  " v-tooltip="{
                                    content: $t('analitics.km_cost_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{
                                      (analitics_data.expences_rub /
                                        analitics_data.bookings_mileage).toFixed(2)
                                    }}
                                  </td>
                                  <td v-else>-</td>
                                </tr>
                                <tr>
                                  <td class="text-left" v-tooltip="{
                                    content: $t('analitics.km_income_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{ $t("analitics.km_income") }}
                                  </td>
                                  <td v-if="analitics_data.bookings_mileage > 0" v-tooltip="{
                                    content: $t('analitics.km_income_tooltip'),
                                    placement: 'top-center',
                                    classes: ['info'],
                                    targetClasses: ['it-has-a-tooltip'],
                                    delay: {
                                      show: 500,
                                      hide: 500,
                                    },
                                  }">
                                    {{
                                      (
                                        analitics_data.average_profit /
                                        analitics_data.bookings_mileage
                                      ).toFixed(2)
                                    }}
                                  </td>
                                  <td v-else>-</td>
                                </tr>
                                <tr>
                                  <td>{{ $t("analitics.average_count") }}</td>
                                  <td>
                                    {{
                                      Math.floor(
                                        analitics_data.bookings_average_cost
                                      )
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>{{ $t("analitics.with_car") }}</td>
                                  <td v-if="car.purchase_price > 0 && car.sale_price > 0
                                  ">
                                    {{
                                      analitics_data.profit -
                                      car.purchase_price +
                                      car.sale_price
                                    }}
                                  </td>
                                  <td v-else>-</td>
                                </tr>
                                <tr>
                                  <td>{{ $t("analitics.with_car_km") }}</td>
                                  <td v-if="car.purchase_price > 0 &&
                                    car.sale_price > 0 &&
                                    analitics_data.bookings_mileage > 0
                                  ">
                                    {{
                                      (analitics_data.profit -
                                        car.purchase_price +
                                        car.sale_price) /
                                      analitics_data.bookings_mileage
                                    }}
                                  </td>
                                  <td v-else>-</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <h2>
                            {{ $t("custom.income") }}
                            <span v-if="analitics_data.income_rub &&
                              analitics_data.income_rub > 0
                            ">: {{ Math.floor(analitics_data.income_rub)
                              }}</span>
                          </h2>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-flex md12>
                            <v-card>
                              <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search_income" append-icon="mdi-magnify"
                                  :label="$t('custom.search')" single-line clearable hide-details></v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn small color="success" to="/counts/new">{{
                                  $t("counts.add_count")
                                  }}</v-btn>
                              </v-toolbar>
                              <v-data-table :headers="headers_counts" :items="analitics_data.income_counts"
                                :loading="isLoading" :loading-text="$t('custom.loading_table')" :search="search_income"
                                :items-per-page="20" :sort-by="['created_at']" :sort-desc="[true]"
                                :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([20, 50, 100, -1])" mobile-breakpoint="100" dense>
                                <template slot="item" slot-scope="props">
                                  <tr :class="props.item.operation && props.item.sum < 0
                                    ? 'red--text'
                                    : ''
                                    ">
                                    <td class="text-center">
                                      {{ props.item.id }}
                                    </td>
                                    <td class="text-center">
                                      {{ props.item.company_id }}
                                    </td>
                                    <td class="text-center">
                                      {{ returnDate(props.item.created_at) }}
                                    </td>
                                    <td class="text-center">
                                      {{ translateCategory(props.item.group) }}
                                    </td>
                                    <td class="text-center">
                                      {{ props.item.description }}
                                    </td>
                                    <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                                      {{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}
                                      <span
                                        v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                                        ({{ props.item.rated_sum }})
                                      </span>
                                    </td>
                                    <td v-else class="text-center">
                                      {{ props.item.sum }}{{ currency }}
                                    </td>
                                    <td class="text-center" v-if="props.item.operation">
                                      <v-icon class="text-center" style="color: green">
                                        mdi-plus-circle-outline
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="!props.item.operation">
                                      <v-icon class="text-center" style="color: tomato">
                                        mdi-minus-circle-outline
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.cash">
                                      <v-icon class="text-center" color="success">
                                        mdi-cash
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.cashless">
                                      <v-icon class="text-center" color="warning">
                                        mdi-contactless-payment-circle-outline
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.entity">
                                      <v-icon class="text-center" color="secondery">
                                        mdi-bank
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.cash_card">
                                      <v-icon class="text-center" color="success">
                                        mdi-credit-card-check-outline
                                      </v-icon>
                                    </td>
                                  </tr>
                                </template>
                                <template slot="no-data">
                                  {{ $t("custom.no_data_in_table") }}
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                                  {{
                                    $t("tables.no_search_result", {
                                      msg: search_income,
                                    })
                                  }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <h2>
                            {{ $t("custom.expences") }}
                            <span v-if="analitics_data.expences_rub &&
                              analitics_data.expences_rub > 0
                            ">: {{ Math.floor(analitics_data.expences_rub)
                              }}</span>
                          </h2>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-flex md12>
                            <v-card>
                              <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search_expences" append-icon="mdi-magnify"
                                  :label="$t('custom.search')" single-line clearable hide-details></v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn small color="success" to="/counts/new">{{
                                  $t("counts.add_count")
                                  }}</v-btn>
                              </v-toolbar>
                              <v-data-table :headers="headers_counts" :items="analitics_data.expences_counts"
                                :loading="isLoading" :loading-text="$t('custom.loading_table')"
                                :search="search_expences" :items-per-page="20" :sort-by="['created_at']"
                                :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'" :footer-props="tableFooterProps([20, 50, 100, -1])" mobile-breakpoint="100" dense>
                                <template slot="item" slot-scope="props">
                                  <tr :class="props.item.operation && props.item.sum < 0
                                    ? 'red--text'
                                    : ''
                                    ">
                                    <td class="text-center">
                                      {{ props.item.id }}
                                    </td>
                                    <td class="text-center">
                                      {{ props.item.company_id }}
                                    </td>
                                    <td class="text-center">
                                      {{ returnDate(props.item.created_at) }}
                                    </td>
                                    <td class="text-center">
                                      {{ translateCategory(props.item.group) }}
                                    </td>
                                    <td class="text-center">
                                      {{ props.item.description }}
                                    </td>
                                    <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                                      {{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}
                                      <span
                                        v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                                        ({{ props.item.rated_sum }})
                                      </span>
                                    </td>
                                    <td v-else class="text-center">
                                      {{ props.item.sum }}{{ currency }}
                                    </td>
                                    <td class="text-center" v-if="props.item.operation">
                                      <v-icon class="text-center" style="color: green">
                                        mdi-plus-circle-outline
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="!props.item.operation">
                                      <v-icon class="text-center" style="color: tomato">
                                        mdi-minus-circle-outline
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.cash">
                                      <v-icon class="text-center" color="success">
                                        mdi-cash
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.cashless">
                                      <v-icon class="text-center" color="warning">
                                        mdi-contactless-payment-circle-outline
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.entity">
                                      <v-icon class="text-center" color="secondery">
                                        mdi-bank
                                      </v-icon>
                                    </td>
                                    <td class="text-center" v-if="props.item.cash_card">
                                      <v-icon class="text-center" color="success">
                                        mdi-credit-card-check-outline
                                      </v-icon>
                                    </td>
                                  </tr>
                                </template>
                                <template slot="no-data">
                                  {{ $t("custom.no_data_in_table") }}
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                                  {{
                                    $t("tables.no_search_result", {
                                      msg: search_expences,
                                    })
                                  }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <h2>
                            {{ $t("custom.grouped_data") }}
                          </h2>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols="12" sm="12" md="12" lg="12">
                              <v-list dense>
                                <v-list-item v-for="(key, index) in summary_groups" :key="index">
                                  <v-list-item-content>
                                    {{ key.text }}:
                                  </v-list-item-content>
                                  <v-list-item-content>
                                    {{ countsByKey(full_counts, key.value) }}
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-else>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-card-text>
                    <v-flex md12>
                      <v-card>
                        <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
                          <v-spacer></v-spacer>
                          <v-text-field v-model="search_expences" append-icon="mdi-magnify" :label="$t('custom.search')"
                            single-line clearable hide-details></v-text-field>
                          <v-spacer></v-spacer>
                          <v-btn small color="success" to="/counts/new">{{
                            $t("counts.add_count")
                            }}</v-btn>
                        </v-toolbar>
                        <v-data-table :headers="headers_counts" :items="expences_counts" :search="search_expences"
                          :loading="isLoading" :loading-text="$t('custom.loading_table')" :items-per-page="20"
                          :sort-by="['created_at']" :sort-desc="[true]" :class="!isMobile ? '' : 'is-mobile'"
                          :footer-props="tableFooterProps([20, 50, 100, -1])" mobile-breakpoint="100" dense>
                          <template slot="item" slot-scope="props">
                            <tr :class="props.item.operation && props.item.sum < 0
                              ? 'red--text'
                              : ''
                              ">
                              <td class="text-center">{{ props.item.id }}</td>
                              <td class="text-center">
                                {{ props.item.company_id }}
                              </td>
                              <td class="text-center">
                                {{ returnDate(props.item.created_at) }}
                              </td>
                              <td class="text-center">
                                {{ translateCategory(props.item.group) }}
                              </td>
                              <td class="text-center">
                                {{ props.item.description }}
                              </td>
                              <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                                {{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}
                                <span
                                  v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                                  ({{ props.item.rated_sum }})
                                </span>
                              </td>
                              <td v-else class="text-center">
                                {{ props.item.sum }}{{ currency }}
                              </td>
                              <td class="text-center" v-if="props.item.operation">
                                <v-icon class="text-center" style="color: green">
                                  mdi-plus-circle-outline
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="!props.item.operation">
                                <v-icon class="text-center" style="color: tomato">
                                  mdi-minus-circle-outline
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="props.item.cash">
                                <v-icon class="text-center" color="success">
                                  mdi-cash
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="props.item.cashless">
                                <v-icon class="text-center" color="warning">
                                  mdi-contactless-payment-circle-outline
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="props.item.entity">
                                <v-icon class="text-center" color="secondery">
                                  mdi-bank
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="props.item.cash_card">
                                <v-icon class="text-center" color="success">
                                  mdi-credit-card-check-outline
                                </v-icon>
                              </td>
                            </tr>
                          </template>
                          <template slot="no-data">
                            {{ $t("custom.no_data_in_table") }}
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                            {{
                              $t("tables.no_search_result", {
                                msg: search_expences,
                              })
                            }}
                          </v-alert>
                        </v-data-table>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ТО 6-->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-card-text>
                    <v-layout justify-center>
                      <v-data-table :headers="inspections_headers" :items="inspections" :search="search_inspections"
                        :loading="isLoading" :loading-text="$t('custom.loading_table')" sort-by="id" :sort-desc="true"
                        item-key="id" :items-per-page="10" mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'"
                        dense :footer-props="tableFooterProps([20, 50, 100, -1])">
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td class="text-center" :key="props.item.id" nowrap>
                              {{ returnDate(props.item.date) }}
                            </td>
                            <td class="text-center">
                              {{ setWorker(props.item.worker) }}
                            </td>
                            <td class="text-center">
                              {{ props.item.description }}
                            </td>
                          </tr>
                        </template>
                        <template slot="no-data">
                          {{ $t("custom.no_data_in_table") }}
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                          {{
                            $t("tables.no_search_result", {
                              msg: search_inspections,
                            })
                          }}
                        </v-alert>
                      </v-data-table>
                    </v-layout>
                    <!-- <gallery-checkin v-if="car" :car_id="car.id"></gallery-checkin> -->
                  </v-card-text>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Склад 7-->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t("store.names") }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-flex md12 :class="isMobile
                      ? 'd-flex align-center justify-space-between '
                      : 'd-flex align-center justify-space-start'
                      ">
                      <!-- <v-switch
                        v-model="show_only_in_stock"
                        :class="isMobile ? 'mt-0 ' : 'mt-0 ml-3'"
                        :label="$t('store.in_stock')"
                        dense
                        hide-details
                      ></v-switch> -->
                      <v-text-field v-model="search_store_products" append-icon="mdi-magnify"
                        :label="$t('custom.search')" class="mx-2" single-line clearable hide-details></v-text-field>
                      <v-autocomplete v-model="filter_store_product_group" hide-no-data hide-details
                        :label="$t('store.group_filter')" :items="products_groups" clearable>
                      </v-autocomplete>
                    </v-flex>
                  </v-toolbar-items>
                </v-toolbar>
                <v-data-table :headers="store_products_headers" :items="filter_products_groups()"
                  :search="search_store_products" :loading="isLoading" :loading-text="$t('custom.loading_table')"
                  sort-by="id" :sort-desc="true" item-key="id" :items-per-page="10" mobile-breakpoint="100"
                  :class="!isMobile ? '' : 'is-mobile'" dense :footer-props="tableFooterProps([20, 50, 100, -1])">
                  <template slot="item" slot-scope="props">
                    <tr :class="props.item.stock_balance > 0
                      ? ''
                      : 'grey--text lighten-5'
                      ">
                      <td class="text-center" :key="props.item.id">
                        {{ props.item.id }}
                      </td>
                      <td class="text-center">
                        {{ returnDate(props.item.created_at) }}
                      </td>
                      <td class="text-center">
                        {{ props.item.name }}
                      </td>
                      <td class="text-center">
                        {{ props.item.group }}
                      </td>
                      <td class="text-center">
                        {{ props.item.stock_balance }}
                      </td>
                      <td class="text-center">
                        {{ props.item.avarege_price }}
                      </td>
                      <td class="text-center">
                        {{ props.item.sku }}
                      </td>
                      <td class="text-center">
                        {{ props.item.article }}
                      </td>
                      <td class="text-center">
                        {{ props.item.store_place }}
                      </td>
                    </tr>

                    <tr />
                  </template>
                  <template slot="no-data">
                    {{ $t("custom.no_data_in_table") }}
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                    {{
                      $t("tables.no_search_result", {
                        msg: search_store_products,
                      })
                    }}
                  </v-alert>
                </v-data-table>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t("store.movements") }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-center"></th>
                        <th class="text-center">{{ $t("custom.id") }}</th>
                        <th class="text-center">{{ $t("store.name") }}</th>
                        <th class="text-center">{{ $t("store.article") }}</th>
                        <th class="text-center">{{ $t("store.sku") }}</th>
                        <th class="text-center">{{ $t("custom.date") }}</th>
                        <th class="text-center">{{ $t("store.store") }}</th>
                        <th class="text-center">
                          {{ $t("employers.employee") }}
                        </th>
                        <th class="text-center">{{ $t("store.price") }}</th>
                        <th class="text-center">{{ $t("store.qty") }}</th>
                        <th class="text-center">
                          {{ $t("store.description") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="movement in movements" :key="movement.id">
                        <td class="text-center">
                          <v-icon class="mx-1" color="primary">
                            mdi-arrow-up-bold-box-outline
                          </v-icon>
                        </td>
                        <td class="text-center">
                          {{ movement.id }}
                        </td>
                        <td class="text-center">
                          {{ findStoreProduct(movement.store_product_id) }}
                        </td>
                        <td class="text-center">
                          {{ findProductArticle(movement.store_product_id) }}
                        </td>
                        <td class="text-center">
                          {{ findProductSku(movement.store_product_id) }}
                        </td>
                        <td class="text-center">
                          {{ returnDateTime(movement.created_at) }}
                        </td>
                        <td class="text-center">
                          {{ findStoreLocation(movement.store_location_id) }}
                        </td>
                        <td class="text-center">
                          {{ setWorker(movement.user_id) }}
                        </td>
                        <td class="text-center">
                          {{ movement.price ? movement.price : 0 }}
                        </td>
                        <td class="text-center">
                          {{ movement.quantity }}
                        </td>
                        <td class="text-center">
                          {{ movement.description }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Букинг 8 -->
          <v-tab-item>
            <v-card v-if="isInternal">
              <v-expansion-panels>
                <v-expansion-panel
                  v-if="showCarIntegrations && $store.getters.getCompany.company && $store.getters.getCompany.company.country == 'Russia'">
                  <v-expansion-panel-header>
                    <h4>VseProkaty.ru</h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat
                      v-if="$store.getters.getCompany.company && $store.getters.getCompany.company.in_booking && $store.getters.getCompany.company.agregator_state == 2">
                      <v-card-text>
                        <v-container :style="isMobile ? 'padding: 2px !important;' : ''">
                          <v-layout row wrap>
                            <v-flex v-if="!car.in_agregator && !car.ready_for_agregator" xs12 sm12 md12 class="my-2">
                              <v-alert prominent type="info">
                                <v-row align="center">
                                  <v-col class="grow">
                                    {{ $t("agregator.ready_for_agregator") }}
                                  </v-col>
                                  <v-col class="shrink">
                                    <v-btn color="warning" @click="sendToModeration()">{{
                                      $t("agregator.send_to_moderation")
                                    }}<v-icon class="my-auto">
                                        mdi-car-search-outline
                                      </v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-flex>
                            <v-flex v-if="!car.in_agregator && car.ready_for_agregator" xs12 sm12 md12 class="my-2">
                              <v-alert prominent color="blue-grey" dark icon="mdi-car-search-outline">
                                <v-row align="center">
                                  <v-col class="grow">
                                    {{ $t("agregator.send_to_moderation_success") }}
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-flex>
                            <v-flex v-if="car.in_agregator && !car.ready_for_agregator" xs12 sm12 md12 class="my-2">
                              <v-alert prominent type="success">
                                <v-row align="center">
                                  <v-col class="grow">
                                    {{ $t("agregator.ready_for_agregator") }}
                                  </v-col>
                                  <v-col class="shrink">
                                    <v-btn color="error" @click="withdrawFromPublication()">{{
                                      $t("agregator.withdraw_from_publication")
                                      }}<v-icon class="my-auto"> mdi-car-off </v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-flex>
                            <v-flex xs12 sm12 md12 class="my-2">
                              <gallery-booking></gallery-booking>
                            </v-flex>
                            <v-flex xs12 sm12 md12 class="my-2 d-flex justify-center">
                              <uppy-booking :max-file-size-in-bytes="50000000" :width="isMobile ? 300 : 750"
                                :height="isMobile ? 250 : 250"
                                :theme="$vuetify.theme.dark ? 'dark' : 'light'"></uppy-booking>
                            </v-flex>
                            <v-flex md12 class="my-3 text-center">
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex class="mt-2 text-center">
                              <h3 class="text-center">
                                {{ $t("agregator.insurance") }}
                              </h3>
                            </v-flex>
                            <v-flex xs12 sm12 md12 :class="isMobile ? 'my-2' : 'my-2 d-flex'">
                              <v-flex md4 class="">
                                <v-checkbox v-model="booking_insurance.full.on" :label="$t('agregator.full_insurance')"
                                  class="mt-5 mr-2"></v-checkbox>
                                <v-text-field class="mr-2 my-2" v-model="booking_insurance.full.price"
                                  :label="$t('agregator.full_insurance_price')" type="number" outlined dense
                                  hide-details></v-text-field>
                              </v-flex>
                              <v-flex md4 class="">
                                <v-checkbox v-model="booking_insurance.super_kasko.on"
                                  :label="$t('agregator.super_kasko')" class="mt-5 mr-2"></v-checkbox>
                                <v-text-field class="mr-2 my-2" v-model="booking_insurance.super_kasko.price"
                                  :label="$t('agregator.super_kasko_price')" type="number" outlined dense
                                  hide-details></v-text-field>
                              </v-flex>
                              <v-flex md4 class="">
                                <v-checkbox v-model="booking_insurance.kasko.on" :label="$t('agregator.kasko')"
                                  class="mt-5 mr-2"></v-checkbox>
                                <v-text-field class="mr-2 my-2" v-model="booking_insurance.kasko.price"
                                  :label="$t('agregator.kasko_price')" type="number" outlined dense
                                  hide-details></v-text-field>
                              </v-flex>
                              <v-flex md4 class="">
                                <v-checkbox v-model="booking_insurance.theft.on" :label="$t('agregator.theft')"
                                  class="mt-5 mr-2"></v-checkbox>
                                <v-text-field class="mr-2 my-2" v-model="booking_insurance.theft.price"
                                  :label="$t('agregator.theft_price')" type="number" outlined dense
                                  hide-details></v-text-field>
                              </v-flex>
                              <v-flex md4 class="">
                                <v-checkbox v-model="booking_insurance.osago.on" :label="$t('agregator.osago')"
                                  class="mt-5 mr-2"></v-checkbox>
                                <v-text-field class="mr-2 my-2" value="0" :label="$t('agregator.osago_price')"
                                  type="number" readonly outlined dense hide-details></v-text-field>
                              </v-flex>
                            </v-flex>
                            <v-flex md12>
                              <v-flex class="mt-2 text-center">
                                <v-btn color="success" @click="saveCarBookingSettingInsurance()">{{
                                  $t("agregator.save_car_insurance")
                                  }}<v-icon v-if="!isMobile" class="my-auto">
                                    mdi-content-save-check-outline
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </v-flex>
                            <v-flex md12 class="my-3 text-center">
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex md12 class="mt-2 text-center">
                              <h3 class="text-center">
                                {{ $t("agregator.services") }}
                              </h3>
                            </v-flex>
                            <v-flex :class="isMobile ? 'text-center' : 'd-flex mx-auto'" md12 size="12"
                              v-for="(service, index) in booking_services" :key="index">
                              <v-flex md3>
                                <v-text-field class="mr-2 my-2" :value="findServiceName(service.id)" readonly
                                  :label="$t('agregator.service_name')" outlined dense hide-details></v-text-field>
                              </v-flex>
                              <v-flex md3>
                                <v-text-field class="mr-2 my-2" v-model="service.price"
                                  :label="$t('agregator.service_price')" type="number" outlined dense
                                  hide-details></v-text-field>
                              </v-flex>
                              <v-flex md6 class="d-flex justify-between align-center">
                                <v-switch :label="service.daily
                                  ? $t('agregator.paid_daily_service')
                                  : $t('agregator.paid_once_service')
                                  " dense hide-details v-model="service.daily" class="mx-auto my-auto"></v-switch>
                                <v-switch :label="service.available
                                  ? $t('agregator.available')
                                  : $t('agregator.unavailable')
                                  " dense hide-details v-model="service.available" class="mx-auto my-auto"></v-switch>
                              </v-flex>
                            </v-flex>
                            <v-flex md12>
                              <v-flex class="mt-2 text-center">
                                <v-btn color="success" @click="saveCarBookingSettingServices()">{{
                                  $t("agregator.save_car_services")
                                  }}<v-icon class="my-auto">
                                    mdi-content-save-check-outline
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </v-flex>
                            <v-flex v-if="!isMobile" md12 class="my-3 text-center">
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex md12 class="mt-4 text-center">
                              <h3 class="text-center">
                                {{ $t("agregator.fast_booking") }}
                              </h3>
                            </v-flex>
                            <v-flex md12 size="12">
                              <v-flex md12>
                                <v-switch :label="$t('agregator.fast_booking')" dense hide-details
                                  v-model="fast_booking" @change="saveCarBookingSettingFastBooking()"></v-switch>
                              </v-flex>
                              <v-flex md12>
                                {{ $t("agregator.fast_booking_info") }}
                              </v-flex>
                              <v-flex md12>
                                {{ $t("agregator.fast_booking_pros") }}
                              </v-flex>
                            </v-flex>
                            <v-flex md12 class="my-3 text-center">
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex md12 class="mt-2 text-center">
                              <h3 class="text-center">
                                {{ $t("agregator.description") }}
                              </h3>
                            </v-flex>
                            <v-flex md12 size="12">
                              <v-flex xs12 sm12 md12>
                                <v-textarea v-model="booking_description" :label="$t('agregator.description')"
                                  :placeholder="$t('agregator.description_info')"></v-textarea>
                              </v-flex>
                            </v-flex>
                            <v-flex md12>
                              <v-flex class="mt-2 text-center">
                                <v-btn color="success" @click="saveCarBookingSettingDescription()">{{
                                  $t("agregator.save_description")
                                  }}<v-icon class="my-auto">
                                    mdi-content-save-check-outline
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                    <v-card flat v-else>
                      <v-card-text>
                        <v-container :style="isMobile ? 'padding: 2px !important;' : ''">
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12 class="my-2">
                              <v-alert prominent type="info">
                                <v-row align="center">
                                  <v-col
                                    v-if="$store.getters.getCompany.company && $store.getters.getCompany.company.agregator_state == 0"
                                    class="grow">
                                    {{ $t("agregator.ready_for_agregator") }}
                                  </v-col>
                                  <v-col
                                    v-if="$store.getters.getCompany.company && $store.getters.getCompany.company.agregator_state == 1"
                                    class="grow">
                                    {{ $t("agregator.send_application_to_agregator_success_text") }}
                                  </v-col>
                                  <v-col
                                    v-if="$store.getters.getCompany.company && $store.getters.getCompany.company.agregator_state == 0"
                                    class="shrink">
                                    <v-btn color="success" @click="showApplicationToBooking()">{{
                                      $t("agregator.send_application_to_agregator")
                                      }}<v-icon class="my-auto">
                                        mdi-car-search-outline
                                      </v-icon>
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-alert>
                              <v-flex class="text-left">
                                <h3>{{ $t("agregator.short_agreement_title") }}</h3>
                                <p v-html="$t('agregator.short_agreement')">
                                </p>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="showCarIntegrations">
                  <v-expansion-panel-header>
                    <h4>Localrent.com</h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-text>
                        <v-flex xs12 sm12 md12 class="my-2 text-center">
                          <v-btn v-if="car.in_localrent" color="warning" @click="publicOnLocalRent(false)">{{
                            $t("agregator.unpublic") }}</v-btn>
                          <v-btn v-else color="success" @click="publicOnLocalRent(true)"
                            :disabled="!company.in_localrent">{{
                              $t("agregator.public")
                            }}</v-btn>
                        </v-flex>
                        <v-flex xs12 sm12 md12 class="my-2">
                          <gallery-booking></gallery-booking>
                        </v-flex>
                        <v-flex xs12 sm12 md12 class="my-2 d-flex justify-center">
                          <uppy-booking :max-file-size-in-bytes="50000000" :width="isMobile ? 300 : 750"
                            :height="isMobile ? 250 : 250"
                            :theme="$vuetify.theme.dark ? 'dark' : 'light'"></uppy-booking>
                        </v-flex>
                        <v-flex md12 class="my-3 text-center">
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex md12 class="my-2 text-center">
                          <h2 class="text-center">
                            {{ $t("agregator.services") }}
                          </h2>
                        </v-flex>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center">
                                  {{ $t("agregator.service_name") }}
                                </th>
                                <th class="text-center">
                                  {{ $t("agregator.quantity_max") }}
                                </th>
                                <th class="text-center">
                                  {{ $t("agregator.total_min") }}
                                </th>
                                <th class="text-center">
                                  {{ $t("agregator.total_max") }}
                                </th>
                                <th class="text-center">
                                  {{ $t("agregator.service_price") }}
                                </th>
                                <th class="text-center">
                                </th>
                                <th class="text-center">
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="extra in existing_extras" :key="extra.id">
                                <td class="">
                                  {{ extra.extra_name }}
                                </td>
                                <td class="text-center">
                                  <v-text-field v-model="extra.quantity_max" @change="createOrUpdateExtra(extra)"
                                    type="number" dense hide-details></v-text-field>
                                </td>
                                <td class="text-center">
                                  <v-text-field v-model="extra.total_min" @change="createOrUpdateExtra(extra)"
                                    type="number" dense hide-details></v-text-field>
                                </td>
                                <td class="text-center">
                                  <v-text-field v-model="extra.total_max" @change="createOrUpdateExtra(extra)"
                                    type="number" dense hide-details></v-text-field>
                                </td>
                                <td class="text-center">
                                  <v-text-field v-model="extra.price" @change="createOrUpdateExtra(extra)" type="number"
                                    dense hide-details></v-text-field>
                                </td>
                                <td class="text-center">
                                  <v-select v-model="extra.rental_type" @change="createOrUpdateExtra(extra)"
                                    :items="extra_rental_types" dense hide-details></v-select>
                                </td>
                                <td class="text-center">
                                  <v-switch v-model="extra.active" @change="createOrUpdateExtra(extra)" class="mx-auto"
                                    :label="$t('agregator.available')" dense hide-details></v-switch>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-tab-item>

          <!-- Вкладка Такси -->
          <v-tab-item v-if="isTaxiMode">
            <v-card flat>
              <v-card-text :style="isMobile ? 'padding: 2px !important;' : ''">
                <TaxiVehicleInfo :car="car" />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Вкладка StarLine -->
          <v-tab-item v-if="isStarlineMode">
            <StarlineTab v-if="providersReady"
              :car="car" 
              :company="company"
              @mileage-updated="updateCarData"
            />
          </v-tab-item>
          
          <!-- Вкладка Wialon -->
          <v-tab-item v-if="isWialonMode">
            <WialonTab v-if="providersReady"
              :car="car"
              @car-updated="updateCarData"
            />
          </v-tab-item>
          
          <!-- Вкладка AutoFon -->
          <v-tab-item v-if="isAutofonMode">
            <AutofonTab v-if="providersReady"
              :car="car"
              @car-updated="updateCarData"
            />
          </v-tab-item>
          
          <!-- Вкладка Traccar -->
          <v-tab-item v-if="isTraccarMode">
            <TraccarTab v-if="providersReady"
              :car="car"
              :company="company"
              @mileage-updated="updateCarData"
            />
          </v-tab-item>
          <v-tab-item v-if="damageControlAvailable">
            <car-passport v-if="tabs === tabNameToIndex.damage_control" :key="car.id" :car="car" :initial-section="passportInitialSection" :initial-entity-id="cardSectionsEntityId" @template-assigned="$set(car, 'damage_control_template_id', $event)" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
    <v-dialog v-model="repair_dialog" :retain-focus="false" persistent fullscreen hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("custom.repair") }}</span>
          <v-icon class="ml-2 green--text" @click="repairSave">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="repair_dialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-form>
              <v-container :style="isMobile ? 'padding: 5px !important;' : ''">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 :class="isMobile ? 'align-center' : 'd-flex align-center'"
                    justify="space-around">
                    <p>{{ $t("cars.repair_what") }}</p>
                    <v-textarea v-model="repair.description" clearable outlined
                      :label="$t('cars.repair_what_desc')"></v-textarea>
                    <v-switch color="red" v-model="repair.warning" :label="$t('cars.repair_warning')"></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="repair_dialog = false">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="repairSave()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="inspection_dialog" :retain-focus="false" persistent max-width="500px"
      transition="dialog-bottom-transition" :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("to.to") }}</span>
          <v-icon class="ml-2 green--text" @click="inspectionSave()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="
            (inspection_dialog = false),
            (inspection_date = null),
            (inspection_date_menu = false),
            (inspection_description = null)
            ">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-form>
              <v-container :style="isMobile ? 'padding: 5px !important;' : ''">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 justify="space-around">
                    <v-menu offset-y :close-on-content-click="false" max-width="252px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-bind="attrs" v-on="on" readonly :dense="isMobile"
                          v-model="inspection_date_format" prepend-icon="mdi-calendar-clock" style="max-width: 240px"
                          :label="$t('to.date')" single-line hide-details></v-text-field>
                      </template>
                      <vc-date-picker v-model="inspection_date" mode="date" :attributes="attrs_calendar"
                        :masks="{ input: 'DD-MM-YYYY' }" :locale="$i18n.locale">
                      </vc-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-textarea v-model="inspection_description" clearable rows="2" auto-grow outlined
                      :label="$t('to.total')"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="
            (inspection_dialog = false),
            (inspection_date = null),
            (inspection_date_menu = false),
            (inspection_description = null)
            ">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="inspectionSave()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="store_place_dialog" :retain-focus="false" max-width="500px" transition="dialog-bottom-transition"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("home.location") }}</span>
          <v-icon class="ml-2 green--text" @click="storePlaceSave()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(store_place_dialog = false), (store_place = null)">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-form>
              <v-container :style="isMobile ? 'padding: 5px !important;' : ''">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 justify="space-around">
                    <v-text-field v-model="store_place" clearable :label="$t('home.location')"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(store_place_dialog = false), (store_place = null)">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="storePlaceSave()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sell_dialog" :retain-focus="false" persistent max-width="800px"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <span class="headline">{{ $t("cars.sell") }}</span>
          <v-icon class="ml-2 green--text" @click="sellSave">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="
            (sell_dialog = false),
            (isLoading = false),
            (sell_info.price = 0),
            (sell_info.date = null),
            (sell_info.cash = false),
            (sell_info.cash_card = false),
            (sell_info.cashless = false),
            (sell_info.entity = false)
            ">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-container>
              <v-layout row wrap>
                <v-flex xs6 sm6 md6 class="d-flex d-inline-flex align-center" justify="space-around">
                  <v-text-field v-model.number="sell_info.price" clearable outlined
                    :label="$t('cars.sell_price')"></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md6 class="d-flex d-inline-flex align-center" justify="space-around">
                  <v-text-field v-model="sell_info.date" type="date" clearable outlined
                    :label="$t('cars.sale_date')"></v-text-field>
                </v-flex>
                <v-flex md12
                  v-if="company && company.multicurrency_cashboxes && company_cashboxes && company_cashboxes.length > 1">
                  <v-select v-model="company_cashbox_id" item-text="name" item-value="id" :items="company_cashboxes"
                    :label="$t('companies.select_cashbox')" hide-no-data hide-details></v-select>
                </v-flex>
                <v-flex md12 v-if="showSelectWorkerCashbox && worker_accounts && worker_accounts.length > 0">
                  <v-select v-model="worker_account_id"
                    :item-text="item => `${item.company_cashbox ? item.company_cashbox.name : null} ${item.currency ? item.currency.code : null} ${item.cash}`"
                    item-value="id" :items="worker_accounts" :label="$t('companies.select_worker_cashbox')" hide-no-data
                    hide-details></v-select>
                </v-flex>
                <v-flex xs12 sm12 md12 class="d-flex align-center justify-space-around">
                  <v-checkbox v-if="company && company.cash_payment" v-model="sell_info.cash" color="success"
                    :disabled="sell_info.cashless || sell_info.cash_card || sell_info.entity"
                    class="mt-0 mr-0" dense hide-details
                    :style="(sell_info.cashless || sell_info.cash_card || sell_info.entity) ? 'opacity: 0.4;' : ''">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="success" v-tooltip="{
                        content: $t('tooltips.cash_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: { show: 500, hide: 500 },
                      }">
                        mdi-cash
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.cashless_payment" v-model="sell_info.cashless" color="warning"
                    :disabled="sell_info.cash || sell_info.cash_card || sell_info.entity"
                    class="mt-0 mr-0" dense hide-details
                    :style="(sell_info.cash || sell_info.cash_card || sell_info.entity) ? 'opacity: 0.4;' : ''">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                        content: $t('tooltips.terminal_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: { show: 500, hide: 500 },
                      }">
                        mdi-contactless-payment-circle-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.card_to_card_payment" v-model="sell_info.cash_card" color="info"
                    :disabled="sell_info.cash || sell_info.cashless || sell_info.entity"
                    class="mt-0 mr-0" dense hide-details
                    :style="(sell_info.cash || sell_info.cashless || sell_info.entity) ? 'opacity: 0.4;' : ''">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="info" v-tooltip="{
                        content: $t('money.card_to_card'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: { show: 500, hide: 500 },
                      }">
                        mdi-credit-card-check-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.entity_payment" v-model="sell_info.entity" color="secondary"
                    :disabled="sell_info.cash || sell_info.cashless || sell_info.cash_card"
                    class="mt-0 mr-0" dense hide-details
                    :style="(sell_info.cash || sell_info.cashless || sell_info.cash_card) ? 'opacity: 0.4;' : ''">
                    <template v-slot:label>
                      <v-icon class="text-center" color="secondary" v-tooltip="{
                        content: $t('tooltips.entity_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: { show: 500, hide: 500 },
                      }">
                        mdi-bank
                      </v-icon>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="
            (sell_dialog = false),
            (isLoading = false),
            (sell_info.price = 0),
            (sell_info.date = null),
            (sell_info.cash = false),
            (sell_info.cash_card = false),
            (sell_info.cashless = false),
            (sell_info.entity = false)
            ">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="sellSave()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_price_dialog" :retain-focus="false" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("cars.change_price") }}</span>
          <v-icon class="ml-2 green--text" @click="saveEditedPrice()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(editedPrice = {}), (edit_price_dialog = false)">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mx-auto" :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12 class="mx-auto">
            <v-text-field v-model.number="editedPrice.value" clearable outlined
              :label="$t('bookings.price')"></v-text-field>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(editedPrice = {}), (edit_price_dialog = false)">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="saveEditedPrice()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_hourly_price_dialog" :retain-focus="false" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("cars.change_price") }}</span>
          <v-icon class="ml-2 green--text" @click="saveEditedHourlyPrice()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(editedHourlyPrice = {}), (edit_hourly_price_dialog = false)">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mx-auto" :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12 class="mx-auto">
            <v-text-field v-model.number="editedHourlyPrice.value" clearable outlined
              :label="$t('bookings.price')"></v-text-field>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(editedHourlyPrice = {}), (edit_hourly_price_dialog = false)">{{ $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveEditedHourlyPrice()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_weekly_price_dialog" :retain-focus="false" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("cars.change_price") }}</span>
          <v-icon class="ml-2 green--text" @click="saveEditedWeeklyPrice()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(editedWeeklyPrice = {}), (edit_weekly_price_dialog = false)">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mx-auto" :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12 class="mx-auto">
            <v-text-field v-model.number="editedWeeklyPrice.value" clearable outlined
              :label="$t('bookings.price')"></v-text-field>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(editedWeeklyPrice = {}), (edit_weekly_price_dialog = false)">{{ $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveEditedWeeklyPrice()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_monthly_price_dialog" :retain-focus="false" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("cars.change_price") }}</span>
          <v-icon class="ml-2 green--text" @click="saveEditedMonthlyPrice()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(editedMonthlyPrice = {}), (edit_monthly_price_dialog = false)">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mx-auto" :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12 class="mx-auto">
            <v-text-field v-model.number="editedMonthlyPrice.value" clearable outlined
              :label="$t('bookings.price')"></v-text-field>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(editedMonthlyPrice = {}), (edit_monthly_price_dialog = false)">{{ $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveEditedMonthlyPrice()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_audited_price_dialog" :retain-focus="false" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("prices_history.prices_history") }}</span>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="(audited_prices = []), (show_audited_price_dialog = false)">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="mx-auto" :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-no-wrap text-center">
                  {{ $t('prices_history.updated') }}
                </th>
                <th class="text-no-wrap text-center">
                  {{ $t('prices_history.updated_by') }}
                </th>
                <th class="text-no-wrap text-center">
                  {{ $t('prices_history.was') }}
                </th>
                <th class="text-no-wrap text-center">
                  {{ $t('prices_history.became') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="price in audited_prices" :key="price.id">
                <td class="text-no-wrap text-center">
                  {{ formatCreatedAt(price.created_at) }}
                </td>
                <td class="text-no-wrap text-center">
                  {{ price.user_id }}
                </td>
                <td v-if="price.audited_changes.values && price.audited_changes.values[0] && price.action == 'create'"
                  class="text-no-wrap text-center">
                  {{ price.audited_changes.values }}
                </td>
                <td v-if="price.audited_changes.values && price.audited_changes.values[0] && price.action != 'create'"
                  class="text-no-wrap text-center">
                  {{ price.audited_changes.values[0] }}
                </td>
                <td v-if="price.audited_changes.values && price.audited_changes.values[1] && price.action == 'create'"
                  class="text-no-wrap text-center">
                  -
                </td>
                <td v-if="price.audited_changes.values && price.audited_changes.values[1] && price.action != 'create'"
                  class="text-no-wrap text-center">
                  {{ price.audited_changes.values[1] }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="(audited_prices = []), (show_audited_price_dialog = false)">{{ $t("custom.close")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showNewMaintenanceDialog" :retain-focus="false" persistent max-width="600px"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("maintenance.new_maintenance") }}
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showNewMaintenanceDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider class="mb-3"></v-divider>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex md12 :class="isMobile ? 'mt-5' : 'd-flex mt-5'">
            <v-flex>
              <v-radio-group v-model="maintenance.periodic">
                <v-radio :label="$t('maintenance.periodic')" :value="true"></v-radio>
                <v-radio :label="$t('maintenance.once')" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="!maintenance.periodic">
              <v-radio-group v-model="maintenance.started">
                <v-radio :label="$t('maintenance.current_maintenance')" :value="true"></v-radio>
                <v-radio :label="$t('maintenance.not_started_maintenance')" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-flex>
          <v-flex md12>
            <v-select v-model="maintenance.maintenance_type" :items="maintenance_types" item-text="text"
              item-value="value" dense outlined :label="$t('maintenance.maintenance_type')"></v-select>
          </v-flex>
          <v-flex md12>
            <v-select v-model="maintenance.criticality" :items="maintenance_criticalities" item-text="text"
              item-value="value" dense outlined :label="$t('maintenance.criticality')"></v-select>
          </v-flex>
          <v-flex md12>
            <v-text-field v-model.trim="maintenance.title" :label="$t('maintenance.title')" outlined
              dense></v-text-field>
          </v-flex>
          <v-flex md12 class="mb-6" v-if="!maintenance.started">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.last_maintenanced_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.last_maintenanced')" outlined hide-details dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.last_maintenanced_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex v-if="showInsurance && maintenance.maintenance_type == 4" md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.next_maintenance_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.next_maintenance_date')" outlined hide-details dense clearable></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.next_maintenance_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale" @dayclick="updateDaysStemp()">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md12 v-if="(!maintenance.started || maintenance.periodic)">
            <v-text-field v-model.trim="maintenance.last_maintenanced_mileage"
              :label="$t('maintenance.last_maintenanced_mileage')" type="number" outlined dense></v-text-field>
          </v-flex>
          <v-flex md12>
            <v-textarea v-model.trim="maintenance.description" :label="$t('maintenance.description')" outlined rows="1"
              auto-grow dense></v-textarea>
          </v-flex>
          <v-flex md12 v-if="maintenance.maintenance_type == 0 && (!maintenance.started || maintenance.periodic)">
            <v-text-field v-model.trim="maintenance.mileage_step" :label="$t('maintenance.mileage_step')" type="number"
              outlined dense></v-text-field>
          </v-flex>
          <v-flex md12 v-if="maintenance.maintenance_type == 1 && (!maintenance.started || maintenance.periodic)">
            <v-text-field v-model="maintenance.days_step" :label="$t('maintenance.days_step')" type="number" outlined
              dense></v-text-field>
          </v-flex>
          <v-flex md12 v-if="(!maintenance.started || maintenance.periodic)">
            <v-text-field v-model="maintenance.notify_before" :label="$t('maintenance.notify_before')" type="number"
              dense outlined></v-text-field>
          </v-flex>
          <v-flex md12 class="d-flex align-middle mb-5">
            <v-autocomplete v-model="maintenance.responsible" item-text="name" item-value="id"
              :loading="isLoadingResponsible" text hide-no-data hide-details outlined dense multiple clearable
              :label="$t('maintenance.responsible')" :items="workers">
            </v-autocomplete>
            <v-btn icon color="success" @click="maintenance.responsible = workers.map((worker) => worker.id)"
              class="ml-2" v-tooltip="{
                content: $t('counts.select_all_groups'),
                placement: 'top-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 1000,
                  hide: 500,
                },
              }">
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNewMaintenanceDialog = false">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn v-if="maintenance.maintenance_type != 4" color="success" @click="saveMaintenance()">{{
            $t("custom.save")
            }}</v-btn>
          <v-btn v-if="showInsurance && maintenance.maintenance_type == 4" color="success" @click="saveInsuranceMaintenance()">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditMaintenanceDialog" :retain-focus="false" persistent max-width="500px"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("maintenance.edit_maintenance") }}
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="closeEditMaintenanceDialog()">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex>
            <v-radio-group v-model="maintenance.started">
              <v-radio :label="$t('maintenance.current_maintenance')" :value="true"
                @change="addStartDateToMaintenance(maintenance)"></v-radio>
              <v-radio :label="$t('maintenance.not_started_maintenance')" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex md12>
            <v-select v-model="maintenance.criticality" :items="maintenance_criticalities" item-text="text"
              item-value="value" dense outlined :label="$t('maintenance.criticality')"></v-select>
          </v-flex>
          <v-flex md12>
            <v-text-field v-model.trim="maintenance.title" :label="$t('maintenance.title')" outlined
              dense></v-text-field>
          </v-flex>
          <v-flex md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.last_maintenanced_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.last_maintenanced')" outlined hide-details dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.last_maintenanced_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex v-if="showInsurance && maintenance.maintenance_type == 4" md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly
                  :value="formatLastMaintenancedDate(maintenance.next_maintenance_date)" :attributes="attrs_calendar"
                  :label="$t('maintenance.next_maintenance_date')" outlined hide-details dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.next_maintenance_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale" @dayclick="updateDaysStemp()">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md12 v-if="maintenance.maintenance_type != 4">
            <v-text-field v-model.trim="maintenance.last_maintenanced_mileage"
              :label="$t('maintenance.last_maintenanced_mileage')" type="number" outlined dense></v-text-field>
          </v-flex>
          <v-flex md12>
            <v-textarea v-model.trim="maintenance.description" :label="$t('maintenance.description')" outlined rows="1"
              auto-grow dense></v-textarea>
          </v-flex>
          <v-flex md12 v-if="maintenance.maintenance_type == 0">
            <v-text-field v-model.trim="maintenance.mileage_step" :label="$t('maintenance.mileage_step')" type="number"
              outlined dense></v-text-field>
          </v-flex>
          <v-flex md12 v-if="maintenance.maintenance_type == 1 || maintenance.maintenance_type == 4">
            <v-text-field v-model="maintenance.days_step" :label="$t('maintenance.days_step')" type="number" outlined
              dense :readonly="maintenance.maintenance_type == 4"></v-text-field>
          </v-flex>
          <v-flex md12>
            <v-text-field v-model="maintenance.notify_before" :label="$t('maintenance.notify_before')" type="number"
              dense outlined></v-text-field>
          </v-flex>
          <v-flex md12 class="d-flex align-middle">
            <v-autocomplete v-model="maintenance.responsible" item-text="name" item-value="id"
              :loading="isLoadingResponsible" text hide-no-data hide-details outlined dense multiple clearable
              :label="$t('maintenance.responsible')" :items="workers">
            </v-autocomplete>
            <v-btn icon color="success" @click="maintenance.responsible = workers.map((worker) => worker.id)"
              class="ml-2" v-tooltip="{
                content: $t('counts.select_all_groups'),
                placement: 'top-center',
                classes: ['info'],
                targetClasses: ['it-has-a-tooltip'],
                delay: {
                  show: 1000,
                  hide: 500,
                },
              }">
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditMaintenanceDialog()">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn color="success" @click="saveEditMaintenance()" :disabled="maintenance.first_notified">{{
            $t("custom.save")
            }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEndMaintenanceDialog" :retain-focus="false" persistent max-width="600px"
      :fullscreen="isMobile ? true : false">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("maintenance.end_maintenance") }}
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showEndMaintenanceDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-flex v-if="showInsurance && maintenance.maintenance_type == 4" md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on" readonly :attributes="attrs_calendar"
                  :value="maintenance.new_date ? formatLastMaintenancedDate(maintenance.new_date) : $t('services.insurance_renew_date')"
                  outlined hide-details clearable dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.new_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <v-flex v-if="showInsurance && maintenance.maintenance_type == 4" md12 class="mb-6">
            <v-menu offset-y :close-on-content-click="false" max-width="252px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" v-on="on"
                  :value="maintenance.last_maintenanced_date ? formatLastMaintenancedDate(maintenance.last_maintenanced_date) : $t('maintenance.last_maintenanced')"
                  :label="$t('maintenance.last_maintenanced')" :attributes="attrs_calendar" outlined hide-details
                  dense></v-text-field>
              </template>
              <vc-date-picker v-model="maintenance.last_maintenanced_date" mode="date" :masks="{ input: 'YYYY-MM-DD' }"
                :locale="$i18n.locale">
              </vc-date-picker>
            </v-menu>
          </v-flex>
          <!-- <v-flex md12>
            <v-text-field
              v-model.trim="maintenance.last_maintenanced_mileage"
              :label="$t('maintenance.last_maintenanced_mileage')"
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-flex> -->
          <v-flex md12 class="mb-5">
            <v-autocomplete v-model="maintenance.contractor_id" item-text="short_name" item-value="id"
              :loading="isLoadingContractors" :search-input.sync="search_contractor" outlined clearable hide-no-data
              hide-details dense :label="$t('contractors.select_contractor')" :items="contractors">
            </v-autocomplete>
          </v-flex>
          <v-flex md12>
            <v-textarea v-model="maintenance.description" :label="$t('maintenance.description')" outlined rows="1"
              auto-grow dense></v-textarea>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showEndMaintenanceDialog = false">{{
            $t("custom.close")
          }}</v-btn>
          <v-btn color="success" @click="saveEndMaintenance()">{{
            $t("maintenance.save_end_maintenance")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showReportDialog" :retain-focus="false" persistent max-width="1000px"
      :style="isMobile ? 'padding: 5px !important;' : ''">
      <v-card min-height="500px">
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <h2 v-if="report && report.deviceId">{{ reportTitle(report) }}</h2>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click.stop="showReportDialog = false, report = {}">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-layout row wrap>
              <v-flex class="d-flex">
                <v-flex>
                  <vc-date-picker ref="report_calendar_start_date" v-model="report_start_date" mode="date"
                    :model-config="reportCalendarConfig" :attributes="report_calendar_attributes" :input-debounce="500"
                    title-position="left" :columns="$screens({ default: 1 })" class="flex d-flex md12 p-0"
                    :locale="$i18n.locale" :is-dark="$vuetify.theme.dark">
                    <template v-slot="{
                      inputValue,
                      inputEvents,
                      togglePopover,
                      isDragging
                    }">
                      <v-flex md12 :class="isMobile ? '' : 'd-flex'">
                        <v-text-field @click="togglePopover()" :class="isDragging
                          ? 'text-gray-600 mr-2 p-0'
                          : 'text-gray-900 mr-2 p-0'
                          " :value="inputValue ? inputValue : $t('trackers.start_date_report')" v-on="inputEvents"
                          prepend-icon="mdi-calendar-clock" readonly hide-details></v-text-field>
                      </v-flex>
                    </template>
                  </vc-date-picker>
                </v-flex>
                <v-flex>
                  <vc-date-picker ref="report_calendar_end_date" v-model="report_end_date" mode="date"
                    :model-config="reportCalendarConfig" :attributes="report_calendar_attributes" :input-debounce="500"
                    title-position="left" :columns="$screens({ default: 1 })" class="flex d-flex md12 p-0"
                    :locale="$i18n.locale" :is-dark="$vuetify.theme.dark">
                    <template v-slot="{
                      inputValue,
                      inputEvents,
                      togglePopover,
                      isDragging
                    }">
                      <v-flex md12 :class="isMobile ? '' : 'd-flex'">
                        <v-text-field @click="togglePopover()" :class="isDragging
                          ? 'text-gray-600 mr-2 p-0'
                          : 'text-gray-900 mr-2 p-0'
                          " :value="inputValue ? inputValue : $t('trackers.end_date_report')" v-on="inputEvents"
                          prepend-icon="mdi-calendar-clock" readonly hide-details></v-text-field>
                      </v-flex>
                    </template>
                  </vc-date-picker>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text v-if="report && report.deviceId" :style="isMobile ? 'padding: 5px !important;' : ''">
          <v-container grid-list-md :style="isMobile ? 'padding: 5px !important;' : ''">
            <v-layout row wrap>
              <v-flex md12 sm12>
                <v-text-field
                  :value="report.distance ? parseInt(report.distance * 0.001) + ' ' + $t('cars.kilometers') : ''"
                  type="text" :label="$t('trackers.distance')" readonly></v-text-field>
              </v-flex>
              <v-flex md6 sm12>
                <v-text-field
                  :value="report.startOdometer ? parseInt(report.startOdometer * 0.001) + ' ' + $t('cars.kilometers') : ''"
                  type="text" :label="$t('trackers.startOdometer')" readonly></v-text-field>
              </v-flex>
              <v-flex md6 sm12>
                <v-text-field
                  :value="report.endOdometer ? parseInt(report.endOdometer * 0.001) + ' ' + $t('cars.kilometers') : ''"
                  type="text" :label="$t('trackers.endOdometer')" readonly></v-text-field>
              </v-flex>
              <v-flex md4 sm12>
                <v-text-field v-model="report.engineHours" type="text" :label="$t('trackers.engineHours')"
                  readonly></v-text-field>
              </v-flex>
              <v-flex md4 sm12>
                <v-text-field v-model="report.maxSpeed" type="text" :label="$t('trackers.maxSpeed')"
                  readonly></v-text-field>
              </v-flex>
              <v-flex md4 sm12>
                <v-text-field v-model="report.spentFuel" type="text" :label="$t('trackers.spentFuel')"
                  readonly></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="report && report.deviceId">
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="showReportDialog = false, report = {}">{{
            $t("custom.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCurrentPositionDialog" :retain-focus="false"
      @click:outside="showCurrentPositionDialog = false, latitude = null, longitude = null" persistent max-width="620px"
      :style="isMobile ? 'padding: 5px !important;' : ''">
      <v-card>
        <v-card-title :class="isMobile ? 'pt-10' : 'headline'">
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click.stop="showCurrentPositionDialog = false, latitude = null, longitude = null">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-flex v-if="latitude && longitude" md12 class="my-2 mx-auto">
            <current-position :latitude="latitude" :longitude="longitude"></current-position>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="showCurrentPositionDialog = false, latitude = null, longitude = null">{{
            $t("custom.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </span>
</template>
<script>
import { findBookingIn, refuseRidedState } from "@/utils/ridedStateGuard";
import {
  translateCountCategory,
  companyCountCategories,
  summaryCategoryValues,
  CAR_SUMMARY_CODES,
} from "@/utils/countCategory";
import {
  buildTableParams,
  calendarRangeFromPages,
  missingRanges,
  mergeLoadedRange,
  subtractRange,
} from "./carBookingsQuery";
import Gallery from "./Gallary";
import CarPassport from "@/components/dashboard/damage_control/passport/CarPassport.vue";
import damageControlAccessMixin from "@/mixins/damageControlAccessMixin";
import { rentalObjectHas, maintenanceVisible } from "@/utils/rentalObjectFeatures";
import TaskCardSection from "@/components/dashboard/tasks/TaskCardSection.vue";
import TaskFormDialog from "@/components/dashboard/tasks/TaskFormDialog.vue";
import GalleryBooking from "./GallaryBooking";
import CurrentPosition from "../gps/CurrentPosition";
import Uppy from "../../../plugins/uppy_cars";
import UppyBooking from "../../../plugins/uppy_booking";
import UppyCarsDoc from "../../../plugins/uppy_cars_doc";
import UppyCarsEntityDoc from "../../../plugins/uppy_cars_entity_doc";
import { Doughnut } from 'vue-chartjs/legacy'

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import { hasPriceGaps, priceGapsLines, hasUsableBase } from "@/utils/priceGaps";
import { periodUpperBound } from "@/utils/pluralization";
import "moment/locale/ru";
import "moment/locale/en-gb";
// moment.locale("ru");
import { Capacitor } from "@capacitor/core";
import UppyCarAvatar from "../../../plugins/uppy_car_avatar";
import TaxiVehicleInfo from "./modules/TaxiVehicleInfo";
import StarlineTab from "./modules/StarlineTab";
import WialonTab from "./modules/WialonTab";
import AutofonTab from "./modules/AutofonTab";
import TraccarTab from "./modules/TraccarTab";
import LoadFailedRetry from "@/components/common/LoadFailedRetry.vue";
import RentToOwnNumberChip from "@/components/dashboard/bookings/RentToOwnNumberChip.vue";
import { isTransientNetworkError } from "@/utils/networkErrors";
import { rentToOwnStoreEnabled } from "@/api/rentToOwn";
import AgentMarker from "@/components/agents/AgentMarker.vue";
import PriceGroupPicker from "./PriceGroupPicker.vue"; // FT-217
import CarPricingLimitsPanel from "./CarPricingLimitsPanel.vue"; // FT-216
import { carDynamicPricingState } from "@/api/dynamicPricing"; // FT-216
import { fetchCarPriceGroup } from "@/utils/priceGroupsApi";
import agentMarkerLoader from "@/components/agents/agentMarkerLoader";

export default {
  mixins: [damageControlAccessMixin],
  pullToRefresh: true,
  data() {
    return {
      // Прод 18.09.2026 (Rollbar 27fa6040, /cars/82509): car был примитивом "",
      // и любая правка поля падала TypeError'ом — v-model="car.X" компилируется
      // во $set(car, "X", ...), а $set по примитиву делает `key in ""`. Объект с
      // массивами цен — тот же дефолт, что у карточки брони (BookingCard.booking):
      // шаблон читает car.prices.length ещё до ответа сервера.
      car: { prices: [], hourly_prices: [], weekly_prices: [], monthly_prices: [] },
      // Начальная загрузка провалилась так, что ретрай уместен, — показываем
      // котика с «Повторить» вместо пустой карточки.
      cardLoadSequence: 0,
      cardDisposed: false,
      cardBootstrapPending: false,
      cardSections: {},
      cardSectionsEntityId: null,
      passportInitialSection: undefined,
      extraDefaults: [],
      providersReady: false,
      tabRequestSequence: 0,
      loadFailed: false,
      // Пустая строка — дефолтный текст блока (про соединение).
      loadFailedMessage: "",
      taskDialog: false,
      cars: [],
      periods: [],
      periodsHourly: [],
      periodsWeekly: [],
      periodsMonthly: [],
      seasons: [],
      analitics_data: [],
      starlineDevices: [],
      isLoadingStarlineDevices: false,
      isEditingStarlineDevice: false,
      wialonUnits: [],
      isLoadingWialonUnits: false,
      isEditingWialonUnit: false,
      autofonObjects: [],
      isLoadingAutofonObjects: false,
      isEditingAutofonObject: false,
      expences_counts: [],
      search_income: null,
      search_expences: null,
      // tabs: 0,
      filesPanel: 0,
      set_tabs: 0,
      calendar_attributes: [],
      select_seasons: [{ season_id: null, value: this.$t("cars.main_prices") }],
      editedPrice: {},
      editedHourlyPrice: {},
      editedWeeklyPrice: {},
      editedMonthlyPrice: {},
      createPricesInput: {},
      createHourlyPricesInput: {},
      createWeeklyPricesInput: {},
      createMonthlyPricesInput: {},
      copy_prices_cars: [],
      movements: [],
      store_locations: [],
      store_products: [],
      search_store_products: null,
      filter_store_product_group: null,
      store_products_headers: [
        {
          text: this.$t("custom.id"),
          align: "center",
          value: "id",
        },
        {
          text: this.$t("custom.created_at"),
          align: "center",
          value: "created_at",
        },
        {
          text: this.$t("store.name"),
          align: "center",
          value: "name",
        },
        {
          text: this.$t("store.group"),
          align: "center",
          value: "group",
        },
        {
          text: this.$t("store.stock_balance"),
          align: "center",
          value: "stock_balance",
        },
        {
          text: this.$t("store.average_price"),
          align: "center",
          value: "average_price",
        },
        {
          text: this.$t("store.sku"),
          align: "center",
          value: "sku",
        },
        {
          text: this.$t("store.article"),
          align: "center",
          value: "article",
        },
        {
          text: this.$t("store.store_place"),
          align: "center",
          value: "store_place",
        },
      ],
      show_only_in_stock: false,
      inspections_headers: [
        { text: this.$t("to.date"), align: "center", value: "date" },
        { text: this.$t("to.worker"), value: "worker", align: "center" },
        {
          text: this.$t("to.total"),
          value: "description",
          sortable: false,
          align: "center",
        },
      ],
      bookings_states: [
        { text: this.$t("bookings_states.new"), value: "Новая" },
        { text: this.$t("bookings_states.in_work"), value: "В обработке" },
        { text: this.$t("bookings_states.abandoned"), value: "Недозвон" },
        { text: this.$t("bookings_states.decline"), value: "Отказ клиента" },
        { text: this.$t("bookings_states.no_cars"), value: "Нет машин" },
        {
          text: this.$t("bookings_states.wait_answer"),
          value: "Ожидает ответа клиента",
        },
        { text: this.$t("bookings_states.wait_pay"), value: "Ожидает оплаты" },
        { text: this.$t("bookings_states.active"), value: "Активная" },
        { text: this.$t("bookings_states.cancel"), value: "Отмена" },
        { text: this.$t("bookings_states.rided"), value: "Отъездила" },
        {
          text: this.$t("bookings_states.return_deposit"),
          value: "Вернуть залог",
        },
        { text: this.$t("bookings_states.accepted"), value: "Подтверждена" },
        {
          text: this.$t("bookings_states.not_accepted"),
          value: "Не подтверждена",
        },
        { text: this.$t("bookings_states.other"), value: "Другое" },
      ],
      contractor: {},
      contractors: [],
      isLoadingContractors: false,
      search_contractor: null,
      bookings: [],
      // FT-116: вкладка «Брони» работает на серверной выборке.
      bookings_total: 0,          // сколько броней всего — для футера таблицы
      price_gaps: [],             // FT-167: типы, которых не хватает этой машине
      price_group_state: null,    // FT-217 CTR-05: группа, предложение, группы филиала; null — ключей нет
      dynamic_pricing_state: null, // FT-216 CTR-02: { participates, min_day_price, max_day_price }; null — блока нет
      bookings_count: 0,          // счётчик из card вместо всей истории броней
      // options v-data-table. Инициализируются ПОЛНЫМ дефолтом, а не пустым объектом:
      // VData эмитит update:options сразу при первом рендере (watcher с immediate), и на
      // пустом объекте watcher видел бы «изменение» и слал лишний запрос страницы.
      bookings_options: { page: 1, itemsPerPage: 20, sortBy: [], sortDesc: [] },
      bookings_request_id: 0,     // защита от гонки: применяем только последний ответ
      bookings_search_timer: null,
      calendar_loaded_ranges: [], // какие месяцы уже загружены — чтобы не перезапрашивать
      calendar_inflight_ranges: [], // какие уже запрошены и ещё летят — иначе параллельные
      // вызовы (карточка открывается и watcher вкладки срабатывает почти одновременно)
      // успевают проскочить проверку кеша до первого ответа и шлют дубли
      calendar_generation: 0,     // поколение кеша: ответы, отправленные до сброса, отбрасываются
      bookings_inflight_params: null,
      calendar_initial_range: null,
      calendar_from_page: null,
      calendar_to_page: null,
      calendar_page_timer: null,
      calendar_page_resolve: null,
      inspections: [],
      search_bookings: null,
      bookings_headers: [
        { text: this.$t("custom.number"), value: "id", align: "center" },
        {
          text: this.$t("custom.created"),
          value: "created_at",
          align: "center",
        },
        {
          text: this.$t("custom.state_short"),
          value: "in_rent",
          align: "center",
        },
        {
          text: this.$t("custom.state_short_2"),
          value: "state",
          align: "center",
        },
        { text: this.$t("custom.client"), value: "last_name", align: "center" },
        { text: this.$t("custom.start"), value: "start_date", align: "center" },
        { text: this.$t("custom.end"), value: "end_date", align: "center" },
        {
          text: this.$t("custom.days"),
          sortable: false,
          value: "days",
          align: "center",
        },
        {
          text: this.$t("custom.checkin"),
          sortable: false,
          value: "location_start",
          align: "center",
        },
        {
          text: this.$t("custom.checkout"),
          sortable: false,
          value: "location_end",
          align: "center",
        },
        {
          text: this.$t("custom.description_2"),
          sortable: false,
          align: "center",
        },
      ],
      all_maintenance_items: [],
      maintenance_headers: [
        { text: '', value: "maintenance_type", align: "center" },
        { text: this.$t('maintenance.date_start'), value: "date_start", align: "center" },
        { text: this.$t('maintenance.title'), value: "title", align: "center" },
        { text: this.$t('maintenance.description'), value: "description", align: "center" },
        { text: this.$t('maintenance.step'), sortable: false, align: "center" },
        { text: this.$t('maintenance.last_maintenance'), sortable: false, align: "center" },
        { text: this.$t('maintenance.responsible'), value: "responsible", align: "center" },
        { text: this.$t('custom.control'), sortable: false, align: "center" },
      ],
      maintenance_not_started_headers: [
        { text: this.$t('maintenance.date_start'), value: "date_start", align: "center" },
        { text: this.$t('maintenance.title'), value: "title", align: "center" },
        { text: this.$t('maintenance.description'), value: "description", align: "center" },
        { text: this.$t('maintenance.step'), sortable: false, align: "center" },
        { text: this.$t('maintenance.last_maintenance'), sortable: false, align: "center" },
        { text: this.$t('maintenance.responsible'), value: "responsible", align: "center" },
        { text: this.$t('custom.control'), sortable: false, align: "center" },
      ],
      maintenance_completed_headers: [
        { text: this.$t("custom.number"), value: "id", align: "center" },
        { text: this.$t('maintenance.date_start'), value: "date_start", align: "center" },
        { text: this.$t('maintenance.date_completed'), value: "date_completed", align: "center" },
        { text: this.$t('maintenance.title'), value: "title", align: "center" },
        { text: this.$t('maintenance.description'), value: "description", align: "center" },
        { text: this.$t('maintenance.step'), sortable: false, align: "center" },
        { text: this.$t('maintenance.mileage_completed'), value: "mileage_completed", align: "center" },
        { text: this.$t('contractors.contractor'), value: "contractor_id", align: "center" },
        { text: this.$t('maintenance.whois_ended'), value: "whois_ended", align: "center" },
        { text: this.$t('custom.control'), sortable: false, align: "center" },
      ],
      search_maintenance: null,
      search_completed_maintenance: null,
      search_not_started_maintenance: null,
      isLoadingResponsible: false,
      maintenance_types: [
        { text: this.$t("maintenance.mileage"), value: 0 },
        { text: this.$t("maintenance.days"), value: 1 },
      ],
      maintenance_criticalities: [
        { text: this.$t("maintenance.low"), value: 0 },
        { text: this.$t("maintenance.medium"), value: 1 },
        { text: this.$t("maintenance.high"), value: 2 },
      ],
      showNewMaintenanceDialog: false,
      showEditMaintenanceDialog: false,
      maintenance: {
        periodic: false,
        started: true,
        maintenance_type: 0,
        title: null,
        description: null,
        mileage_step: 0,
        days_step: 0,
        last_maintenanced_date: moment().format("YYYY-MM-DD"),
        notify_before: 0,
        criticality: 0,
        responsible: [],
        assign_to_all_cars: false,
        car_id: null,
        car_ids: [],
      },
      showEndMaintenanceDialog: false,
      search_inspections: null,
      inspection_date: null,
      inspection_date_format: null,
      inspection_date_menu: false,
      inspection_description: null,
      cars_doc_template_url: null,
      cars_doc_template_id: null,
      cars_entity_doc_template_url: null,
      cars_entity_doc_template_id: null,
      workers: [],
      repair_dialog: false,
      sell_dialog: false,
      edit_price_dialog: false,
      edit_hourly_price_dialog: false,
      edit_weekly_price_dialog: false,
      edit_monthly_price_dialog: false,
      inspection_dialog: false,
      showAddPriceBtn: true,
      showAddHourlyPriceBtn: true,
      showAddWeeklyPriceBtn: true,
      showAddMonthlyPriceBtn: true,
      repair: {
        description: "",
        warning: false,
      },
      sell_info: {
        price: 0,
        date: null,
        cash: false,
        cashless: false,
        cash_card: false,
        entity: false,
      },
      worker_account_id: null,
      showSelectWorkerCashbox: false,
      editedCount: [],
      selected_car: [],
      selected_count: [],
      states: [
        { id: 1, state: this.$t("states.normal") },
        { id: 2, state: this.$t("states.in_service") },
        { id: 3, state: this.$t("states.critical") },
        { id: 4, state: this.$t("states.long_rent") },
        { id: 5, state: this.$t("states.no_rent") },
        { id: 6, state: this.$t("states.service_needed") },
      ],
      store_place_dialog: false,
      store_place: null,
      start_date: null,
      end_date: null,
      start_date_format: null,
      end_date_format: null,
      start_date_menu: false,
      end_date_menu: false,
      show_audited_price_dialog: false,
      audited_prices: [],
      headers_counts: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        { text: this.$t("custom.branch"), align: "center", value: "company_id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.group"), sortable: false, align: "center" },
        {
          text: this.$t("custom.description"),
          sortable: false,
          value: "description",
          align: "center",
        },
        {
          text: this.$t("custom.amount"),
          sortable: false,
          value: "sum",
          align: "center",
        },
        {
          text: this.$t("custom.operation"),
          value: "operation",
          align: "center",
        },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
      ],
      counts: [],
      itemsPerPageArray: [4, 8, 12],
      numberOfPages: 0,
      page: 1,
      itemsPerPage: 1,
      branches: [],
      revenue_for_period_data: [
        [
          this.$t("custom.group"),
          this.$t("custom.income"),
          this.$t("custom.expences"),
        ],
      ],
      income_expences_chart_data: [
        [this.$t("custom.income"), this.$t("custom.expences")],
      ],
      chartDataExpences: {
        labels: [this.$t("custom.income"), this.$t("custom.expences")],
        datasets: [
          {
            backgroundColor: ['#41B883', '#E46651'],
            data: [0, 0]
          }
        ]
      },
      chartOptionsExpences: {
        responsive: true,
        maintainAspectRatio: false
      },
      chart_types: ["BarChart", "ColumnChart", "PieChart", "LineChart"],
      selected_chart_type: "ColumnChart",
      selected_group: [],
      showEdit: false,
      editDialog: false,
      isLoading: false,
      drive_units: [
        { text: this.$t("drive_units.front"), value: "Передний" },
        { text: this.$t("drive_units.back"), value: "Задний" },
        { text: this.$t("drive_units.full"), value: "Полный" },
      ],
      car_classes: [
        { text: this.$t("car_classes.economy"), value: "Эконом" },
        { text: this.$t("car_classes.middle"), value: "Средний" },
        { text: this.$t("car_classes.business"), value: "Бизнес" },
        { text: this.$t("car_classes.commercial"), value: "Коммерческий" },
      ],
      tagGroups: [],
      carTagSelections: {},  // { groupId: tagId | [tagIds] }
      // Откат выбора после отказа по роли меняет v-model чип-группы. Если она
      // ответит на это своим @change, saveCarTags вызовется повторно — флаг
      // не даёт предупреждению уйти в цикл.
      isRevertingCarTags: false,
      car_types: [
        { text: this.$t("car_types.micro"), value: "Микро" },
        { text: this.$t("car_types.hatchback"), value: "Хэтчбек" },
        { text: this.$t("car_types.sedan"), value: "Седан" },
        { text: this.$t("car_types.universal"), value: "Универсал" },
        { text: this.$t("car_types.minivan"), value: "Минивен" },
        { text: this.$t("car_types.coupe"), value: "Купе" },
        { text: this.$t("car_types.crossover"), value: "Кроссовер" },
        { text: this.$t("car_types.suv"), value: "Внедорожник" },
        { text: this.$t("car_types.pickup"), value: "Пикап" },
        { text: this.$t("car_types.limousine"), value: "Лимузин" },
        { text: this.$t("car_types.van"), value: "Фургон" },
        { text: this.$t("car_types.cabriolet"), value: "Кабриолет" },
        { text: this.$t("car_types.bus"), value: "Микроавтобус" },
        { text: this.$t("car_types.campervan"), value: "Автодом" },
        { text: this.$t("car_types.light_van"), value: "Легковой фургон" },
        { text: this.$t("car_types.rodster"), value: "Родстер" },
        { text: this.$t("car_types.sportcar"), value: "Спорткар" },
      ],
      motorcycle_types: [
        { text: this.$t("motorcycle_types.sport"), value: "Спортивные (спортбайки)" },
        { text: this.$t("motorcycle_types.cruiser"), value: "Круизеры" },
        { text: this.$t("motorcycle_types.tourist"), value: "Туристические (турэндуро)" },
        { text: this.$t("motorcycle_types.enduro"), value: "Эндуро" },
        { text: this.$t("motorcycle_types.standard"), value: "Стандартные (нейкед)" },
        { text: this.$t("motorcycle_types.scooter"), value: "Скутеры" },
        { text: this.$t("motorcycle_types.chopper"), value: "Чопперы" },
        { text: this.$t("motorcycle_types.cafe_racer"), value: "Кафе рейсеры" },
        { text: this.$t("motorcycle_types.kross"), value: "Кроссовые (мотокросс)" },
        { text: this.$t("motorcycle_types.super"), value: "Супермото" },
        { text: this.$t("motorcycle_types.street"), value: "Стритфайтеры" },
        { text: this.$t("motorcycle_types.sport_tourist"), value: "Спорт-туристические" },
        { text: this.$t("motorcycle_types.moped"), value: "Мопеды" },
        { text: this.$t("motorcycle_types.truck"), value: "Трайки (трехколесные)" },
        { text: this.$t("motorcycle_types.bobber"), value: "Боббер" },
        { text: this.$t("motorcycle_types.buggy"), value: "Багги" },
      ],
      bike_types: [
        { text: this.$t("bike_types.road"), value: "Шоссейные" },
        { text: this.$t("bike_types.mtb"), value: "Горные (MTB)" },
        { text: this.$t("bike_types.city"), value: "Городские" },
        { text: this.$t("bike_types.hybrid"), value: "Гибридные" },
        { text: this.$t("bike_types.track"), value: "Трековые" },
        { text: this.$t("bike_types.gravel"), value: "Гравийные (гревел)" },
        { text: this.$t("bike_types.folding"), value: "Складные" },
        { text: this.$t("bike_types.bmx"), value: "BMX" },
        { text: this.$t("bike_types.tourist"), value: "Туристические" },
        { text: this.$t("bike_types.triathlon"), value: "Для триатлона" },
        { text: this.$t("bike_types.fatbike"), value: "Фэтбайки" },
        { text: this.$t("bike_types.cruiser"), value: "Круизеры" },
        { text: this.$t("bike_types.downhill"), value: "Даунхилл" },
        { text: this.$t("bike_types.children"), value: "Детские" },
        { text: this.$t("bike_types.tandem"), value: "Тандемы" },
        { text: this.$t("bike_types.electric"), value: "Электрические" },
        { text: this.$t("bike_types.trick"), value: "Трюковые" },
        { text: this.$t("bike_types.offroad"), value: "Внедорожные" },
        { text: this.$t("bike_types.sport"), value: "Спортивные" },
        { text: this.$t("bike_types.seat"), value: "Самокаты с сиденьем" },
        { text: this.$t("bike_types.scooter"), value: "Гироскутеры" },
        { text: this.$t("bike_types.kick"), value: "Кикскутеры" },
        { text: this.$t("bike_types.speed"), value: "Быстроходные" },
      ],
      fuels: [
        { text: this.$t("fuels.gas"), value: "Бензин" },
        { text: this.$t("fuels.gas_92"), value: "Бензин 92" },
        { text: this.$t("fuels.gas_95"), value: "Бензин 95" },
        { text: this.$t("fuels.gas_98"), value: "Бензин 98" },
        { text: this.$t("fuels.gas_100"), value: "Бензин 100" },
        { text: this.$t("fuels.disel"), value: "Дизель" },
        { text: this.$t("fuels.gas_natural"), value: "Газ" },
        { text: this.$t("fuels.gas_gasoline"), value: "Бензин/Газ" },
        { text: this.$t("fuels.electricity"), value: "Электричество" },
        { text: this.$t("fuels.hybrid"), value: "Гибрид" },
        { text: this.$t("fuels.hybrid_gas"), value: "Гибрид/Бензин" },
        { text: this.$t("fuels.hybrid_dizel"), value: "Гибрид/Дизель" },
        { text: this.$t("fuels.hydrogen"), value: "Водород" },
      ],
      gears: [
        { text: this.$t("transmissions.automatic"), value: "Автомат" },
        { text: this.$t("transmissions.manual"), value: "Механика" },
        { text: this.$t("transmissions.variator"), value: "Вариатор" },
        { text: this.$t("transmissions.robot"), value: "Робот" },
      ],
      roofs: [
        { text: this.$t("roofs.ordinary"), value: "Обычная" },
        { text: this.$t("roofs.glass"), value: "Стеклянная" },
        { text: this.$t("roofs.folding"), value: "Складывающаяся" },
      ],
      steering_side: [
        { text: this.$t("steering_side.left"), value: "Левая" },
        { text: this.$t("steering_side.right"), value: "Правая" },
      ],
      interiors: [
        { text: this.$t("interiors.textile"), value: "Ткань" },
        { text: this.$t("interiors.leather"), value: "Кожа" },
      ],
      attrs_calendar: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      booking_insurance: {
        full: {
          price: 0,
        },
        super_kasko: {
          price: 0,
        },
        kasko: {
          price: 0,
        },
        theft: {
          price: 0,
        },
        osago: {
          price: 0,
        },
      },
      car_marks: [],
      car_mark: null,
      isLoadingCarMarks: false,
      car_mark_search: null,
      car_models: [],
      car_model: null,
      cars_ids: [],
      isLoadingCarModels: false,
      car_model_search: null,
      car_generations: [],
      car_generation: null,
      isLoadingCarGenerations: false,
      car_generation_search: null,
      car_configurations: [],
      car_configuration: null,
      isLoadingCarConfigurations: false,
      car_configuration_search: null,
      car_modifications: [],
      car_modification: null,
      isLoadingCarModifications: false,
      car_modification_search: null,
      booking_services: [],
      booking_description: null,
      report: {},
      report_start_date: null,
      report_end_date: null,
      company_cashbox_id: null,
      company_cashbox_id_analitics: null,
      latitude: null,
      longitude: null,
      existing_extras: [
        {
          extra_code: "gps",
          extra_name: this.$t("agregator.gps"),
          rental_type: "per_day",
          extra_type: 1,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "free_cancellation",
          extra_name: this.$t("agregator.free_cancellation"),
          rental_type: "per_day",
          extra_type: 1,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "tpl",
          extra_name: this.$t("agregator.tpl"),
          rental_type: "per_day",
          extra_type: 3,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "cdw",
          extra_name: this.$t("agregator.cdw"),
          rental_type: "per_day",
          extra_type: 3,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "scdw",
          extra_name: this.$t("agregator.scdw"),
          rental_type: "per_day",
          extra_type: 3,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "full_cdw",
          extra_name: this.$t("agregator.full_cdw"),
          rental_type: "per_day",
          extra_type: 3,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "tp",
          extra_name: this.$t("agregator.tp"),
          rental_type: "per_day",
          extra_type: 3,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "insurance_for_passengers",
          extra_name: this.$t("agregator.insurance_for_passengers"),
          rental_type: "per_day",
          extra_type: 3,
          active: false,
          quantity_max: 5,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "young_driver_21_25",
          extra_name: this.$t("agregator.young_driver_21_25"),
          rental_type: "per_day",
          extra_type: 2,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "second_driver",
          extra_name: this.$t("agregator.second_driver"),
          rental_type: "per_day",
          extra_type: 2,
          active: false,
          quantity_max: 1,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "child_seat_one_year",
          extra_name: this.$t("agregator.child_seat_one_year"),
          rental_type: "per_booking",
          extra_type: 2,
          active: false,
          quantity_max: 2,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "child_seat",
          extra_name: this.$t("agregator.child_seat"),
          rental_type: "per_booking",
          extra_type: 2,
          active: false,
          quantity_max: 2,
          total_min: null,
          total_max: null,
          price: 0,
        },
        {
          extra_code: "child_booster_seat",
          extra_name: this.$t("agregator.child_booster_seat"),
          rental_type: "per_booking",
          extra_type: 2,
          active: false,
          quantity_max: 2,
          total_min: null,
          total_max: null,
          price: 0,
        },
      ],
      extra_rental_types: [
        { text: this.$t('agregator.paid_daily_service'), value: "per_day" },
        { text: this.$t('agregator.paid_once_service'), value: "per_booking" },
      ],
      new_extra: {
        name: null,
        price: 0,
        rental_type: "per_day",
      },
      reportCalendarConfig: {
        type: "string",
        mask: "DD-MM-YYYY"
      },
      report_calendar_attributes: [
        {
          key: "today",
          highlight: {
            color: "blue",
            fillMode: "outline",
            contentClass: "italic",
          },
          dates: new Date(),
        },
      ],
      showReportDialog: false,
      fast_booking: false,
      uploadPhotos: false,
      showDopPanel: false,
      showCurrentPositionDialog: false,
      copyPricesPanel: false,
      oldDataPanel: false,
      partner_can_view_maintenances: true,
      partner_can_view_booking_card: true,
      isLoadinSaveCarActive: false,
      isLoadingDisactivateCar: false,
      isLoadingShtrafus: false,
      // Подписка/отписка Штрафуса ушла в джобу — см. markShtrafusPending.
      shtrafusPending: false,
      isLoadingShtrafusSearch: false,
      isLoadingEditSave: false,
      isLoadingSaveBookingState: false,
      updatingBookingId: null,
      timeout: null,
      isMobile: false,
      error: "",
    };
  },
  created() {
    this.extraDefaults = this.existing_extras.map(extra => ({ ...extra }));
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      this.loadCarCardData();
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },

  // FT-116: снимаем отложенные таймеры вкладки «Брони». Иначе уход с карточки сразу после
  // ввода в поиск отправлял бы запрос через 400 мс и писал в уничтоженный компонент.
  beforeDestroy() {
    this.cardDisposed = true;
    this.cardLoadSequence += 1;
    this.tabRequestSequence += 1;
    this.bookings_request_id += 1;
    this.calendar_generation += 1;
    // Страница уходит — заявка на объяснение сетевого отказа больше не наша.
    this.$store.commit("network/RELEASE_LOAD", `car-card-${this._uid}`);
    clearTimeout(this.bookings_search_timer);
    clearTimeout(this.calendar_page_timer);
    clearTimeout(this.timeout);
    this.bookings_search_timer = null;
    this.calendar_page_timer = null;
    this.timeout = null;
    if (this.calendar_page_resolve) {
      this.calendar_page_resolve();
      this.calendar_page_resolve = null;
    }
  },

  mounted: function () {
    if (
      this.$tours["registrationTour"] &&
      this.$store.getters.getTourNextStep
    ) {
      console.log(this.$tours["registrationTour"] &&
        this.$store.getters.getTourNextStep)
      this.$tours["registrationTour"].nextStep();
    }
    let self = this;
  },
  watch: {
    // Адрес /cars/:id может смениться БЕЗ пересоздания компонента: «назад» в
    // браузере после prev/next, ссылка на другое авто, программная навигация.
    // created() тогда не сработает, и под новым адресом осталось бы прошлое
    // авто — с открытым гейтом car.id и чужой формой (находка финального ревью
    // 21.09.2026, проба на настоящем Router). Сбрасываем к дефолту: гейт снова
    // закрыт, пока не приедут данные нового авто.
    "$route.params.id": function (next, prev) {
      if (String(next) === String(prev)) return;
      this.car = { prices: [], hourly_prices: [], weekly_prices: [], monthly_prices: [] };
      this.loadCarCardData();
    },
    set_tabs: function () {
      this.$store.commit("setCarTab", this.set_tabs);
    },
    tabs() {
      if (this.cardBootstrapPending || this.cardDisposed || !this.car.id) return;
      this.passportInitialSection = undefined;
      this.providersReady = true;
      this.updateTabsData();
    },
    // FT-116: смена страницы, размера страницы или колонки сортировки — новый запрос.
    // Сравнение со старыми значениями обязательно: v-data-table дёргает options и при
    // обычной перерисовке, а без сравнения это давало бы лишний запрос на каждый чих.
    bookings_options(next, prev) {
      if (this.cardBootstrapPending || this.cardDisposed || this.tabs !== 0) return;
      if (!prev || !next) return;
      const changed =
        next.page !== prev.page ||
        next.itemsPerPage !== prev.itemsPerPage ||
        String(next.sortBy) !== String(prev.sortBy) ||
        String(next.sortDesc) !== String(prev.sortDesc);
      if (changed) this.loadBookingsPage();
    },
    // Поиск ушёл на сервер, поэтому нужен дебаунс: иначе запрос уходил бы на каждую букву.
    // Страница сбрасывается на первую — иначе после ввода можно оказаться на странице 7
    // выдачи из двух строк.
    search_bookings() {
      if (this.cardBootstrapPending || this.cardDisposed || this.tabs !== 0) return;
      clearTimeout(this.bookings_search_timer);
      this.bookings_search_timer = setTimeout(() => {
        if (this.bookings_options && this.bookings_options.page !== 1) {
          // Смена страницы сама вызовет загрузку через watcher options.
          this.bookings_options = { ...this.bookings_options, page: 1 };
        } else {
          this.loadBookingsPage();
        }
      }, 400);
    },
    start_date() {
      if (this.start_date) {
        this.start_date_format = moment(this.start_date, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );
        if (this.start_date && this.end_date && this.isLoading == false) {
          this.getAnaliticsDataForRange();
        }
      }
    },
    end_date() {
      if (this.end_date) {
        this.end_date_format = moment(this.end_date, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );

        if (this.start_date && this.end_date && this.isLoading == false) {
          this.getAnaliticsDataForRange();
        }
      }
    },
    company_cashbox_id_analitics() {
      if (this.start_date && this.end_date && this.isLoading == false) {
        this.getAnaliticsDataForRange();
      }
    },
    report_start_date() {
      if (this.report_start_date) {
        if (this.report_start_date && this.report_end_date) {
          this.get_total_distance();
        }
      }
    },
    report_end_date() {
      if (this.report_end_date) {
        if (this.report_start_date && this.report_end_date) {
          this.get_total_distance();
        }
      }
    },
    selected_group() {
      this.revenue_for_period_data = [
        [
          this.$t("custom.group"),
          this.$t("custom.income"),
          this.$t("custom.expences"),
        ],
      ];
      this.selected_group.forEach((group) => {
        if (
          this.analitics_data.income_counts &&
          this.analitics_data.expences_counts
        ) {
          let true_counts = this.analitics_data.income_counts.filter(
            (count) => count.group == group
          );
          let false_counts = this.analitics_data.expences_counts.filter(
            (count) => count.group == group
          );
          // console.log(true_counts,false_counts)
          let revenue = 0;
          let expences = 0;
          if (true_counts.length > 0) {
            revenue = true_counts.map((a) => a.sum).reduce((v, i) => v + i);
          }
          if (false_counts.length > 0) {
            expences = false_counts.map((a) => a.sum).reduce((v, i) => v + i);
          }
          // let income = revenue - expences

          this.revenue_for_period_data.push([this.translateCategory(group), revenue, expences * -1]);
        } else {
          this.$notify(this.$t("errors.not_enough_data"), this.$t("errors.not_enough_car_data"), "warning");
        }
      });
    },
    inspection_date() {
      if (this.inspection_date) {
        this.inspection_date_format = moment(this.inspection_date).format(
          "DD-MM-YYYY"
        );
      }
    },
    search_contractor() {
      if (this.contractor && this.contractor.id) {
        return;
      }
      if (this.search_contractor == "" || this.search_contractor == " ") {
        this.search_contractor = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadContractors();
          }, 200); // delay
        }
        debounce();
      }
    },
    car_mark() {
      if (this.car_mark) {
        this.car.car_mark_id = this.car_mark.id;
        this.isLoading = true;
        this.isLoadingCarModels = true;
        this.axios
          .get(`/api/v1/car_models?car_mark_id=${this.car_mark.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.car_models = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => {
            this.isLoadingCarModels = false;
            this.isLoading = false;
          });
      } else {
        this.car_models = [];
        this.car_generations = [];
        this.car_configurations = [];
        this.car_modifications = [];
      }
    },
    car_model() {
      if (this.car_model) {
        this.car.car_model_id = this.car_model.id;
        this.isLoading = true;
        this.isLoadingCarGenerations = true;
        if (!this.car.car_name || this.car.car_name == "") {
          this.car.car_name = `${this.car_mark.name} ${this.car_model.name}`;
        }
        if (!this.car.code || this.car.code == "") {
          this.car.code = `${this.car_mark.name[0]}${this.car_model.name[0]}1`;
        }
        this.axios
          .get(`/api/v1/car_generations?car_model_id=${this.car_model.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.car_generations = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => {
            this.isLoadingCarGenerations = false;
            this.isLoading = false;
          });
      } else {
        this.car_generations = [];
        this.car_configurations = [];
        this.car_modifications = [];
      }
    },
    car_generation() {
      if (this.car_generation) {
        this.car.car_generation_id = this.car_generation.id;
        this.isLoadingCarConfigurations = true;
        this.isLoading = true;
        this.axios
          .get(
            `/api/v1/car_configurations?car_generation_id=${this.car_generation.id}`,
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.car_configurations = response.data;
            console.log(this.car_configurations)
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => {
            this.isLoadingCarConfigurations = false;
            this.isLoading = false;
          });
      } else {
        this.car_configurations = [];
        this.car_modifications = [];
      }
    },
    car_configuration() {
      if (this.car_configuration) {
        this.car.car_configuration_id = this.car_configuration.id;
        this.car_modifications = this.car_configuration.modifications
        if (this.car_configuration["body_type"] && (this.car.car_type == "" || this.car.car_type == null)) {
          // для выбора типа кузова
          switch (this.car_configuration["body_type"]) {
            case 'купе': case 'купе-хардтоп':
              this.car.car_type = "Купе"
              break;
            case 'родстер': case 'тарга': case 'спидстер':
              this.car.car_type = "Родстер"
              break;
            case 'седан': case 'седан 2 дв.': case 'лифтбек': case 'седан-хардтоп':
              this.car.car_type = "Седан"
              break;
            case 'хэтчбек 3 дв.': case 'хэтчбек 5 дв.': case 'хэтчбек 4 дв.':
              this.car.car_type = "Хэтчбек"
              break;
            case 'внедорожник 5 дв.': case 'внедорожник 3 дв.': case 'внедорожник открытый':
              this.car.car_type = "Внедорожник"
              break;
            case 'универсал': case 'универсал 5 дв.': case 'универсал 3 дв.':
              this.car.car_type = "Универсал"
              break;
            case 'кабриолет':
              this.car.car_type = "Кабриолет"
              break;
            case 'минивэн': case 'микровэн': case 'компактвэн':
              this.car.car_type = "Минивен"
              break;
            case 'фургон':
              this.car.car_type = "Фургон"
              break;
            case 'пикап': case 'пикап одинарная кабина': case 'пикап полуторная кабина': case 'пикап двойная кабина':
              this.car.car_type = "Пикап"
              break;
            case 'лимузин':
              this.car.car_type = "Лимузин"
              break;
            default:
              break;
          }
        }
      } else {
        this.car_modifications = [];
      }
    },
    car_modification() {
      if (this.car_modification) {
        this.car.car_complectation_id = this.car_modification["complectation-id"];
        if (this.car_modification.specifications.transmission && (this.car.transmission == "" || this.car.transmission == null)) {
          let self = this
          switch (this.car_modification.specifications.transmission) {
            case 'механическая':
              self.car.transmission = "Механика"
              break;
            case 'автоматическая':
              self.car.transmission = "Автомат"
              break;
            case 'робот':
              self.car.transmission = "Робот"
              break;
            case 'вариатор':
              self.car.transmission = "Вариатор"
              break;
            default:
              break;
          }
        }
        if (this.car_modification.specifications["doors-count"] && (this.car.doors_count == "" || this.car.doors_count == null || this.car.doors_count == 0)) {
          this.car.doors_count = this.car_modification.specifications["doors-count"]
        }
        if (this.car_modification.specifications["fuel-tank-capacity"] && (this.car.tank_value == "" || this.car.tank_value == null || this.car.tank_value == 0)) {
          this.car.tank_value = this.car_modification.specifications["fuel-tank-capacity"]
        }
        if (this.car_modification.specifications["horse-power"] && (this.car.engine_power == "" || this.car.engine_power == null || this.car.engine_power == 0)) {
          this.car.engine_power = this.car_modification.specifications["horse-power"]
        }
        if (this.car_modification.specifications["consumption-mixed"] && (this.car.gas_mileage == "" || this.car.gas_mileage == null || this.car.gas_mileage == 0)) {
          this.car.gas_mileage = this.car_modification.specifications["consumption-mixed"]
        }
        if (this.car_modification.specifications["volume-litres"] && (this.car.engine_capacity == "" || this.car.engine_capacity == null || this.car.engine_capacity == 0)) {
          this.car.engine_capacity = this.car_modification.specifications["volume-litres"]
        }
        if (this.car_modification.specifications["wheel-size"] && (this.car.tire_size == "" || this.car.tire_size == null || this.car.tire_size == 0)) {
          this.car.tire_size = this.car_modification.specifications["wheel-size"][0]
        }
        if (this.car_modification.specifications["drive"] && (this.car.drive_unit == "" || this.car.drive_unit == null)) {
          switch (this.car_modification.specifications["drive"]) {
            case 'задний':
              this.car.drive_unit = "Задний"
              break;
            case 'передний':
              this.car.drive_unit = "Передний"
              break;
            case 'полный':
              this.car.drive_unit = "Полный"
              break;
            default:
              break;
          }
        }
        if (this.car_modification.specifications["fuel"] && (this.car.drive_unit == "" || this.car.drive_unit == null)) {
          switch (this.car_modification.specifications["fuel"]) {
            case 'АИ-95':
              this.car.drive_unit = "Бензин 95"
              break;
            case 'АИ-92':
              this.car.drive_unit = "Бензин 92"
              break;
            case 'АИ-98':
              this.car.drive_unit = "Бензин 98"
              break;
            case 'газ':
              this.car.drive_unit = "Газ"
              break;
            case 'ДТ':
              this.car.drive_unit = "Дизель"
              break;
            case 'водород':
              this.car.drive_unit = "Водород"
              break;
            default:
              break;
          }
        }
      }
    },
  },
  computed: {
    // FT-183: фичи, скрытые для типа техники компании (utils/rentalObjectFeatures).
    showFines() {
      return rentalObjectHas(this.rental_object, "fines");
    },
    showMileage() {
      return rentalObjectHas(this.rental_object, "mileage");
    },
    showFuel() {
      return rentalObjectHas(this.rental_object, "fuel");
    },
    showInsurance() {
      return rentalObjectHas(this.rental_object, "insurance");
    },
    showCarIntegrations() {
      return rentalObjectHas(this.rental_object, "car_integrations");
    },
    // FT-173 REQ-11: видимость кнопки «Оформить выкуп» — те же условия, что у
    // пункта меню Drawer.vue (REQ-01): услуга rent_to_own в плане (trial не
    // открывает — решение USER D1; FT-194 — и переключатель филиала, rentToOwnEnabled) И роль manager+.
    // isManagerPlus — computed из глобального roleMixin (main.js).
    // FT-173 H12: архивную машину в договор выкупа не оформить — кнопка скрыта.
    rentToOwnEntryVisible() {
      return rentToOwnStoreEnabled(this.$store.getters) && this.isManagerPlus && !(this.car && this.car.archive);
    },
    // FT-167 (REQ-06). Признак обязан гаснуть на месте: цены правятся на этом же
    // экране без перезагрузки, а price_gaps приходит один раз в .then. Пересчёт
    // локальный, без похода на сервер — заполнение строки может только УБРАТЬ тип
    // из набора, добавить нельзя, поэтому пришедшего массива и текущих ассоциаций
    // достаточно. Обратное направление (удалили строку — признак должен появиться)
    // требует нового used_types с сервера и в объём не входит (NS-11).
    //
    // Работает только потому, что четыре массива созданы через $set в .then:
    // новый ключ на уже наблюдаемом объекте во Vue 2 нереактивен, и computed
    // не инвалидировался бы никогда.
    livePriceGaps() {
      const assoc = { daily: "prices", hourly: "hourly_prices",
                      weekly: "weekly_prices", monthly: "monthly_prices" };
      return (this.price_gaps || []).filter((type) => !hasUsableBase(this.car[assoc[type]]));
    },
    showPriceGap() {
      return this.isStaff && hasPriceGaps(this.livePriceGaps);
    },
    priceGapLines() {
      return priceGapsLines(this.livePriceGaps, this.$t.bind(this));
    },
    nonSystemTagGroups() {
      return this.tagGroups.filter((g) => !g.system);
    },
    // Зеркалит роль-гард Api::V1::CarsController#update_tags. Без него
    // saveCarTags уходил на сервер при КАЖДОМ сохранении карточки (не только
    // при правке тегов) и возвращал 403 с красным тостом «Not authorized».
    canEditTags() {
      return ["superadmin", "admin", "manager"].includes(this.user_role);
    },
    cars_files() {
      if (this.car && this.car.cars_files) {
        return this.car.cars_files;
      } else {
        return [];
      }
    },
    // FT-183: записи страхований ТС (maintenance_type 4) скрыты у вело-компании.
    visible_maintenance_items: function () {
      return this.all_maintenance_items.filter((item) => item && maintenanceVisible(this.rental_object, item));
    },
    maintenance_items: function () {
      return this.visible_maintenance_items.filter((item) => !item.completed && item.started);
    },
    maintenance_completed_items: function () {
      return this.visible_maintenance_items.filter((item) => item.completed);
    },
    not_started_maintenance_items: function () {
      return this.visible_maintenance_items.filter((item) => !item.started && item.date_start == null);
    },
    full_counts: function () {
      if (this.analitics_data.income_counts && this.analitics_data.expences_counts) {
        return this.analitics_data.income_counts.concat(this.analitics_data.expences_counts);
      } else {
        return []
      }
    },
    // Сводка «Сгруппированные данные»: статьи каталога в прежнем порядке плюс статьи
    // компании без кода, по которым у автомобиля есть платежи (FT-192 task-24).
    summary_groups() {
      const categories = companyCountCategories(this.$store.getters.getCompany, { fallback: true });
      return summaryCategoryValues(CAR_SUMMARY_CODES, categories, this.full_counts).map((value) => ({
        text: this.translateCategory(value),
        value,
      }));
    },
    worker_accounts() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.currency_accounts;
      } else {
        return [];
      }
    },
    toolbar_height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 170
        case 'sm': return 170
        default: return 60
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    isTaxiMode() {
      return this.company && this.company.taxi_park_type && this.company.taxi_park_type !== 'not_taxi';
    },
    isStarlineMode() {
      return this.main_company && this.main_company.starline_on && this.main_company.plan.included_services.includes('starline') && 
             this.car && this.car.gps_integration_type === 'starline' && 
             this.car.starline_device_id ;
    },
    isWialonMode() {
      return this.main_company && this.main_company.wialon_on && this.main_company.plan.included_services.includes('wialon') && 
             this.car && this.car.gps_integration_type === 'wialon' && 
             this.car.wialon_unit_id ;
    },
    isAutofonMode() {
      return this.main_company && this.main_company.autofon_on && this.main_company.plan.included_services.includes('autofon') && 
             this.car && this.car.gps_integration_type === 'autofon' && 
             this.car.autofon_object_id ;
    },
    isTraccarMode() {
      return this.main_company && this.main_company.beacons_on && 
             this.car && this.car.gps_integration_type === 'traccar' && 
             this.car.traccar_id ;
    },
    // Маппинг имён вкладок на индексы
    tabNameToIndex() {
      const map = {
        'bookings': 0,        // Брони
        'characteristics': 1, // Характеристики
        'prices': 2,          // Цены
        'service': 3,         // Обслуживание
        'files': 4,           // Файлы
        'analytics': 5,       // Аналитика/Расходы
        'inspection': 6,      // Техосмотр (ТО)
        'store': 7,           // Склад
        'integrations': 8     // Интеграции
      };
      let nextIndex = 9;
      if (this.isTaxiMode) {
        map['taxi'] = nextIndex++;
      }
      if (this.isStarlineMode) {
        map['starline'] = nextIndex++;
      }
      if (this.isWialonMode) {
        map['wialon'] = nextIndex++;
      }
      if (this.isAutofonMode) {
        map['autofon'] = nextIndex++;
      }
      if (this.isTraccarMode) {
        map['traccar'] = nextIndex++;
      }
      if (this.damageControlAvailable) {
        map['damage_control'] = nextIndex++;
      }
      return map;
    },
    // Маппинг индексов на имена вкладок
    tabIndexToName() {
      const map = {
        0: 'bookings',        // Брони
        1: 'characteristics', // Характеристики
        2: 'prices',          // Цены
        3: 'service',         // Обслуживание
        4: 'files',           // Файлы
        5: 'analytics',       // Аналитика/Расходы
        6: 'inspection',      // Техосмотр (ТО)
        7: 'store',           // Склад
        8: 'integrations'     // Интеграции
      };
      let nextIndex = 9;
      if (this.isTaxiMode) {
        map[nextIndex++] = 'taxi';
      }
      if (this.isStarlineMode) {
        map[nextIndex++] = 'starline';
      }
      if (this.isWialonMode) {
        map[nextIndex++] = 'wialon';
      }
      if (this.isAutofonMode) {
        map[nextIndex++] = 'autofon';
      }
      if (this.isTraccarMode) {
        map[nextIndex++] = 'traccar';
      }
      if (this.damageControlAvailable) {
        map[nextIndex++] = 'damage_control';
      }
      return map;
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    company_cashboxes_with_all() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.push(
          {
            id: null,
            name: this.$t("companies.all_cashboxes"),
          },
        );
        return cashboxes;
      } else {
        return [];
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    user_exists_in_traccar() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.traccar_id != null;
      } else {
        return false;
      }
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    tabs: {
      // getter - конвертируем имя вкладки в индекс
      get: function () {
        const tabName = this.$store.getters.getCarTab;
        const index = this.tabNameToIndex[tabName];
        // Если вкладка недоступна (например starline на машине без StarLine) - возвращаем 0
        return index !== undefined ? index : 0;
      },
      // setter - конвертируем индекс в имя вкладки
      set: function (newValue) {
        const tabName = this.tabIndexToName[newValue];
        if (tabName) {
          this.$store.commit("setCarTab", tabName);
        }
      },
    },
    store_products_for_car() {
      if (this.store_products && this.store_products.length > 0) {
        return this.store_products.filter((product) => {
          return product.cars_ids.includes(this.car.id);
        });
      } else {
        return [];
      }
    },
    products_groups() {
      let groups = [];
      this.store_products.forEach((product) => {
        if (!groups.includes(product.group)) {
          groups.push(product.group);
        }
      });
      return groups;
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    rental_object() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.rental_object) {
        return this.$store.getters.getCompany.company.rental_object;
      } else {
        return 'cars';
      }
    },
    current_object_types() {
      if (this.rental_object == 'cars') {
        return this.car_types;
      } else if (this.rental_object == 'bicycles') {
        return this.bike_types;
      } else if (this.rental_object == 'motorcycles') {
        return this.motorcycle_types;
      } else {
        return this.car_types;
      }
    },
  },
  methods: {
    // Форма слова в заголовках таблиц цен ("1 - 1 час", "2 - 5 часов") — по верхней границе периода
    periodUpperBound,
    // Загрузка карточки вынесена из created() отдельным методом: на обрыве сети
    // (прод 18.09.2026: GET car_card_data status 0) котик LoadFailedRetry даёт
    // повторить запрос, не перезагружая страницу. Эталон — BookingCard.loadCardData.
    loadCarCardData() {
      if (this.cardDisposed) return Promise.resolve();
      const sequence = this.cardLoadSequence = (this.cardLoadSequence || 0) + 1;
      const carId = this.$route.params.id;
      const current = () => !this.cardDisposed && sequence === this.cardLoadSequence && String(carId) === String(this.$route.params.id);
      this.cardBootstrapPending = true;
      this.tabRequestSequence = (this.tabRequestSequence || 0) + 1;
      this.bookings_request_id = (this.bookings_request_id || 0) + 1;
      this.bookings_inflight_params = null;
      this.resetCalendarCache();
      clearTimeout(this.bookings_search_timer);
      clearTimeout(this.calendar_page_timer);
      if (this.calendar_page_resolve) { this.calendar_page_resolve(); this.calendar_page_resolve = null; }
      const newEntity = String(this.cardSectionsEntityId) !== String(carId);
      if (newEntity) {
        this.providersReady = false;
        this.existing_extras = (this.extraDefaults || []).map(extra => ({ ...extra }));
        this.bookings_options = { ...this.bookings_options, page: 1 };
        this.calendar_from_page = null;
        this.calendar_to_page = null;
        this.search_bookings = null;
      }
      const range = this.currentCalendarRange();
      this.calendar_initial_range = range;
      const params = {
        tab: this.$store.getters.getCarTab || "bookings",
        ...buildTableParams(this.bookings_options, this.search_bookings),
        ...range,
        start_date: moment().subtract(1, "months").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        company_cashbox_id: this.company_cashbox_id_analitics,
      };
      let self = this;
      this.loadFailed = false;
      this.loadFailedMessage = "";
      this.isLoading = true;
      // Пока карточка грузится, сетевой отказ объясняет она сама — глобальный
      // индикатор молчит. Заявка делается ДО запроса и держится всю попытку,
      // включая нажатие «Повторить»: иначе на время ретрая индикатор считал бы
      // отказ ничьим и всплывал поверх лоадера (находка ревью 19.09.2026).
      this.$store.commit("network/CLAIM_LOAD", `car-card-${this._uid}`);
      return this.axios
        .get(`/api/v1/car_cards/${carId}`, {
          params,
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then(async (response) => {
          if (!current()) return;
          const { card, sections, effective_tab: effectiveTab } = response.data;
          response = { data: card };
          // Set envelopes before car.id opens the child render gates.
          if (newEntity || String(this.cardSectionsEntityId) !== String(carId)) {
            this.cardSections = {
              tasks: sections.tasks || { status: "error" },
              task_users: sections.task_users || { status: "error" },
            };
            this.cardSectionsEntityId = card.car.id;
          }
          this.passportInitialSection = effectiveTab === "damage_control" ? (sections.tab || { status: "error" }) : undefined;
          const access = sections.partner_access;
          this.partner_can_view_maintenances = !this.isPartner || !!(access && access.status === "ok" && access.data.can_view_maintenances);
          this.partner_can_view_booking_card = !this.isPartner || !!(access && access.status === "ok" && access.data.can_view_booking_card);
          this.$store.commit("network/RELEASE_LOAD", `car-card-${this._uid}`);
          // FT-167: четыре массива цен кладутся в car СРАЗУ при присваивании, а не
          // дописываются после. Во Vue 2 ключ, добавленный на уже наблюдаемый объект,
          // реактивным не становится — computed livePriceGaps не инвалидировался бы
          // никогда, и иконка не гасла бы после сохранения цены (REQ-06). Прайс-таблицы
          // в шаблоне этого не замечали: они читают car.prices на каждом ре-рендере,
          // без кэша computed.
          //
          // Именно присваивание целиком, а НЕ $set: loadCarCardData вызывается в спеках
          // с синтетическим this (inPlaceRetrySilencesGlobalCat.spec.js), у которого
          // методов Vue-инстанса нет.
          // FT-184: метка «через агента» машины едет в этом же ответе (agent_marks).
          agentMarkerLoader.prime(response.data.agent_marks);
          this.car = {
            ...response.data.car,
            prices: response.data.prices.data.map((price) => price.attributes),
            hourly_prices: response.data.hourly_prices.data.map((price) => price.attributes),
            weekly_prices: response.data.weekly_prices.data.map((price) => price.attributes),
            monthly_prices: response.data.monthly_prices.data.map((price) => price.attributes),
          };
          // FT-167: старый api и внешние роли поля не шлют (NEG-05, CTR-04).
          this.price_gaps = response.data.price_gaps || [];
          // FT-217 CTR-05: ключи групп сервер шлёт только сотрудникам и только для машины
          // своего филиала; нет ключа — нет и выбора группы с предложением (REQ-10).
          this.price_group_state = Object.prototype.hasOwnProperty.call(response.data, "price_groups")
            ? {
              price_group: response.data.price_group || null,
              suggestion: response.data.price_group_suggestion || null,
              groups: response.data.price_groups || [],
              unit: response.data.unit || null,
            }
            : null;
          // FT-216 CTR-02: блок есть только у superadmin/admin и только при услуге в плане (REQ-15).
          this.dynamic_pricing_state = response.data.dynamic_pricing
            ? carDynamicPricingState(response.data.dynamic_pricing)
            : null;
          if (this.car.price_hour == null || this.car.price_hour == undefined || this.car.price_hour == '') {
            this.car.price_hour = 0;
          }
          if (this.car.deposit == null || this.car.deposit == undefined || this.car.deposit == '') {
            this.car.deposit = 0;
          }

          this.seasons = response.data.seasons;
          this.seasons.forEach((season) => {
            self.car.prices.forEach((price) => {
              if (price.season_id != season.id) {
                self.select_seasons.push({
                  season_id: season.id,
                  value: `${season.start_date} - ${season.end_date}`,
                });
              }
            });
          });
          // сортируем цены по первой дате начала сезона, если сезонов нет, то в самый верх списка
          // сортируем сезоны по дате начала
          let sorted_seasons = this.seasons.sort(function (a, b) {
            if (moment(a.start_date, "DD.MM").isBefore(moment(b.start_date, "DD.MM"))) {
              return -1;
            }
            if (moment(a.start_date, "DD.MM").isSameOrAfter(moment(b.start_date, "DD.MM"))) {
              return 1;
            }
            return 0;
          });

          // сортируем цены по индексу в сортированном массиве сезонов
          let sorted_prices = this.car.prices.sort(function (a, b) {
            if (a.season_id == null) {
              return -99999;
            }
            let index_a = sorted_seasons.findIndex((season) => season.id == a.season_id);
            let index_b = sorted_seasons.findIndex((season) => season.id == b.season_id);

            if (index_a < index_b) {
              return -1;
            }
            if (index_a > index_b) {
              return 1;
            }
            return 0;
          });
          // сортируем цены по индексу в сортированном массиве сезонов
          let sorted_hourly_prices = this.car.hourly_prices.sort(function (a, b) {
            if (a.season_id == null) {
              return -99999;
            }
            let index_a = sorted_seasons.findIndex((season) => season.id == a.season_id);
            let index_b = sorted_seasons.findIndex((season) => season.id == b.season_id);

            if (index_a < index_b) {
              return -1;
            }
            if (index_a > index_b) {
              return 1;
            }
            return 0;
          });
          // сортируем цены по индексу в сортированном массиве сезонов
          let sorted_weekly_prices = this.car.weekly_prices.sort(function (a, b) {
            if (a.season_id == null) {
              return -99999;
            }
            let index_a = sorted_seasons.findIndex((season) => season.id == a.season_id);
            let index_b = sorted_seasons.findIndex((season) => season.id == b.season_id);

            if (index_a < index_b) {
              return -1;
            }
            if (index_a > index_b) {
              return 1;
            }
            return 0;
          });
          // сортируем цены по индексу в сортированном массиве сезонов
          let sorted_monthly_prices = this.car.monthly_prices.sort(function (a, b) {
            if (a.season_id == null) {
              return -99999;
            }
            let index_a = sorted_seasons.findIndex((season) => season.id == a.season_id);
            let index_b = sorted_seasons.findIndex((season) => season.id == b.season_id);

            if (index_a < index_b) {
              return -1;
            }
            if (index_a > index_b) {
              return 1;
            }
            return 0;
          });
          this.car.prices = sorted_prices;
          this.car.hourly_prices = sorted_hourly_prices;
          this.car.weekly_prices = sorted_weekly_prices;
          this.car.monthly_prices = sorted_monthly_prices;

          this.periods = response.data.periods;
          this.periodsHourly = response.data.hourly_periods;
          this.periodsWeekly = response.data.weekly_periods;
          this.periodsMonthly = response.data.monthly_periods;

          // The aggregate carries the count and the selected tab’s bounded page/window.
          this.bookings_count = Number(response.data.bookings_count) || 0;
          this.cars_ids = response.data.cars_ids;
          this.company_cashbox_id = this.company_cashboxes && this.company_cashboxes[0] && this.company_cashboxes[0].id ? this.company_cashboxes[0].id : null;
          this.applyTagGroups(sections.tag_groups && sections.tag_groups.status === "ok" ? sections.tag_groups.data : {});
          this.applyInitialTab(effectiveTab, sections.tab, params);
          this.$store.commit("setCarTab", effectiveTab);
          // Flush the accepted generation's watchers before enabling legacy interactions.
          await this.$nextTick();
          if (!current()) return;
          this.cardBootstrapPending = false;
          this.providersReady = !["starline", "wialon", "autofon", "traccar"].includes(effectiveTab) || !!(sections.tab && sections.tab.status === "ok");
        })
        .catch((error) => {
          if (!current()) return;
          // Раньше .catch не было вовсе: 404 (авто удалено / чужой филиал / битый
          // id) давал unhandled rejection и пустую битую карточку. Уводим на
          // список, прочие ошибки — через setError (тост, страница остаётся).
          if (error.response?.status === 404) {
            this.$store.commit("network/RELEASE_LOAD", `car-card-${this._uid}`);
            this.$notify(this.$t("errors.car_not_found"), "", "error");
            this.$router.push({ path: `/cars` });
            return;
          }
          // Котик с «Повторить» — там, где ретрай реально может помочь: обрыв
          // сети и 5xx (сервер мог икнуть). На 4xx его нет — доступа и прав
          // повтором не прибавится, остаётся тост. Без ветки 5xx человек
          // оставался с пустой карточкой без единой кнопки (находка ревью).
          const status = error.response && error.response.status;
          const isNetwork = isTransientNetworkError(error);
          this.loadFailed = isNetwork || status >= 500;
          // Текст про соединение честен только для обрыва; на 5xx сеть исправна.
          this.loadFailedMessage = isNetwork ? "" : this.$t("errors.car_load");
          // Заявка — только на сетевой отказ. На 5xx блок на экране есть, но
          // он не про сеть: если человек следом реально уйдёт в офлайн,
          // глобальный индикатор обязан сработать (находка ревью 19.09.2026).
          if (!isNetwork) {
            this.$store.commit("network/RELEASE_LOAD", `car-card-${this._uid}`);
          }
          // Блок на экране уже объяснил отказ — тост был бы вторым сообщением.
          this.setError(error, this.$t("errors.car_load"), { silent: this.loadFailed });
        })
        .finally(() => {
          if (!current()) return;
          this.cardBootstrapPending = false;
          this.isLoading = false;
        });
    },
    applyInitialTab(tab, section, params) {
      // Clear data from the previous entity even when this section is denied or failed.
      this.bookings = []; this.bookings_total = 0;
      this.branches = []; this.cars = []; this.workers = []; this.contractors = [];
      this.all_maintenance_items = []; this.inspections = [];
      this.movements = []; this.store_locations = []; this.store_products = [];
      this.analitics_data = []; this.expences_counts = [];
      this.chartDataExpences = {
        labels: [this.$t("custom.income"), this.$t("custom.expences")],
        datasets: [{ backgroundColor: ['#41B883', '#E46651'], data: [0, 0] }],
      };
      this.cars_doc_template_url = null; this.cars_doc_template_id = null;
      this.cars_entity_doc_template_url = null; this.cars_entity_doc_template_id = null;
      this.booking_insurance = {
        full: { price: 0 }, super_kasko: { price: 0 }, kasko: { price: 0 },
        theft: { price: 0 }, osago: { price: 0 },
      };
      this.booking_services = [];
      this.booking_description = null; this.fast_booking = false;
      if (!section || section.status !== "ok") {
        if (!section || section.status === "error") {
          this.$notify(this.$t("errors.error"), this.$t("errors.car_load"), "error");
        }
        return;
      }
      const data = section.data || {};
      const attributes = (payload) => ((payload && payload.data) || []).map((item) => item.attributes);
      switch (tab) {
        case "bookings": {
          this.bookings = (data.bookings && data.bookings.bookings) || [];
          this.bookings_total = (data.bookings && data.bookings.total) || 0;
          const calendar = data.calendar || {};
          if (calendar.from && calendar.to) {
            this.calendar_loaded_ranges = mergeLoadedRange([], { from: calendar.from, to: calendar.to });
          }
          this.appendCalendarAttributes(calendar.bookings || []);
          break;
        }
        case "characteristics": this.branches = data.companies || []; break;
        case "prices": this.cars = attributes(data.cars_for_car_card); break;
        case "service":
          this.all_maintenance_items = data.maintenances || [];
          this.workers = data.workers || [];
          this.contractors = attributes(data.contractors);
          break;
        case "files":
          this.cars_doc_template_url = data.doc_templates ? data.doc_templates.url
            : (this.$i18n.locale === "ru" ? "https://web.rentprog.ru/doc_example.docx" : "https://web.rentprog.com/doc_example_en.docx");
          this.cars_doc_template_id = data.doc_templates ? data.doc_templates.id : null;
          this.cars_entity_doc_template_url = data.entity_doc_templates ? data.entity_doc_templates.url : null;
          this.cars_entity_doc_template_id = data.entity_doc_templates ? data.entity_doc_templates.id : null;
          // Preserve the legacy empty-template fallback.
          if (!data.entity_doc_templates) this.cars_doc_template_url = this.$i18n.locale === "ru"
            ? "https://web.rentprog.ru/entity_doc_example.docx" : "https://web.rentprog.com/entity_doc_example_en.docx";
          break;
        case "analytics":
          if (data.analytics) {
            this.start_date = params.start_date;
            this.end_date = params.end_date;
            if (data.analytics.income_rub || data.analytics.expences_rub) {
              this.analitics_data = data.analytics;
              this.chartDataExpences = {
                labels: [this.$t("custom.income"), this.$t("custom.expences")],
                datasets: [{ backgroundColor: ['#41B883', '#E46651'], data: [data.analytics.income_rub, data.analytics.expences_rub] }],
              };
              this.selected_group = ["Оплата аренды", "Ремонт", "Обслуживание", "Запчасти", "Страховка"];
            } else this.$notify(this.$t("errors.not_enough_data"), this.$t("errors.not_enough_car_data"), "warning");
          } else this.expences_counts = attributes(data.minus_counts);
          break;
        case "inspection":
          this.inspections = data.inspections || []; this.workers = data.workers || [];
          break;
        case "store": {
          const movements = data.store_movements || {};
          this.movements = movements.movements || [];
          this.store_locations = movements.locations || [];
          this.store_products = movements.products || [];
          this.workers = data.workers || [];
          break;
        }
        case "integrations": {
          const payload = data.booking_settings || {};
          const settings = payload.settings || {};
          this.booking_insurance = { ...this.booking_insurance, ...(settings.insurance || {}) };
          this.booking_services = settings.services || [];
          this.booking_description = settings.description;
          this.fast_booking = settings.fast_booking;
          (payload.existing_extras || []).forEach((extra) => {
            const index = this.existing_extras.findIndex((item) => item.extra_code === extra.extra_code);
            if (index !== -1) this.existing_extras.splice(index, 1, extra);
          });
          break;
        }
        // Passport receives the envelope; taxi and provider tabs own their lifecycle.
      }
    },
    // ── FT-116: вкладка «Брони» на серверной выборке ────────────────────────────────────
    //
    // Раньше и таблица, и календарь жили на одном массиве со всей историей авто — из-за него
    // карточка весила мегабайт и не открывалась, пока история не выгрузится. Теперь таблица
    // просит страницу, календарь — видимый диапазон месяцев.

    // Счётчик приходит вместо списка. От длины массива зависел ровно один сценарий: увод с
    // пустой вкладки «Брони» на «Цены». Сама вкладка выбирается из Vuex (getCarTab), и
    // форсировать её здесь нельзя — это снесло бы запоминание вкладки между заходами.
    applyCardBookingsCount(count) {
      this.bookings_count = Number(count) || 0;
      if (this.bookings_count === 0) {
        this.tabs = 2;
      }
    },

    loadBookingsPage() {
      if (this.cardBootstrapPending || this.cardDisposed) return Promise.resolve();
      const carId = this.$route.params.id;
      const params = buildTableParams(this.bookings_options, this.search_bookings);
      const signature = JSON.stringify(params);
      // Тот же запрос уже в полёте — второй не нужен. Карточка зовёт загрузку вкладки
      // дважды: явным вызовом в created и через watcher tabs (легаси-стык, живёт с 2020).
      if (this.bookings_inflight_params === signature) return Promise.resolve();

      this.bookings_inflight_params = signature;
      const requestId = ++this.bookings_request_id;
      this.isLoading = true;

      return this.axios
        .get(`/api/v1/bookings_in_cars/${this.$route.params.id}`, {
          params: params,
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          // Ответ на устаревший запрос игнорируем: при быстром листании ответы приходят не
          // в том порядке, в каком уходили, и старый затёр бы актуальную страницу.
          if (this.cardDisposed || String(carId) !== String(this.$route.params.id) || requestId !== this.bookings_request_id) return;

          this.bookings = response.data.bookings || [];
          this.bookings_total = response.data.total || 0;
        })
        .catch((error) => {
          if (this.cardDisposed || String(carId) !== String(this.$route.params.id) || requestId !== this.bookings_request_id) return;
          this.setError(error, this.$t("errors.bookings_load"));
          console.log(error);
        })
        .finally(() => {
          if (requestId !== this.bookings_request_id || this.cardDisposed || String(carId) !== String(this.$route.params.id)) return;
          if (this.bookings_inflight_params === signature) this.bookings_inflight_params = null;
          if (requestId === this.bookings_request_id) this.isLoading = false;
        });
    },

    // Сброс кеша календаря: и загруженные диапазоны, и уже нарисованная подсветка. Иначе
    // после изменения брони календарь остаётся замороженным на прежних данных.
    //
    // Поколение инкрементируется здесь же: в момент сброса запрос может быть в полёте, и
    // его ответ придёт уже ПОСЛЕ. Без проверки поколения он вернул бы подсветку по старым
    // данным и пометил бы месяц загруженным — то есть ровно ту устаревшую картинку, ради
    // которой сброс и делается, да ещё и без шанса перезапросить.
    resetCalendarCache() {
      this.calendar_generation = (this.calendar_generation || 0) + 1;
      this.calendar_loaded_ranges = [];
      this.calendar_inflight_ranges = [];
      this.calendar_attributes = [];
    },

    // Текущий видимый диапазон календаря. До первого события v-calendar показывает месяцы
    // от сегодняшнего, поэтому диапазон считается от текущей даты.
    currentCalendarRange() {
      if (this.calendar_from_page) {
        return calendarRangeFromPages(this.calendar_from_page, this.calendar_to_page);
      }
      const now = new Date();
      const columns = typeof this.$screens === "function" ? Number(this.$screens({ default: 1, md: 2, lg: 4 })) || 1 : 1;
      const last = new Date(now.getFullYear(), now.getMonth() + columns - 1, 1);
      return calendarRangeFromPages(
        { month: now.getMonth() + 1, year: now.getFullYear() },
        { month: last.getMonth() + 1, year: last.getFullYear() }
      );
    },

    // Грузит только те месяцы, которых ещё нет в кеше. Возврат на уже просмотренные месяцы
    // запроса не порождает.
    loadCalendarSlice(range) {
      if (this.cardBootstrapPending || this.cardDisposed) return Promise.resolve();
      const carId = this.$route.params.id;
      if (!range) return Promise.resolve();
      // Из запроса вычитаем и загруженное, и уже летящее: карточка открывается и watcher
      // вкладки срабатывает почти одновременно, и без учёта in-flight один и тот же месяц
      // уходил на сервер трижды (видно в сетевой панели при живом прогоне).
      const gaps = missingRanges(
        [...this.calendar_loaded_ranges, ...this.calendar_inflight_ranges],
        range
      );
      if (gaps.length === 0) return Promise.resolve();

      // Счётчика ЗАПРОСОВ у календаря нет намеренно: он аддитивен — поздний ответ просто
      // добавит подсветку своих месяцев и ничего не затрёт. А вот поколение кеша проверять
      // обязательно: ответ, отправленный до сброса, вернул бы старую картинку уже после него.
      const generation = this.calendar_generation;

      return Promise.all(gaps.map((gap) => {
        this.calendar_inflight_ranges = mergeLoadedRange(this.calendar_inflight_ranges, gap);
        return this.axios
          .get(`/api/v1/bookings_in_cars_calendar/${this.$route.params.id}`, {
            params: { from: gap.from, to: gap.to },
            headers: { Authorization: this.$store.getters.getAuthToken },
          })
          .then((response) => {
            // Кеш успели сбросить, пока запрос летел — данные из него уже устарели.
            if (this.cardDisposed || String(carId) !== String(this.$route.params.id) || generation !== this.calendar_generation) return;

            // Загруженным помечается диапазон ИЗ ОТВЕТА: сервер капит ширину, и пометка
            // запрошенного оставила бы обрезанные месяцы пустыми навсегда.
            this.calendar_loaded_ranges = mergeLoadedRange(this.calendar_loaded_ranges, {
              from: response.data.from,
              to: response.data.to,
            });
            this.appendCalendarAttributes(response.data.bookings || []);
          })
          .catch((error) => {
            // Тост только в консоль и один раз: setError показал бы второй такой же
            // красный тост поверх ошибки таблицы, а заодно погасил бы её индикатор
            // загрузки — у ещё летящего запроса страницы.
            console.log("FT-116 calendar slice failed", error);
          })
          .finally(() => {
            // Снимаем пометку «летит» в любом случае: после ошибки месяц обязан снова стать
            // запрашиваемым, иначе он навсегда останется пустым. После сброса кеша список
            // уже пуст, и вычитание просто ничего не делает.
            if (this.cardDisposed || String(carId) !== String(this.$route.params.id) || generation !== this.calendar_generation) return;
            this.calendar_inflight_ranges = subtractRange(this.calendar_inflight_ranges, gap);
          });
      }));
    },

    onCalendarPageChange(fromPage, toPage) {
      if (fromPage) this.calendar_from_page = fromPage;
      if (toPage) this.calendar_to_page = toPage;
      if (this.cardBootstrapPending || this.cardDisposed) return Promise.resolve();
      const range = this.currentCalendarRange();
      // v-calendar announces its initial pages on mount, including for a failed section.
      // Only a changed window is a user refresh; an initial error must not auto-retry.
      if (this.calendar_initial_range && range && range.from === this.calendar_initial_range.from && range.to === this.calendar_initial_range.to) return Promise.resolve();
      this.calendar_initial_range = null;

      // Одно листание порождает ДВА события (from-page и to-page), и между ними диапазон
      // рассогласован. Ждём конца тика, чтобы прилетели оба: иначе на каждое листание
      // уходил лишний запрос, а при движении вперёд — ещё и заведомо невалидный
      // (from позже to), на который сервер отвечает 422 и пользователь видит ошибку.
      // Отменённый таймер резолвим, а не бросаем: иначе промис предыдущего вызова остаётся
      // pending навсегда — ловушка для того, кто напишет `await` в цикле.
      if (this.calendar_page_resolve) {
        clearTimeout(this.calendar_page_timer);
        this.calendar_page_resolve();
        this.calendar_page_resolve = null;
      }

      return new Promise((resolve) => {
        this.calendar_page_resolve = resolve;
        this.calendar_page_timer = setTimeout(() => {
          this.calendar_page_resolve = null;
          resolve(this.loadCalendarSlice(this.currentCalendarRange()));
        }, 0);
      });
    },

    appendCalendarAttributes(bookings) {
      const selectHighlight = (booking) => {
        if (booking.active) return booking.in_rent ? "green" : "blue";
        return "gray";
      };
      const known = new Set(this.calendar_attributes.map((a) => a.key));

      bookings.forEach((booking) => {
        if (!booking.active && !booking.in_rent && !booking.ride) return;
        // Диапазоны месяцев могут перекрываться по краям брони — ключ не даёт задвоить
        // подсветку одной и той же брони.
        if (known.has(booking.id)) return;

        this.calendar_attributes.push({
          key: booking.id,
          highlight: {
            start: { fillMode: "outline", color: selectHighlight(booking) },
            base: { fillMode: "light", color: selectHighlight(booking) },
            end: { fillMode: "outline", color: selectHighlight(booking) },
          },
          content: "black",
          dates: {
            start: moment(booking.start_date, "DD-MM-YYYY H:mm").toDate(),
            end: moment(booking.end_date, "DD-MM-YYYY H:mm").toDate(),
          },
          popover: {
            label: `${this.$t("custom.number")}${booking.id} ${booking.start_date} ${booking.location_start} - ${booking.end_date} ${booking.location_end} | ${booking.last_name} ${booking.first_name} ${booking.middle_name}`,
            visibility: "hover",
            hideIndicator: true,
          },
        });
      });
    },

    onTaskSaved() {}, // задача в сторе (UPSERT) → секция задач покажется автоматически
    isTagDimmed(group, tag) {
      const sel = this.carTagSelections[group.id];
      if (!sel) return false;
      if (Array.isArray(sel)) return sel.length > 0 && !sel.includes(tag.id);
      return sel !== null && sel !== tag.id;
    },
    isLightTagColor(hex) {
      if (!hex) return true;
      const c = hex.replace("#", "");
      const r = parseInt(c.substring(0, 2), 16);
      const g = parseInt(c.substring(2, 4), 16);
      const b = parseInt(c.substring(4, 6), 16);
      return (r * 299 + g * 587 + b * 114) / 1000 > 160;
    },
    tagGroupDisplayName(group) {
      if (group.system) {
        const key = "tags.system_" + group.name;
        const translated = this.$t(key);
        return translated !== key ? translated : group.name;
      }
      return group.name;
    },
    applyTagGroups(payload) {
      const data = payload.data || [];
      this.tagGroups = data.map((item) => {
        const attrs = item.attributes || {};
        const includedTags = (payload.included || [])
          .filter((inc) => inc.type === "tag" && item.relationships && item.relationships.tags &&
            item.relationships.tags.data.some((r) => r.id === inc.id))
          .map((inc) => ({
            id: parseInt(inc.id),
            ...inc.attributes,
          }))
          .sort((a, b) => a.sort_order - b.sort_order);
        return {
          id: parseInt(item.id),
          ...attrs,
          tags: includedTags,
        };
      });
      // Заполнить текущие выбранные теги из данных ТС
      this.loadCarTagSelections();
    },
    loadCarTagSelections() {
      if (!this.car || !this.car.tags) return;
      const selections = {};
      this.tagGroups.forEach((group) => {
        const carTags = (this.car.tags || []).filter((t) => t.group_id === group.id);
        if (group.allow_multiple) {
          selections[group.id] = carTags.map((t) => t.id);
        } else {
          selections[group.id] = carTags.length > 0 ? carTags[0].id : null;
        }
      });
      this.$set(this, "carTagSelections", selections);
    },
    // Теги сохраняются сами по себе, по клику на чип, а не вместе с карточкой:
    // общий save дёргал этот запрос при КАЖДОМ сохранении машины и у роли без
    // прав давал 403 с красным тостом, даже когда теги не трогали.
    saveCarTags() {
      // Зеркалит роль-гард Api::V1::CarsController#update_tags: говорим прямо,
      // что нельзя, и возвращаем чипы к сохранённому состоянию, чтобы выбор не
      // выглядел применённым.
      if (!this.canEditTags) {
        if (this.isRevertingCarTags) return;

        this.isRevertingCarTags = true;
        this.$notify(this.$t("errors.no_access"), this.$t("tags.no_edit_permission"), "warning");
        this.loadCarTagSelections();
        this.$nextTick(() => {
          this.isRevertingCarTags = false;
        });
        return;
      }

      const tagIds = [];
      // Собрать все выбранные теги (включая системные)
      Object.keys(this.carTagSelections).forEach((groupId) => {
        const val = this.carTagSelections[groupId];
        if (Array.isArray(val)) {
          val.forEach((id) => tagIds.push(id));
        } else if (val) {
          tagIds.push(val);
        }
      });
      this.axios
        .post(
          `/api/v1/cars/${this.car.id}/update_tags`,
          { tag_ids: tagIds },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .catch((error) => {
          this.$notify(this.$t("errors.error"), error.response?.data?.error || error.message, "error");
        });
    },
    getDefaultImage() {
      // Проверяем тип объектов аренды
      const rentalObject = this.company?.rental_object || 'cars';
      
      if (rentalObject === 'cars') {
        // Для автомобилей - иконка авто
        return 'https://web.rentprog.com/img/no-car-image-min.png';
      } else {
        // Для остальных - нейтральная SVG заглушка
        return '/img/no-image-placeholder.svg';
      }
    },
    onImageError() {
      // При ошибке загрузки сбрасываем avatar_url
      if (this.car && this.car.avatar_url) {
        this.$set(this.car, 'avatar_url', null);
      }
    },
    removeSeasonPrices(price) {
      this.removeSeasonPricesRow(price, "prices");
    },
    removeSeasonHourlyPrices(price) {
      this.removeSeasonPricesRow(price, "hourly_prices");
    },
    removeSeasonWeeklyPrices(price) {
      this.removeSeasonPricesRow(price, "weekly_prices");
    },
    // FT-217 SC-04: группу и предложение переноса сервер считает при чтении — после
    // записи цены суток или почасовой перечитываем их, чтобы предложение появилось
    // сразу, а не при следующем открытии карточки. Только если блок групп показан
    // (ключи CTR-05 пришли в car_card_data). Неудача перечитывания цену не отменяет:
    // тоста нет (цена сохранена), отказ уходит в Rollbar через silent setError.
    refreshPriceGroup() {
      if (!this.price_group_state || !this.car || !this.car.id) return Promise.resolve();
      return fetchCarPriceGroup(this, this.car.id)
        .then((data) => {
          if (!this.price_group_state) return;
          // архивная машина (её могли архивировать, пока карточка открыта): сервер
          // ключей групп не отдаёт — выбор группы и предложение прячем, как при загрузке
          if (!Object.prototype.hasOwnProperty.call(data, "price_groups")) {
            this.price_group_state = null;
            return;
          }
          this.price_group_state = {
            price_group: data.price_group || null,
            suggestion: data.suggestion || null,
            groups: data.price_groups || this.price_group_state.groups,
            unit: data.unit || this.price_group_state.unit,
          };
        })
        .catch((error) => this.setError(error, this.$t("price_groups.load_error"), { silent: true }));
    },
    removeSeasonMonthlyPrices(price) {
      this.removeSeasonPricesRow(price, "monthly_prices");
    },
    // Удаляются только цены сезона: основные (без сезона) только меняются — API отвечает base_prices_undeletable.
    removeSeasonPricesRow(price, kind) {
      if (!this.isAdminPlus) {
        this.$notify(this.$t("errors.no_access"), "", "warning");
        return;
      }
      if (!price.id || !price.season_id) return;

      const kindTitles = {
        prices: this.$t("bookings.daily_prices"),
        hourly_prices: this.$t("bookings.hourly_prices"),
        weekly_prices: this.$t("bookings.weekly_prices"),
        monthly_prices: this.$t("bookings.monthly_prices"),
      };
      this.$confirm({
        title: this.$t("custom.you_sure_title"),
        text: this.$t("cars.remove_season_prices_warning", {
          kind: kindTitles[kind],
          season: this.getSeasonValue(price.season_id),
        }),
        icon: "mdi-alert-circle-outline",
        confirmButtonText: this.$t("custom.you_sure_yes"),
        cancelButtonText: this.$t("custom.you_sure_no"),
      }).then((result) => {
        if (!result) return;

        this.isLoading = true;
        this.axios
          .delete(`/api/v1/${kind}/${price.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then(() => {
            const index = this.car[kind].indexOf(price);
            if (index >= 0) this.car[kind].splice(index, 1);
            this.$notify(this.$t("custom.deleted"), this.$t("tooltips.remove_prices_success"), "success");
            if (kind === "prices" || kind === "hourly_prices") this.refreshPriceGroup();
          })
          .catch((error) =>
            this.setError(error, this.$t("errors.delete_prices"))
          )
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    copyPrices() {
      if (this.isManagerPlus) {
        if (this.copy_prices_cars.length > 0) {
          // удаляем текущий автомобиль из списка
          this.copy_prices_cars = this.copy_prices_cars.filter((car) => car.id != this.car.id);
        }
        if (this.car.id && this.copy_prices_cars && this.copy_prices_cars.length > 0) {
          let self = this;
          this.$confirm({
            title: this.$t("custom.you_sure_title"),
            text: this.$t("cars.you_sure_copy_prices_text"),
            icon: "mdi-alert-circle-outline",
            confirmButtonText: this.$t("custom.yes"),
            cancelButtonText: this.$t("custom.no"),
          }).then((result) => {
            if (result) {
              this.isLoading = true;
              this.axios
                .post(
                  "/api/v1/copy_prices",
                  {
                    copy_from_id: this.car.id,
                    copy_to_ids: this.copy_prices_cars,
                  },
                  {
                    headers: {
                      Authorization: this.$store.getters.getAuthToken,
                    },
                  }
                )
                .then(() => {
                  this.copy_prices_cars = [];
                  this.copyPricesPanel = false;
                  this.$notify(this.$t("custom.success"), this.$t("cars.copy_prices_text"), "success");
                  // цены целей могли сдвинуть медиану группы этой машины
                  this.refreshPriceGroup();
                })
                .catch((error) =>
                  this.setError(error, this.$t("errors.error"))
                )
                .finally(() => {
                  this.isLoading = false;
                });
            }
          });
        } else {
          this.$notify(this.$t("custom.no_data"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    repairSave() {
      if (this.isStaff) {
        this.isLoading = true;
        var self = this;
        this.axios
          .post(
            `/api/v1/cars/${this.car.id}/repairs`,
            {
              repairs: {
                description: this.repair.description,
                warning: this.repair.warning,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.$notify(this.$t("cars.add_repair"), this.$t("cars.add_repair_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.add_repair"));
          })
          .finally(
            () => (
              (this.repair_dialog = false),
              (this.isLoading = false),
              (this.repair.description = ""),
              (this.repair.warning = false)
            )
          );
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sellSave() {
      if (this.isAdminPlus) {
        if (
          this.car.id &&
          this.sell_info.price > 0 &&
          this.sell_info.date &&
          (this.sell_info.cash ||
            this.sell_info.cash_card ||
            this.sell_info.cashless ||
            this.sell_info.entity)
        ) {
          if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && this.sell_info.cash) {
            // проверяем что у пользователя есть выбранный счёт
            let worker_accounts_cashboxes_ids = this.worker_accounts.map(
              (account) => account.company_cashbox_id
            );
            let company_cashbox_id = this.company_cashbox_id;
            // проверяем что у пользователя есть выбранный счёт
            if (worker_accounts_cashboxes_ids.length > 0 && worker_accounts_cashboxes_ids.includes(company_cashbox_id)) {
              console.log("exists currency_account")
            } else if (worker_accounts_cashboxes_ids.length > 0 && !worker_accounts_cashboxes_ids.includes(company_cashbox_id) && !this.worker_account_id) {
              console.log("not exists currency_account")
              this.showSelectWorkerCashbox = true;
              this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "warning", 5000);
              return;
            } else {
              console.log("currency_account selected")
            }
          }
          this.isLoading = true;
          var self = this;
          this.axios
            .post(
              `/api/v1/sell_car`,
              {
                car_id: this.car.id,
                sale_price: this.sell_info.price,
                sale_date: this.sell_info.date,
                archive: true,
                cash: this.sell_info.cash,
                cashless: this.sell_info.cashless,
                cash_card: this.sell_info.cash_card,
                entity: this.sell_info.entity,
                company_cashbox_id: this.company_cashbox_id,
                worker_account_id: this.worker_account_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.worker_account_id = null;
              this.$notify(this.$t("cars.sell_car_title"), this.$t("cars.sell_car_text"), "success", 3000);
              // Архив и сброс формы — только после успешной продажи. Раньше это стояло в
              // finally: после отказа (406 брони, 422 exchange_rate_missing — нет курса к
              // валюте счёта) карточка показывала машину архивной, а введённое пропадало.
              this.car.archive = true;
              this.sell_dialog = false;
              this.sell_info.price = 0;
              this.sell_info.date = null;
              this.sell_info.cash = false;
              this.sell_info.cash_card = false;
              this.sell_info.cashless = false;
              this.sell_info.entity = false;
            })
            .catch((error) => {
              // 406 = бизнес-гард (активные брони): человеческое сообщение,
              // без Rollbar и без сырого AxiosError (паттерн деактивации)
              if (error.response?.status == 406) {
                this.$notify(this.$t("errors.sell_car"), this.$t("errors.selling_car_has_bookings"), "error", 5000);
              } else {
                this.setError(error, this.$t("errors.sell_car"));
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        } else {
          this.$notify(this.$t("custom.no_data"), "", "warning", 3000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    inspectionSave() {
      if (this.isStaff) {
        this.isLoading = true;
        var self = this;
        this.axios
          .post(
            `/api/v1/cars/${this.car.id}/inspections`,
            {
              inspections: {
                description: this.inspection_description,
                date: this.inspection_date,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.inspection_dialog = false;
            this.inspection_date = null;
            this.inspection_date_menu = false;
            this.inspection_description = null;

            this.$notify(this.$t("to.success_title"), this.$t("to.success_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.update_to"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    storePlaceSave() {
      if (this.isStaff) {
        this.isLoading = true;
        var self = this;
        this.axios
          .patch(
            `/api/v1/cars/${this.car.id}`,
            {
              cars: {
                store_place: this.store_place,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.car.store_place = this.store_place;
            this.store_place = null;
            this.store_place_dialog = false;

            this.$notify(this.$t("cars.location_car_updated"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.location_car"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    unarchiveCar() {
      if (this.isStaff) {
        this.isLoading = true;
        var self = this;
        this.axios
          .patch(
            `/api/v1/cars/${this.car.id}`,
            {
              cars: {
                archive: false,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("cars.car_unarchive"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.unarchive_car"));
          })
          .finally(
            () => ((this.car.archive = false), (this.isLoading = false))
          );
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    archiveCar() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .patch(
            `/api/v1/cars/${this.car.id}`,
            {
              cars: {
                archive: true,
                active: false,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.$notify(this.$t("cars.car_archivate"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.archivate_car"));
          })
          .finally(() => ((this.car.archive = true), (this.isLoading = false)));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCarActive() {
      if (this.isStaff) {
        if (this.main_company && this.main_company.plan && this.main_company.active_cars_count >= this.main_company.plan.cars_limit) {
          this.$notify(this.$t("errors.tariffs_limit_reached_title"), this.$t("errors.tariffs_limit_reached_text"), "warning", 5000);
          return;
        }
        if (this.car.price_hour == null || this.car.price_hour == undefined || this.car.price_hour == '') {
          this.car.price_hour = 0;
        }
        if (this.car.deposit == null || this.car.deposit == undefined || this.car.deposit == '') {
          this.car.deposit = 0;
        }
        if (this.car.car_name && this.car.code && this.car.prices.length > 0) {
          this.isLoadinSaveCarActive = true;
          this.axios
            .patch(
              `/api/v1/active_update_car/${this.car.id}`,
              {
                cars: {
                  active: !this.car.active,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.active = !this.car.active;
              // FT-187: срок оплаты после включения считает сервер.
              this.car.billable_until = response.data?.billable_until ?? null;
              const until = this.minBillingUntil();
              if (until) {
                this.$notify(this.$t("cars.car_active"), this.$t("cars.min_billing_activated_text", { date: moment(until).format("ll") }), "info", 8000);
              } else {
                this.$notify(this.$t("cars.car_active"), "", "success", 3000);
              }
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.activate_car"));
            })
            .finally(() => (this.isLoadinSaveCarActive = false));
        } else {
          this.car.active = false;
          this.$notify(this.$t("errors.error"), this.$t("errors.activate_car_text"), "warning", 5000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // FT-187: до какого момента машина оплачивается после выключения. Дату считает API
    // (billable_until: null вне enforce, у демо/архива, после истечения срока), а тариф
    // проверяем здесь — правило только для оплаты за каждую машину (pay_as_you_go).
    minBillingUntil() {
      if (this.main_company?.plan?.payment_type !== "pay_as_you_go") return null;
      return this.car.billable_until || null;
    },
    async disactivateCar() {
      if (this.isStaff) {
        // FT-187: после включения машина оплачивается минимальный срок — предупреждаем до
        // выключения, что списания продолжатся до этой даты.
        if (this.minBillingUntil()) {
          const confirmed = await this.$confirm({
            title: this.$t("custom.you_sure_title"),
            text: this.$t("cars.min_billing_deactivate_text", {
              date: moment(this.minBillingUntil()).format("ll"),
            }),
            icon: "mdi-cash-clock",
            iconColor: "warning",
            confirmButtonText: this.$t("custom.yes"),
            confirmButtonColor: "warning",
            cancelButtonText: this.$t("custom.no"),
          });
          if (!confirmed) return;
        }
        this.isLoadingDisactivateCar = true;
        this.axios
          .patch(
            `/api/v1/active_update_car/${this.car.id}`,
            {
              cars: {
                active: false,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.car.active = false;
            this.car.billable_until = response.data?.billable_until ?? null;
            this.$notify(this.$t("cars.car_deactive"), "", "success", 3000);
          })
          .catch((error) => {
            // check if error is 406
            if (error.response?.status == 406) {
              this.$notify(this.$t("errors.deactivate_car"), this.$t("errors.deactivating_car_has_bookings"), "error", 5000);
            } else {
              this.setError(error, this.$t("errors.deactivate_car"));
            }
          })
          .finally(() => (this.isLoadingDisactivateCar = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    async addCarToShtrafus() {
      if (!this.requireStaff()) return;
      if (this.shtrafusPending) return;
      if (!this.car.car_name || !this.car.number || !this.car.registration_certificate) {
        this.$notify(this.$t("fines.not_enough_data_shtrafus"), "", "warning", 5000);
        return;
      }
      let price = parseFloat(this.main_company.plan.fines_monitoring_cost || 0).toFixed(1);
      const result = await this.$confirm({
        title: this.$t("fines.fines_monitory_title"),
        text: this.$t("fines.shtrafus_subscribe_text", { price: price, currency: this.main_company.plan.currency }),
        icon: "mdi-alert-circle-outline",
        iconColor: "warning",
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
      });
      if (result) {
        this.isLoadingShtrafus = true;
        this.axios
          .post(
            `/api/v1/shtrafus_data`,
            { car_id: this.car.id },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.success"), "", "success", 3000);
            this.markShtrafusPending();
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingShtrafus = false));
      }
    },
    async shtrafusSearchFines() {
      if (!this.requireStaff()) return;
      if (!this.car.car_name || !this.car.number || !this.car.registration_certificate) {
        this.$notify(this.$t("fines.not_enough_data_shtrafus"), "", "warning", 5000);
        return;
      }
      let price = parseFloat(this.main_company.plan.fines_cost).toFixed(1);
      const result = await this.$confirm({
        title: this.$t("fines.fines_monitory_title"),
        text: this.$t("fines.shtrafus_search_text", { price: price, currency: this.main_company.plan.currency }),
        icon: "mdi-alert-circle-outline",
        iconColor: "warning",
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
      });
      if (result) {
        this.isLoadingShtrafusSearch = true;
        this.axios
          .post(
            `/api/v1/shtrafus_search_fines`,
            { car_id: this.car.id },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.success"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingShtrafusSearch = false));
      }
    },
    retryShtrafusSubscription() {
      if (this.isStaff) {
        if (this.shtrafusPending) return;
        this.isLoadingShtrafus = true;
        this.axios
          .post(
            `/api/v1/shtrafus_data`,
            { car_id: this.car.id },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.success"), "", "success", 3000);
            this.markShtrafusPending();
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoadingShtrafus = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Подписку и отписку Штрафуса сервер только ставит в очередь
    // (Shtrafus::SubscribeCarJob / UnsubscribeCarJob), поля машины меняет джоба.
    // Раньше карточка выставляла их сама (shtrafus_vehicle_id = -1 или null) и
    // показывала «Повторить подписку» / «Подключить» по догадке, а когда джоба
    // доходила, сервер отвечал 422 fines_monitoring_active (FT-184 CP-03,
    // fines_telematics_marketplaces-2). Теперь — локальное ожидание завершения:
    // локальная отметка «ожидает обновления», кнопки спрятаны до перезагрузки
    // карточки, поля машины не трогаем и повторных запросов не шлём.
    markShtrafusPending() {
      this.shtrafusPending = true;
    },
    async removeCarFromShtrafus() {
      if (this.isStaff) {
        if (this.shtrafusPending) return;
        const result = await this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("fines.turn_off_fines_checking_text"),
          icon: "mdi-delete-outline",
          iconColor: "error",
          confirmButtonText: this.$t("custom.yes"),
          confirmButtonColor: "error",
          cancelButtonText: this.$t("custom.no"),
        });
        if (result) {
          this.isLoadingShtrafus = true;
          this.axios
            .get(
              `/api/v1/remove_car_from_shtrafus/${this.car.id}`,
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.$notify(this.$t("custom.success"), "", "success", 3000);
              this.markShtrafusPending();
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"));
            })
            .finally(() => (this.isLoadingShtrafus = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    editSave() {
      if (this.isStaff) {
        let self = this;
        if (this.car.car_name == "" || this.car.car_name == null) {
          this.$notify(this.$t("errors.no_car_name_title"), this.$t("errors.no_car_name_text"), "warning", 5000);
          return;
        }
        this.isLoadingEditSave = true;
        this.axios
          .patch(
            `/api/v1/cars/${this.car.id}`,
            {
              cars: {
                active: this.car.active,
                car_name: this.car.car_name,
                company_id: this.car.company_id,
                code: this.car.code,
                sort: this.car.sort,
                branch_id: this.car.branch_id,
                number: this.car.number,
                vin: this.car.vin,
                body_number: this.car.body_number,
                pts: this.car.pts,
                registration_certificate: this.car.registration_certificate,
                year: this.car.year,
                transmission: this.car.transmission,
                fuel: this.car.fuel,
                tank_value: this.car.tank_value,
                number_doors: this.car.number_doors,
                engine_capacity: this.car.engine_capacity,
                is_electropackage: this.car.is_electropackage,
                car_type: this.car.car_type,
                car_class: this.car.car_class,
                color: this.car.color,
                is_air: this.car.is_air,
                price_hour: this.car.price_hour || 0,
                deposit: this.car.deposit || 0,
                hourly_deposit: this.car.hourly_deposit || 0,
                weekly_deposit: this.car.weekly_deposit || 0,
                monthly_deposit: this.car.monthly_deposit || 0,
                insurance: this.car.insurance,
                mileage: this.car.mileage,
                start_mileage: this.car.start_mileage,
                diagnostic_card: this.car.diagnostic_card,
                purchase_price: this.car.purchase_price,
                purchase_date: this.car.purchase_date,
                sale_price: this.car.sale_price,
                sale_date: this.car.sale_date,
                tire_size: this.car.tire_size,
                number_seats: this.car.number_seats,
                drive_unit: this.car.drive_unit,
                engine_power: this.car.engine_power,
                airbags: this.car.airbags,
                roof: this.car.roof,
                gas_mileage: this.car.gas_mileage,
                steering_side: this.car.steering_side,
                interior: this.car.interior,
                abs: this.car.abs,
                ebd: this.car.ebd,
                esp: this.car.esp,
                window_lifters: this.car.window_lifters,
                trunk_volume: this.car.trunk_volume,
                description: this.car.description,
                franchise: this.car.franchise,
                max_fine: this.car.max_fine,
                repair_cost: this.car.repair_cost,
                heated_seats: this.car.heated_seats,
                heated_seats_front: this.car.heated_seats_front,
                parktronic: this.car.parktronic,
                parktronic_back: this.car.parktronic_back,
                parktronic_camera: this.car.parktronic_camera,
                wheel_adjustment: this.car.wheel_adjustment,
                wheel_adjustment_full: this.car.wheel_adjustment_full,
                audio_system: this.car.audio_system,
                video_system: this.car.video_system,
                tv_system: this.car.tv_system,
                cd_system: this.car.cd_system,
                usb_system: this.car.usb_system,
                climate_control: this.car.climate_control,
                folding_seats: this.car.folding_seats,
                heated_windshield: this.car.heated_windshield,
                rain_sensor: this.car.rain_sensor,
                beacon_emai: this.car.beacon_emai,
                beacon_phone: this.car.beacon_phone,
                beacon_pin: this.car.beacon_pin,
                extra_mileage_km: this.car.extra_mileage_km,
                extra_mileage_price: this.car.extra_mileage_price,
                age_limit: this.car.age_limit,
                driver_year_limit: this.car.driver_year_limit,
                custom_field_1: this.car.custom_field_1,
                custom_field_2: this.car.custom_field_2,
                custom_field_3: this.car.custom_field_3,
                car_mark_id: this.car.car_mark_id,
                car_model_id: this.car.car_model_id,
                car_generation_id: this.car.car_generation_id,
                car_configuration_id: this.car.car_configuration_id,
                car_modification_id: this.car.car_modification_id,
                car_complectation_id: this.car.car_complectation_id,
                starline_device_id: this.car.starline_device_id,
                wialon_unit_id: this.car.wialon_unit_id,
                autofon_object_id: this.car.autofon_object_id,
                gps_integration_type: this.car.gps_integration_type,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("cars.car_update_title"), this.$t("cars.car_update_text"), "success", 3000);
          })
          .catch((error) => {
            this.isLoadingEditSave = false;
            if (error.response?.status == 406) {
              this.setError(error, this.$t("errors.periods_most_be_equal"));
            } else {
              this.setError(error, this.$t("errors.update_car"));
            }
            console.log(error);
          })
          .finally(() => (this.isLoadingEditSave = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveBookingState(state, id) {
      if (this.isStaff) {
        if ((state, id)) {
          if (refuseRidedState(this, findBookingIn(id, this.bookings), state)) return;
          if (state == "Отъездила" || state == "Активная") {
            this.$notify(this.$t("errors.warning_title"), this.$t("bookings_states.select_state_warning_active_rided"), "warning", 3000);
          }
          this.updatingBookingId = id;
          this.isLoadingSaveBookingState = true;
          this.axios
            .patch(
              `/api/v1/bookings/${id}`,
              {
                bookings: {
                  state: state,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              let foundIndex = this.bookings.findIndex(
                (element) => element.id === id
              );
              if (foundIndex >= 0 && this.bookings && Array.isArray(this.bookings)) {
                this.bookings[foundIndex].state = state;
              }
              // FT-116: подсветка календаря живёт в кеше по месяцам, и смена состояния
              // брони (например на «Отъездила») меняет её цвет. Без перезагрузки календарь
              // показывал бы машину занятой, когда она уже свободна.
              this.resetCalendarCache();
              this.loadCalendarSlice(this.currentCalendarRange());
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_state"));
            })
            .finally(() => (this.isLoadingSaveBookingState = false, this.updatingBookingId = null));
        } else {
          this.$notify(this.$t("errors.select_state"), this.error, "error", 3000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deleteCarDoc(name) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.axios
              .delete(`/api/v1/cars_doc_templates/${name}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then(() => {
                if (this.$i18n.locale == "ru") {
                  this.cars_doc_template_url =
                    "https://web.rentprog.ru/doc_example.docx";
                } else {
                  this.cars_doc_template_url =
                    "https://web.rentprog.com/doc_example_en.docx";
                }
                this.cars_doc_template_id = null;
                this.$notify(this.$t("custom.deleted"), this.$t("other.delete_file"), "success", 2000);
              })
              .catch((error) =>
                this.setError(error, this.$t("errors.delete_file"))
              );
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deleteCarEntityDoc(name) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.axios
              .delete(`/api/v1/cars_entity_doc_templates/${name}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then(() => {
                if (this.$i18n.locale == "ru") {
                  this.cars_entity_doc_template_url =
                    "https://web.rentprog.ru/entity_doc_example.docx";
                } else {
                  this.cars_entity_doc_template_url =
                    "https://web.rentprog.com/entity_doc_example_en.docx";
                }
                this.cars_entity_doc_template_id = null;
                this.$notify(this.$t("custom.deleted"), this.$t("other.delete_file"), "success", 2000);
              })
              .catch((error) =>
                this.setError(error, this.$t("errors.delete_file"))
              );
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateCarState(id, state) {
      if (this.isStaff) {
        if ((id, state)) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/cars/${id}`,
              {
                cars: {
                  state: state,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.state = state;
              this.$notify(this.$t("cars.state_update"), "", "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.car_state"));
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    addPrice() {
      let values = [];
      this.showAddPriceBtn = false;
      this.periods.forEach((period) => {
        values.push(0);
      });
      // для дефолтных цен
      values.push(0);
      let seasons_ids = [];
      this.car.prices.forEach((price) => {
        price.season_id;
      });
      this.car.prices.push({
        car_id: this.car.id,
        season_id: null,
        values: values,
      });
    },
    addHourlyPrice() {
      let values = [];
      this.showAddHourlyPriceBtn = false;
      this.periodsHourly.forEach((period) => {
        values.push(0);
      });
      // для дефолтных цен
      values.push(0);
      let seasons_ids = [];
      this.car.hourly_prices.forEach((price) => {
        price.season_id;
      });
      this.car.hourly_prices.push({
        car_id: this.car.id,
        season_id: null,
        values: values,
      });
    },
    addWeeklyPrice() {
      let values = [];
      this.showAddWeeklyPriceBtn = false;
      this.periodsWeekly.forEach((period) => {
        values.push(0);
      });
      // для дефолтных цен
      values.push(0);
      let seasons_ids = [];
      this.car.weekly_prices.forEach((price) => {
        price.season_id;
      });
      this.car.weekly_prices.push({
        car_id: this.car.id,
        season_id: null,
        values: values,
      });
    },
    addMonthlyPrice() {
      let values = [];
      this.showAddMonthlyPriceBtn = false;
      this.periodsMonthly.forEach((period) => {
        values.push(0);
      });
      // для дефолтных цен
      values.push(0);
      let seasons_ids = [];
      this.car.monthly_prices.forEach((price) => {
        price.season_id;
      });
      this.car.monthly_prices.push({
        car_id: this.car.id,
        season_id: null,
        values: values,
      });
    },
    saveNewPrices() {
      if (this.isStaff) {
        //  Check if all prices are filled
        let isFilled = true;
        Object.values(this.createPricesInput).forEach((value, index) => {
          // в последнем индексе всегда season_id поэтому без null
          if (value == 0 || value == "") {
            isFilled = false;
          }
        });
        if (isFilled) {
          this.isLoading = true;
          let index_periods = [];
          let prices_values = [];
          Object.keys(this.createPricesInput).forEach((key) => {
            if (key != "season_id") {
              index_periods.push(key);
            }
          });
          index_periods.forEach((index) => {
            prices_values.push(this.createPricesInput[index]);
          });

          this.axios
            .post(
              "/api/v1/prices",
              {
                prices: {
                  car_id: this.car.id,
                  season_id: this.createPricesInput.season_id
                    ? this.createPricesInput.season_id
                    : "",
                  values: prices_values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.prices.pop();
              this.car.prices.push(response.data);
              this.createPricesInput = {};
              this.refreshPriceGroup();
              this.showAddPriceBtn = true;
              // если у нас только основные цены, то добавляем сезоны в селект
              if (this.car.prices.length == 1) {
                this.seasons.forEach((season) => {
                  this.select_seasons.push({
                    season_id: season.id,
                    value: `${season.start_date} - ${season.end_date}`,
                  });
                });
              }

              this.$notify(this.$t("cars.create_prices_title"), this.$t("cars.create_prices_text"), "success");
            })
            .catch((error) => this.setError(error, this.$t("errors.save_prices")))
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.save_prices"), this.$t("errors.fill_all_prices"), "error", 5000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveNewHourlyPrices() {
      if (this.isStaff) {
        //  Check if all prices are filled
        let isFilled = true;
        Object.values(this.createHourlyPricesInput).forEach((value, index) => {
          // в последнем индексе всегда season_id поэтому без null
          if (value == 0 || value == "") {
            isFilled = false;
          }
        });
        if (isFilled) {
          this.isLoading = true;
          let index_periods = [];
          let prices_values = [];
          Object.keys(this.createHourlyPricesInput).forEach((key) => {
            if (key != "season_id") {
              index_periods.push(key);
            }
          });
          index_periods.forEach((index) => {
            prices_values.push(this.createHourlyPricesInput[index]);
          });

          this.axios
            .post(
              "/api/v1/hourly_prices",
              {
                hourly_prices: {
                  car_id: this.car.id,
                  season_id: this.createHourlyPricesInput.season_id
                    ? this.createHourlyPricesInput.season_id
                    : "",
                  values: prices_values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.hourly_prices.pop();
              this.car.hourly_prices.push(response.data);
              this.createHourlyPricesInput = {};
              this.refreshPriceGroup();
              this.showAddHourlyPriceBtn = true;

              this.$notify(this.$t("cars.create_prices_title"), this.$t("cars.create_prices_text"), "success");
            })
            .catch((error) => this.setError(error, this.$t("errors.save_prices")))
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.save_prices"), this.$t("errors.fill_all_prices"), "error", 5000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveNewWeeklyPrices() {
      if (this.isStaff) {
        //  Check if all prices are filled
        let isFilled = true;
        Object.values(this.createWeeklyPricesInput).forEach((value, index) => {
          // в последнем индексе всегда season_id поэтому без null
          if (value == 0 || value == "") {
            isFilled = false;
          }
        });
        if (isFilled) {
          this.isLoading = true;
          let index_periods = [];
          let prices_values = [];
          Object.keys(this.createWeeklyPricesInput).forEach((key) => {
            if (key != "season_id") {
              index_periods.push(key);
            }
          });
          index_periods.forEach((index) => {
            prices_values.push(this.createWeeklyPricesInput[index]);
          });

          this.axios
            .post(
              "/api/v1/weekly_prices",
              {
                weekly_prices: {
                  car_id: this.car.id,
                  season_id: this.createWeeklyPricesInput.season_id
                    ? this.createWeeklyPricesInput.season_id
                    : "",
                  values: prices_values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.weekly_prices.pop();
              this.car.weekly_prices.push(response.data);
              this.createWeeklyPricesInput = {};
              this.showAddWeeklyPriceBtn = true;

              this.$notify(this.$t("cars.create_prices_title"), this.$t("cars.create_prices_text"), "success");
            })
            .catch((error) => this.setError(error, this.$t("errors.save_prices")))
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.save_prices"), this.$t("errors.fill_all_prices"), "error", 5000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveNewMonthlyPrices() {
      if (this.isStaff) {
        //  Check if all prices are filled
        let isFilled = true;
        Object.values(this.createMonthlyPricesInput).forEach((value, index) => {
          // в последнем индексе всегда season_id поэтому без null
          if (value == 0 || value == "") {
            isFilled = false;
          }
        });
        if (isFilled) {
          this.isLoading = true;
          let index_periods = [];
          let prices_values = [];
          Object.keys(this.createMonthlyPricesInput).forEach((key) => {
            if (key != "season_id") {
              index_periods.push(key);
            }
          });
          index_periods.forEach((index) => {
            prices_values.push(this.createMonthlyPricesInput[index]);
          });

          this.axios
            .post(
              "/api/v1/monthly_prices",
              {
                monthly_prices: {
                  car_id: this.car.id,
                  season_id: this.createMonthlyPricesInput.season_id
                    ? this.createMonthlyPricesInput.season_id
                    : "",
                  values: prices_values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.monthly_prices.pop();
              this.car.monthly_prices.push(response.data);
              this.createMonthlyPricesInput = {};
              this.showAddMonthlyPriceBtn = true;

              this.$notify(this.$t("cars.create_prices_title"), this.$t("cars.create_prices_text"), "success");
            })
            .catch((error) => this.setError(error, this.$t("errors.save_prices")))
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.save_prices"), this.$t("errors.fill_all_prices"), "error", 5000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    getSeasonValue(season_id) {
      if (this.seasons.find((season) => season.id == season_id)) {
        let season = this.seasons.find((season) => season.id == season_id);
        return `${season.start_date} - ${season.end_date}`;
      } else if (season_id == null) {
        return this.$t("cars.main_prices");
      }
    },
    showNewPrice(price, index) {
      this.editedPrice.season_id = price.season_id;
      this.editedPrice.price_id = price.id;
      this.editedPrice.period = index;
      this.editedPrice.values = price.values;
      this.editedPrice.value = price.values[index];
      this.edit_price_dialog = true;
    },
    showNewHourlyPrice(price, index) {
      this.editedHourlyPrice.season_id = price.season_id;
      this.editedHourlyPrice.price_id = price.id;
      this.editedHourlyPrice.period = index;
      this.editedHourlyPrice.values = price.values;
      this.editedHourlyPrice.value = price.values[index];
      this.edit_hourly_price_dialog = true;
    },
    showNewWeeklyPrice(price, index) {
      this.editedWeeklyPrice.season_id = price.season_id;
      this.editedWeeklyPrice.price_id = price.id;
      this.editedWeeklyPrice.period = index;
      this.editedWeeklyPrice.values = price.values;
      this.editedWeeklyPrice.value = price.values[index];
      this.edit_weekly_price_dialog = true;
    },
    showNewMonthlyPrice(price, index) {
      this.editedMonthlyPrice.season_id = price.season_id;
      this.editedMonthlyPrice.price_id = price.id;
      this.editedMonthlyPrice.period = index;
      this.editedMonthlyPrice.values = price.values;
      this.editedMonthlyPrice.value = price.values[index];
      this.edit_monthly_price_dialog = true;
    },
    saveEditedPrice() {
      if (this.isStaff) {
        if (this.editedPrice.value && this.editedPrice.value != "" && this.editedPrice.value != null && this.editedPrice.value != " " && typeof (this.editedPrice.value) == "number" && !isNaN(this.editedPrice.value)) {
          let self = this;
          this.isLoading = true;
          this.editedPrice.values.splice(
            this.editedPrice.period,
            1,
            this.editedPrice.value
          );
          this.axios
            .patch(
              `/api/v1/prices/${self.editedPrice.price_id}`,
              {
                prices: {
                  values: self.editedPrice.values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.prices
                .find((price) => price.id == this.editedPrice.price_id)
                .values.splice(
                  self.editedPrice.period,
                  1,
                  self.editedPrice.value
                );
              this.$notify(this.$t("cars.update_price"), this.$t("cars.update_price_success"), "success");
              this.refreshPriceGroup();
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_prices"));
            })
            .finally(
              () => (
                (this.editedPrice = {}),
                (this.edit_price_dialog = false),
                (this.isLoading = false)
              )
            );
        } else {
          this.$notify(this.$t("errors.add_price_value"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveEditedHourlyPrice() {
      if (this.isStaff) {
        if (this.editedHourlyPrice.value && this.editedHourlyPrice.value != "" && this.editedHourlyPrice.value != null && this.editedHourlyPrice.value != " " && typeof (this.editedHourlyPrice.value) == "number" && !isNaN(this.editedHourlyPrice.value)) {
          let self = this;
          this.isLoading = true;
          this.editedHourlyPrice.values.splice(
            this.editedHourlyPrice.period,
            1,
            this.editedHourlyPrice.value
          );
          this.axios
            .patch(
              `/api/v1/hourly_prices/${self.editedHourlyPrice.price_id}`,
              {
                hourly_prices: {
                  values: self.editedHourlyPrice.values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.hourly_prices
                .find((price) => price.id == this.editedHourlyPrice.price_id)
                .values.splice(
                  self.editedHourlyPrice.period,
                  1,
                  self.editedHourlyPrice.value
                );
              this.$notify(this.$t("cars.update_price"), this.$t("cars.update_price_success"), "success");
              this.refreshPriceGroup();
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_prices"));
            })
            .finally(
              () => (
                (this.editedHourlyPrice = {}),
                (this.edit_hourly_price_dialog = false),
                (this.isLoading = false)
              )
            );
        } else {
          this.$notify(this.$t("errors.add_price_value"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveEditedWeeklyPrice() {
      if (this.isStaff) {
        if (this.editedWeeklyPrice.value && this.editedWeeklyPrice.value != "" && this.editedWeeklyPrice.value != null && this.editedWeeklyPrice.value != " " && typeof (this.editedWeeklyPrice.value) == "number" && !isNaN(this.editedWeeklyPrice.value)) {
          let self = this;
          this.isLoading = true;
          this.editedWeeklyPrice.values.splice(
            this.editedWeeklyPrice.period,
            1,
            this.editedWeeklyPrice.value
          );
          this.axios
            .patch(
              `/api/v1/weekly_prices/${self.editedWeeklyPrice.price_id}`,
              {
                weekly_prices: {
                  values: self.editedWeeklyPrice.values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.weekly_prices
                .find((price) => price.id == this.editedWeeklyPrice.price_id)
                .values.splice(
                  self.editedWeeklyPrice.period,
                  1,
                  self.editedWeeklyPrice.value
                );
              this.$notify(this.$t("cars.update_price"), this.$t("cars.update_price_success"), "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_prices"));
            })
            .finally(
              () => (
                (this.editedWeeklyPrice = {}),
                (this.edit_weekly_price_dialog = false),
                (this.isLoading = false)
              )
            );
        } else {
          this.$notify(this.$t("errors.add_price_value"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveEditedMonthlyPrice() {
      if (this.isStaff) {
        if (this.editedMonthlyPrice.value && this.editedMonthlyPrice.value != "" && this.editedMonthlyPrice.value != null && this.editedMonthlyPrice.value != " " && typeof (this.editedMonthlyPrice.value) == "number" && !isNaN(this.editedMonthlyPrice.value)) {
          let self = this;
          this.isLoading = true;
          this.editedMonthlyPrice.values.splice(
            this.editedMonthlyPrice.period,
            1,
            this.editedMonthlyPrice.value
          );
          this.axios
            .patch(
              `/api/v1/monthly_prices/${self.editedMonthlyPrice.price_id}`,
              {
                monthly_prices: {
                  values: self.editedMonthlyPrice.values,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.car.monthly_prices
                .find((price) => price.id == this.editedMonthlyPrice.price_id)
                .values.splice(
                  self.editedMonthlyPrice.period,
                  1,
                  self.editedMonthlyPrice.value
                );
              this.$notify(this.$t("cars.update_price"), this.$t("cars.update_price_success"), "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.update_prices"));
            })
            .finally(
              () => (
                (this.editedMonthlyPrice = {}),
                (this.edit_monthly_price_dialog = false),
                (this.isLoading = false)
              )
            );
        } else {
          this.$notify(this.$t("errors.add_price_value"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    showAudits(price) {
      this.show_audited_price_dialog = true;
      this.audited_prices = price.audits;
    },
    deleteItem(car) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("cars.delete_warning"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.axios
              .delete(`/api/v1/cars/${car.id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then(() => {
                this.$router.push({ path: `/vehicles/list` }).catch((err) => { });
                this.$notify(this.$t("custom.deleted"), this.$t("cars.delete_success"), "success");
              })
              .catch((error) => {
                // check if error is 406
                if (error.response?.status == 406) {
                  this.$notify(this.$t("errors.delete_car"), this.$t("errors.delete_car_has_bookings"), "error", 5000);
                } else {
                  this.setError(error, this.$t("errors.delete_car"));
                }
              })
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    getAnaliticsDataForRange() {
      if (this.start_date && this.end_date) {
        this.isLoading = true;
        let self = this;
        this.axios
          .get(
            `/api/v1/car_analitics?id=${this.$route.params.id}&start_date=${this.start_date}&end_date=${this.end_date}`,
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            if (response.data.income_rub || response.data.expences_rub) {
              this.analitics_data = response.data;
              // (this.income_expences_chart_data = [
              //   [this.$t("custom.income"), this.$t("custom.expences")],
              // ]),
              //   this.income_expences_chart_data.push([
              //     this.$t("custom.income"),
              //     this.analitics_data.income_rub,
              //   ]);
              // this.income_expences_chart_data.push([
              //   this.$t("custom.expences"),
              //   this.analitics_data.expences_rub,
              // ]);
              this.chartDataExpences = {
                labels: [this.$t("custom.income"), this.$t("custom.expences")],
                datasets: [
                  {
                    backgroundColor: ['#41B883', '#E46651'],
                    data: [this.analitics_data.income_rub, this.analitics_data.expences_rub]
                  }
                ]
              }
              this.selected_group = [
                "Оплата аренды",
                "Ремонт",
                "Обслуживание",
                "Запчасти",
                "Страховка",
              ];
            } else {
              this.analitics_data = [];
              this.chartDataExpences = {
                labels: [this.$t("custom.income"), this.$t("custom.expences")],
                datasets: [
                  {
                    backgroundColor: ['#41B883', '#E46651'],
                    data: [0, 0]
                  }
                ]
              }
              this.$notify(this.$t("errors.not_enough_data"), this.$t("errors.not_enough_car_data"), "warning");
            }
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.load_counts"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.isLoading = true;
        let self = this;
        this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
        this.end_date = moment().format("YYYY-MM-DD");
        this.axios
          .get(`/api/v1/car_analitics?id=${this.$route.params.id}&start_date=${this.start_date}&end_date=${this.end_date}&company_cashbox_id=${this.company_cashbox_id_analitics}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (response.data.income_rub || response.data.expences_rub) {
              this.analitics_data = response.data;
              // (this.income_expences_chart_data = [
              //   [this.$t("custom.income"), this.$t("custom.expences")],
              // ]),
              //   this.income_expences_chart_data.push([
              //     this.$t("custom.income"),
              //     this.analitics_data.income_rub,
              //   ]);
              // this.income_expences_chart_data.push([
              //   this.$t("custom.expences"),
              //   this.analitics_data.expences_rub,
              // ]);
              this.chartDataExpences = {
                labels: [this.$t("custom.income"), this.$t("custom.expences")],
                datasets: [
                  {
                    backgroundColor: ['#41B883', '#E46651'],
                    data: [this.analitics_data.income_rub, this.analitics_data.expences_rub]
                  }
                ]
              }
              this.selected_group = [
                "Оплата аренды",
                "Ремонт",
                "Обслуживание",
                "Запчасти",
                "Страховка",
              ];
            } else {
              this.$notify(this.$t("errors.not_enough_data"), this.$t("errors.not_enough_car_data"), "warning");
            }
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.load_counts"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      }
    },
    updateDaysStemp() {
      if (this.maintenance.next_maintenance_date && this.maintenance.last_maintenanced_date) {
        this.maintenance.days_step = moment(this.maintenance.next_maintenance_date).diff(moment(this.maintenance.last_maintenanced_date), 'days')
      }
    },
    // Поля маяка уходят в запросе: кнопку жмут до «Сохранить», а сервер без них брал
    // пустой IMEI из базы (машина 60809, 30.09.2026). traccar_id — из ответа сервера:
    // фиктивный 999999 показывал «подключено», даже когда Traccar отказал.
    addCarToTraccar(car_id) {
      if (this.isStaff) {
        if (this.car.beacon_emai && this.car.beacon_phone) {
          this.isLoading = true;
          this.axios
            .post(
              `/api/v1/create_device_in_traccar`,
              {
                id: car_id,
                beacon_emai: this.car.beacon_emai,
                beacon_phone: this.car.beacon_phone,
                beacon_pin: this.car.beacon_pin,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              const data = response && response.data;
              if (data && data.pending) {
                this.$notify(this.$t("cars.traccar_pending"), "", "info");
                return;
              }
              // Старый API отвечает "ok" без traccar_id — прежнее поведение до его выкатки.
              this.car.traccar_id = (data && data.traccar_id) || 999999;
              this.$notify(this.$t("cars.added_to_traccar"), "", "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.not_enough_data"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    removeDeviceFromTraccar(car_id) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("cars.traccar_remove_warning"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            this.axios
              .post(
                `/api/v1/remove_device_from_traccar`,
                {
                  id: car_id,
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then(() => {
                this.car.traccar_id = null;
                this.$notify(this.$t("custom.deleted"), "", "success");
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.error"));
              })
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // StarLine методы
    async loadStarlineDevices() {
      if (this.isLoadingStarlineDevices) return;
      this.isLoadingStarlineDevices = true;
      try {
        const response = await this.axios.get('/api/v1/starline/devices', {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        this.starlineDevices = (response.data.devices || []).map(device => ({
          ...device,
          displayName: device.alias ? `${device.alias} (${device.id})` : `Device ${device.id}`
        }));
        if (response.data.error && this.starlineDevices.length === 0) {
          this.$notify(response.data.error, "", "warning");
        }
      } catch (error) {
        this.setError(error, this.$t('starline.load_devices_error'));
      } finally {
        this.isLoadingStarlineDevices = false;
      }
    },
    getStarlineDeviceDisplayName(deviceId) {
      // Пробуем найти устройство в загруженном списке
      const device = this.starlineDevices.find(d => d.id === deviceId);
      if (device) {
        return device.alias ? `${device.alias} (${device.id})` : `Device ${device.id}`;
      }
      // Если списка нет - показываем просто ID
      return `Device ID: ${deviceId}`;
    },
    async startEditingStarlineDevice() {
      this.isEditingStarlineDevice = true;
      // Загружаем список устройств если ещё не загружен
      if (this.starlineDevices.length === 0) {
        await this.loadStarlineDevices();
      }
    },
    cancelEditingStarlineDevice() {
      this.isEditingStarlineDevice = false;
    },
    onStarlineDeviceSelected() {
      // При выборе устройства выходим из режима редактирования
      if (this.car.starline_device_id) {
        this.isEditingStarlineDevice = false;
      }
    },
    // Wialon методы
    async loadWialonUnits() {
      if (this.isLoadingWialonUnits) return;
      this.isLoadingWialonUnits = true;
      try {
        const response = await this.axios.get('/api/v1/wialon/units', {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        if (response.data.units) {
          this.wialonUnits = response.data.units;
        }
        if (response.data.error && this.wialonUnits.length === 0) {
          this.$notify(response.data.error, "", "warning");
        }
      } catch (error) {
        this.setError(error, this.$t('wialon.load_units_error'));
      } finally {
        this.isLoadingWialonUnits = false;
      }
    },
    getWialonUnitDisplayName(unitId) {
      const unit = this.wialonUnits.find(u => u.id == unitId);
      if (unit) {
        return unit.name || `Unit ${unit.id}`;
      }
      return `Unit ID: ${unitId}`;
    },
    async startEditingWialonUnit() {
      this.isEditingWialonUnit = true;
      if (this.wialonUnits.length === 0) {
        await this.loadWialonUnits();
      }
    },
    cancelEditingWialonUnit() {
      this.isEditingWialonUnit = false;
    },
    onWialonUnitSelected() {
      if (this.car.wialon_unit_id) {
        this.isEditingWialonUnit = false;
      }
    },
    // AutoFon методы
    async loadAutofonObjects() {
      if (this.isLoadingAutofonObjects) return;
      this.isLoadingAutofonObjects = true;
      try {
        const response = await this.axios.get('/api/v1/autofon/objects', {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        if (response.data.objects) {
          this.autofonObjects = response.data.objects;
        }
        if (response.data.error && this.autofonObjects.length === 0) {
          this.$notify(response.data.error, "", "warning");
        }
      } catch (error) {
        this.setError(error, this.$t('autofon.load_objects_error'));
      } finally {
        this.isLoadingAutofonObjects = false;
      }
    },
    getAutofonObjectDisplayName(objectId) {
      const obj = this.autofonObjects.find(o => o.id == objectId);
      if (obj) {
        return obj.name || `Object ${obj.id}`;
      }
      return `Object ID: ${objectId}`;
    },
    async startEditingAutofonObject() {
      this.isEditingAutofonObject = true;
      if (this.autofonObjects.length === 0) {
        await this.loadAutofonObjects();
      }
    },
    cancelEditingAutofonObject() {
      this.isEditingAutofonObject = false;
    },
    onAutofonObjectSelected() {
      if (this.car.autofon_object_id) {
        this.isEditingAutofonObject = false;
      }
    },
    updateCarData() {
      // Обновить данные машины после изменения пробега
      this.axios
        .get(`/api/v1/cars/${this.car.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.car.mileage = response.data.data.attributes.mileage;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        });
    },
    get_total_distance() {
      let self = this
      let email = this.$store.getters.getCurrentUser.email;
      let traccar_password = this.$store.getters.getCurrentUser.traccar_password;
      let data = new URLSearchParams({
        "email": email,
        "password": traccar_password
      })
      // authorization in socket
      let session_url = "https://vos-rentprog.ru/api/session"
      let new_session_resp = this.axios({
        method: "post",
        url: session_url,
        headers: {
          "Authorization": "Basic " + btoa(`${email}:${traccar_password}`),
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: data
      })
        .then(response => {
          this.isLoading = true;
          let from = moment().subtract(100, 'years').format('YYYY-MM-DDTHH:mm:ss') + 'Z'
          let to = moment().format('YYYY-MM-DDTHH:mm:ss') + 'Z'
          let report_url = `https://vos-rentprog.ru/api/reports/summary?deviceId=${[this.car.traccar_id]}&from=${from}&to=${to}`
          this.axios({
            method: "get",
            url: report_url,
            headers: {
              "Authorization": "Basic " + btoa(`${email}:${traccar_password}`),
              "Content-Type": "application/x-www-form-urlencoded"
            },
          })
            .then(report_response => {
              console.log(report_response.data)
              this.report = report_response.data[0];
              // переводим узлы в км
              this.report.distance = this.report.distance / 1852
              this.report.maxSpeed = this.report.maxSpeed * 1.852
              this.report.averageSpeed = this.report.averageSpeed * 1.852
              this.showReportDialog = true;
            })
            .catch(error => {
              this.isLoading = false;
              this.setError(error, this.$t('errors.beacon_load'));
              console.log(error);
            })
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error)
        })
        .finally(() => (this.isLoading = false));
    },
    getCurrentPosition() {
      this.isLoading = true;
      this.latitude = null;
      this.longitude = null;

      let self = this
      let email = this.$store.getters.getCurrentUser.email;
      let traccar_password = this.$store.getters.getCurrentUser.traccar_password;
      let data = new URLSearchParams({
        "email": email,
        "password": traccar_password
      })
      // authorization in socket
      let session_url = "https://vos-rentprog.ru/api/session"
      let new_session_resp = this.axios({
        method: "post",
        url: session_url,
        headers: {
          "Authorization": "Basic " + btoa(`${email}:${traccar_password}`),
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: data
      })
        .then(response => {
          let position_url = `https://vos-rentprog.ru/api/positions?deviceId=${this.car.traccar_id}`
          this.axios({
            method: "get",
            url: position_url,
            headers: {
              "Authorization": "Basic " + btoa(`${email}:${traccar_password}`),
              "Content-Type": "application/x-www-form-urlencoded"
            },
          })
            .then(position_response => {
              this.latitude = position_response.data[0].latitude
              this.longitude = position_response.data[0].longitude
              this.showCurrentPositionDialog = true;
            })
            .catch(error => {
              this.isLoading = false;
              this.setError(error, this.$t('errors.beacon_load'));
              console.log(error);
            })
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error)
        })
        .finally(() => (this.isLoading = false));
    },
    reportTitle(report) {
      if (report) {
        if (report && report.deviceName) {
          return `ID${report.deviceId} ${report.deviceName}`
        } else {
          return `${report.deviceId}`
        }
      } else {
        return ""
      }
    },
    update_total_distance() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .post(
            `/api/v1/update_total_distance`,
            {
              car_id: this.car.id,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.updated"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    translateCategory(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    translateBodyType(body_type) {
      let transtation_body_type = ""
      // Для перевода
      switch (body_type) {
        case 'купе':
          transtation_body_type = this.$t('car_base_ru.COUPE')
          break;
        case 'купе-хардтоп':
          transtation_body_type = this.$t('car_base_ru.COUPE_HARDTOP')
          break;
        case 'родстер':
          transtation_body_type = this.$t('car_base_ru.ROADSTER')
          break;
        case 'тарга':
          transtation_body_type = this.$t('car_base_ru.TARGA')
          break;
        case 'спидстер':
          transtation_body_type = this.$t('car_base_ru.SPEEDSTER')
          break;
        case 'седан':
          transtation_body_type = this.$t('car_base_ru.SEDAN')
          break;
        case 'седан 2 дв.':
          transtation_body_type = this.$t('car_base_ru.SEDAN_2_DOORS')
          break;
        case 'лифтбек':
          transtation_body_type = this.$t('car_base_ru.LIFTBACK')
          break;
        case 'седан-хардтоп':
          transtation_body_type = this.$t('car_base_ru.SEDAN_HARDTOP')
          break;
        case 'хэтчбек 3 дв.':
          transtation_body_type = this.$t('car_base_ru.HATCHBACK_3_DOORS')
          break;
        case 'хэтчбек 5 дв.':
          transtation_body_type = this.$t('car_base_ru.HATCHBACK_5_DOORS')
          break;
        case 'хэтчбек 4 дв.':
          transtation_body_type = this.$t('car_base_ru.HATCHBACK_4_DOORS')
          break;
        case 'внедорожник 5 дв.':
          transtation_body_type = this.$t('car_base_ru.ALLROAD_5_DOORS')
          break;
        case 'внедорожник 3 дв.':
          transtation_body_type = this.$t('car_base_ru.ALLROAD_3_DOORS')
          break;
        case 'внедорожник открытый':
          transtation_body_type = this.$t('car_base_ru.ALLROAD_OPEN')
          break;
        case 'универсал':
          transtation_body_type = this.$t('car_base_ru.WAGON')
          break;
        case 'универсал 5 дв.':
          transtation_body_type = this.$t('car_base_ru.WAGON_5_DOORS')
          break;
        case 'универсал 3 дв.':
          transtation_body_type = this.$t('car_base_ru.WAGON_3_DOORS')
          break;
        case 'кабриолет':
          transtation_body_type = this.$t('car_base_ru.CABRIO')
          break;
        case 'минивэн':
          transtation_body_type = this.$t('car_base_ru.MINIVAN')
          break;
        case 'микровэн':
          transtation_body_type = this.$t('car_base_ru.MICROVAN')
          break;
        case 'компактвэн':
          transtation_body_type = this.$t('car_base_ru.COMPACTVAN')
          break;
        case 'фургон':
          transtation_body_type = this.$t('car_base_ru.VAN')
          break;
        case 'пикап':
          transtation_body_type = this.$t('car_base_ru.PICKUP')
          break;
        case 'пикап одинарная кабина':
          transtation_body_type = this.$t('car_base_ru.PICKUP_ONE')
          break;
        case 'пикап полуторная кабина':
          transtation_body_type = this.$t('car_base_ru.PICKUP_ONE_HALF')
          break;
        case 'пикап двойная кабина':
          transtation_body_type = this.$t('car_base_ru.PICKUP_TWO')
          break;
        case 'лимузин':
          transtation_body_type = this.$t('car_base_ru.LIMOUSINE')
          break;
        case 'фаэтон':
          transtation_body_type = this.$t('car_base_ru.PHAETON')
          break;
        default:
          break;
      }
      return transtation_body_type;
    },
    translateTransmission(transmission) {
      let transtation_transmission = ""
      // Для перевода
      switch (transmission) {
        case 'механическая':
          transtation_transmission = this.$t('car_base_ru.MECHANICAL')
          break;
        case 'автоматическая':
          transtation_transmission = this.$t('car_base_ru.AUTOMATIC')
          break;
        case 'робот':
          transtation_transmission = this.$t('car_base_ru.ROBOT')
          break;
        case 'вариатор':
          transtation_transmission = this.$t('car_base_ru.VARIATOR')
          break;
        default:
          break;
      }
      return transtation_transmission;
    },
    translateFuel(fuel) {
      let transtation_fuel = ""
      // Для перевода
      switch (fuel) {
        case 'бензин':
          transtation_fuel = this.$t('car_base_ru.GASOLINE')
          break;
        case 'электро':
          transtation_fuel = this.$t('car_base_ru.ELECTRO')
          break;
        case 'дизель':
          transtation_fuel = this.$t('car_base_ru.DIESEL')
          break;
        case 'гибрид':
          transtation_fuel = this.$t('car_base_ru.HYBRID')
          break;
        case 'СУГ':
          transtation_fuel = this.$t('car_base_ru.LPG')
          break;
        default:
          break;
      }
      return transtation_fuel;
    },
    showApplicationToBooking() {
      if (this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.country == "Russia") {

        if (this.isStaff) {
          this.$confirm({
            title: this.$t("agregator.send_application_to_agregator_title"),
            html: this.$t("agregator.send_application_to_agregator_text"),
            icon: "mdi-alert-circle-outline",
            confirmButtonText: this.$t("agregator.agreement_true"),
            cancelButtonText: this.$t("custom.no"),
          }).then((result) => {
            if (result) {
              this.isLoading = true;
              this.axios
                .post(
                  `/api/v1/request_to_vseprokaty`,
                  {
                    company_id: this.$store.getters.getCompany.company.id,
                  },
                  {
                    headers: {
                      Authorization: this.$store.getters.getAuthToken,
                    },
                  }
                )
                .then((response) => {
                  this.isLoading = false;
                  this.$store.commit("setCompany", { company: response.data });
                  this.$notify(this.$t("agregator.send_application_to_agregator_success"), this.$t("agregator.send_application_to_agregator_success_text"), "success");
                })
                .catch((error) =>
                  this.setError(
                    error,
                    this.$t("agregator.send_application_to_agregator_error")
                  )
                )
                .finally(() => (this.isLoading = false));
            }
          });
        } else {
          this.$notify(this.$t("errors.no_access"), "", "warning");
        }
      } else {
        this.$confirm({
          html: this.$t("agregator.only_russia"),
          icon: "mdi-alert-circle-outline",
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }
    },
    sendToModeration() {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("agregator.send_to_moderation_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            this.axios
              .post(
                `/api/v1/vseprokaty_to_moderation`,
                {
                  car_id: this.car.id,
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then(() => {
                // Поле — ready_for_agregator, как у сервера (Marketplace::ToModeration)
                // и в шаблоне: запись в несуществующее поле оставляла кнопку видимой,
                // и повтор получал 422 car_already_on_marketplace (FT-184 CP-03).
                this.car.ready_for_agregator = true;
                this.isLoading = false;
                this.$notify(this.$t("custom.success"), this.$t("agregator.send_to_moderation_success"), "success");
              })
              .catch((error) =>
                this.setError(
                  error,
                  this.$t("agregator.send_to_moderation_error")
                )
              )
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    withdrawFromPublication() {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("agregator.unpublish_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.yes"),
          cancelButtonText: this.$t("custom.no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            this.axios
              .post(
                `/api/v1/vseprokaty_unpublish`,
                {
                  car_id: this.car.id,
                },
                {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                }
              )
              .then(() => {
                // Как сервер (Marketplace::UnpublishCar): оба флага сброшены.
                this.car.ready_for_agregator = false;
                this.car.in_agregator = false;
                this.isLoading = false;
                this.$notify(this.$t("agregator.unpublished"), this.$t("agregator.unpublished_text"), "success");
              })
              .catch((error) =>
                this.setError(error, this.$t("agregator.unpublished_error"))
              )
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCarBookingSettingInsurance() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .patch(
            `/api/v1/car_booking_setting/${this.$route.params.id}/insurance`,
            {
              insurance: this.booking_insurance,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.save_car"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCarBookingSettingServices() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .patch(
            `/api/v1/car_booking_setting/${this.$route.params.id}/services`,
            {
              services: this.booking_services,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.save_car"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCarBookingSettingFastBooking() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .patch(
            `/api/v1/car_booking_setting/${this.$route.params.id}/fast_booking`,
            {
              fast_booking: this.fast_booking,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.save_car"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveCarBookingSettingDescription() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .patch(
            `/api/v1/car_booking_setting/${this.$route.params.id}/description`,
            {
              description: this.booking_description,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.save_car"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateAvatar(event) {
      console.log("update avatar");
      this.car.avatar_url = event;
    },
    updateTabsData() {
      if (this.cardBootstrapPending || this.cardDisposed) return;
      const sequence = this.tabRequestSequence = (this.tabRequestSequence || 0) + 1;
      const carId = this.$route.params.id;
      const current = () => !this.cardDisposed && sequence === this.tabRequestSequence && String(carId) === String(this.$route.params.id);
      if (!/^\d+$/.test(String(this.$route.params.id))) {
        this.isLoading = false;
        return;
      }
      let self = this;
      if (
        this.tabs == 5 &&
        (this.isAdminPlus || this.isPartner || this.isGuest)
      ) {
        if (this.isPartner) {
          this.checkPartnerAccess(current);
        }
        if (this.isPartner && !this.partner_can_view_booking_card) {
          this.isLoading = false;
          return;
        }
        this.isLoading = true;
        let self = this;
        this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
        this.end_date = moment().format("YYYY-MM-DD");
        this.axios
          .get(`/api/v1/car_analitics?id=${this.$route.params.id}&start_date=${this.start_date}&end_date=${this.end_date}&company_cashbox_id=${this.company_cashbox_id_analitics}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            if (response.data.income_rub || response.data.expences_rub) {
              this.analitics_data = response.data;
              // (this.income_expences_chart_data = [
              //   [this.$t("custom.income"), this.$t("custom.expences")],
              // ]),
              //   this.income_expences_chart_data.push([
              //     this.$t("custom.income"),
              //     this.analitics_data.income_rub,
              //   ]);
              // this.income_expences_chart_data.push([
              //   this.$t("custom.expences"),
              //   this.analitics_data.expences_rub,
              // ]);
              this.chartDataExpences = {
                labels: [this.$t("custom.income"), this.$t("custom.expences")],
                datasets: [
                  {
                    backgroundColor: ['#41B883', '#E46651'],
                    data: [this.analitics_data.income_rub, this.analitics_data.expences_rub]
                  }
                ]
              }
              this.selected_group = [
                "Оплата аренды",
                "Ремонт",
                "Обслуживание",
                "Запчасти",
                "Страховка",
              ];
            } else {
              this.$notify(this.$t("errors.not_enough_data"), this.$t("errors.not_enough_car_data"), "warning");
            }
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.load_counts"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 6) {
        this.isLoading = true;
        let self = this;
        this.axios
          .get(`/api/v1/cars/${this.$route.params.id}/inspections`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.inspections = response.data;
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.inspections_load"));
            console.log(error);
          });
        this.axios
          .get(`/api/v1/get_workers_names_with_ids`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.workers = response.data;
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.employers_load"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 4) {
        this.isLoading = true;
        let self = this;
        this.axios
          .get(`/api/v1/cars_doc_templates/${this.$route.params.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            if (response.data) {
              this.cars_doc_template_url = response.data.url;
              this.cars_doc_template_id = response.data.id;
            } else {
              if (this.$i18n.locale == "ru") {
                this.cars_doc_template_url =
                  "https://web.rentprog.ru/doc_example.docx";
              } else {
                this.cars_doc_template_url =
                  "https://web.rentprog.com/doc_example_en.docx";
              }
            }
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.doc_template_load"));
            console.log(error);
          });

        this.axios
          .get(`/api/v1/cars_entity_doc_templates/${this.$route.params.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            if (response.data) {
              this.cars_entity_doc_template_url = response.data.url;
              this.cars_entity_doc_template_id = response.data.id;
            } else {
              if (this.$i18n.locale == "ru") {
                this.cars_doc_template_url =
                  "https://web.rentprog.ru/entity_doc_example.docx";
              } else {
                this.cars_doc_template_url =
                  "https://web.rentprog.com/entity_doc_example_en.docx";
              }
            }
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.doc_ur_template_load"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 0) {
        // FT-116: вкладка «Брони» больше не выгружает всю историю. Таблица берёт свою
        // страницу, календарь — свой диапазон месяцев; это два независимых запроса.
        //
        // Кеш календаря при КАЖДОМ входе на вкладку сбрасывается. До фичи подсветка
        // строилась заново из свежего массива, и без сброса получилась бы регрессия:
        // пользователь меняет статус брони прямо в таблице, строка обновляется, а календарь
        // до перезагрузки страницы продолжает показывать её прежним цветом — то есть
        // фантомную занятость машины.
        this.calendar_initial_range = null;
        this.resetCalendarCache();
        this.loadBookingsPage();
        this.loadCalendarSlice(this.currentCalendarRange());
      } else if (this.tabs == 7) {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/store_movements_in_car/${this.$route.params.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.movements = response.data.movements;
            this.store_locations = response.data.locations;
            this.store_products = response.data.products;
            this.axios
              .get(`/api/v1/get_workers_names_with_ids`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then((response) => {
                if (!current()) return;
                this.workers = response.data;
              })
              .catch((error) => {
                if (!current()) return;
                this.setError(error, this.$t("errors.employers_load"));
                console.log(error);
              });
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.store_load"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 1) {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/companies`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.branches = response.data;
            // this.axios
            //   .get(`/api/v1/car_base_for_car/${this.car.id}`, {
            //     headers: {
            //       Authorization: this.$store.getters.getAuthToken,
            //     },
            //   })
            //   .then((response) => {
            //     this.car_marks = response.data.car_marks;
            //     this.car_mark = response.data.car_mark;
            //     this.car_model = response.data.car_model;
            //     this.car_generation = response.data.car_generation;
            //     this.car_configuration = response.data.car_configuration;
            //     this.car_modification = response.data.car_modification;
            //   })
            //   .catch((error) => {
            //     this.setError(error, this.$t("errors.error"));
            //     console.log(error);
            //   })
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.branch_load"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 5 && !this.checkAdmin()) {
        if (this.isPartner) {
          this.checkPartnerAccess(current);
        }
        if (this.isPartner && !this.partner_can_view_booking_card) {
          this.isLoading = false;
          return;
        }
        this.isLoading = true;
        let self = this;
        this.axios
          .get(`/api/v1/cars_minus_counts?car_id=${this.$route.params.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.counts = [];
            response.data.data.forEach((count) => {
              self.expences_counts.push(count.attributes);
            });
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.load_counts"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 8) {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/car_booking_setting_v2/${this.$route.params.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.booking_insurance = response.data.settings.insurance;
            this.booking_services = response.data.settings.services;
            this.booking_description = response.data.settings.description;
            this.fast_booking = response.data.settings.fast_booking;
            if (response.data.existing_extras && response.data.existing_extras.length > 0) {
              response.data.existing_extras.forEach((extra) => {
                let extra_index = this.existing_extras.findIndex((item) => item.extra_code == extra.extra_code)
                if (extra_index != -1) {
                  this.existing_extras.splice(extra_index, 1, extra)
                }
              });
            }
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 3) {
        if (this.isPartner && !this.partner_can_view_maintenances) {
          this.isLoading = false;
          return;
        }
        // Обслуживание
        this.isLoading = true;
        this.axios
          .get(`/api/v1/car_maintenances/${this.$route.params.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.all_maintenance_items = response.data;
            this.getWorkersNames(current);
            this.loadContractors(current);
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      } else if (this.tabs == 2) {
        // Цены
        this.isLoading = true;
        this.axios
          .get(`/api/v1/cars_for_car_card`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            if (!current()) return;
            this.cars = [];
            response.data.data.forEach((car) => {
              this.cars.push(car.attributes);
            });
          })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => { if (current()) this.isLoading = false; });
      }
    },
    checkPartnerAccess(current = () => true) {
      if (this.isPartner) {
        this.isLoading = true;
        this.axios.get(`/api/v1/check_partner_access`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        }).then((response) => {
          if (!current()) return;
          if (!response.data.can_view_maintenances) {
            this.partner_can_view_maintenances = false;
          }
          if (!response.data.can_view_booking_card) {
            this.partner_can_view_booking_card = false;
          }
        })
          .catch((error) => {
            if (!current()) return;
            this.setError(error, this.$t("errors.error"));
          })
          .finally(() => { if (current()) this.isLoading = false; });
      }
    },
    closeEditMaintenanceDialog() {
      this.showEditMaintenanceDialog = false;
      this.maintenance = {
        maintenance_type: 0,
        title: null,
        description: null,
        mileage_step: 0,
        days_step: 0,
        last_maintenanced_date: null,
        notify_before: 0,
        criticality: 0,
        responsible: [],
        assign_to_all_cars: false,
        car_id: null,
        car_ids: [],
      }
    },
    getWorkersNames(current = () => true) {
      this.isLoadingResponsible = true;
      this.axios
        .get("/api/v1/get_workers_names_with_ids", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          if (!current()) return;
          this.workers = response.data;
        })
        .catch((error) => {
          if (!current()) return;
          this.setError(error, "Something went wrong in get_workers_names");
          console.log(error);
        })
        .finally(() => { if (current()) this.isLoadingResponsible = false; });
    },
    findWorkersName(ids) {
      let names = [];
      ids.forEach((id) => {
        this.workers.forEach((worker) => {
          if (worker.id == id) {
            names.push(worker.name);
          }
        });
      });
      return names ? names.join(", ") : "";
    },
    findContractorName(id) {
      if (id != null) {
        if (this.contractors.find((contractor) => contractor.id == id)) {
          return this.contractors.find((contractor) => contractor.id == id)
            .short_name;
        }
      } else {
        return "-";
      }
    },
    saveMaintenance() {
      if (this.isStaff) {
        if (this.maintenance.title && this.maintenance.title.length > 0) {
          this.maintenance.car_id = this.car.id;
          this.isLoading = true;
          if (this.maintenance.periodic) {
            this.maintenance.started = false;
          }
          this.axios
            .post("/api/v1/maintenances",
              {
                maintenance: this.maintenance,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
            .then(() => {
              this.$notify(this.$t("maintenance.maintenance_created"), this.$t("maintenance.maintenance_created_text"), "success");
              this.showNewMaintenanceDialog = false;
              this.maintenance = {
                maintenance_type: 0,
                title: null,
                description: null,
                mileage_step: 0,
                days_step: 0,
                last_maintenanced_date: moment().format("YYYY-MM-DD"),
                criticality: 0,
                responsible: [],
                assign_to_all_cars: false,
                car_id: null,
                car_ids: [],
              };
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.maintenance_create"));
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("custom.no_data"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveInsuranceMaintenance() {
      if (this.isStaff) {
        if (this.maintenance.car_id || (this.maintenance.car_ids && this.maintenance.car_ids.length > 0) && this.maintenance.title && this.maintenance.title.length > 0 && this.maintenance.days_step && this.maintenance.days_step > 0) {
          this.isLoading = true;
          if (this.maintenance.last_maintenanced_date == null) {
            this.maintenance.last_maintenanced_date = moment().format("YYYY-MM-DD");
          }
          // remove next_maintenance_date
          delete this.maintenance.next_maintenance_date;
          this.axios
            .post("/api/v1/maintenances",
              {
                maintenance: this.maintenance,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
            .then((response) => {
              this.$notify(this.$t("maintenance.maintenance_created"), this.$t("maintenance.maintenance_created_text"), "success");
              this.showNewMaintenanceDialog = false;
              this.maintenance = {
                maintenance_type: 0,
                title: null,
                description: null,
                mileage_step: 0,
                days_step: 0,
                last_maintenanced_date: moment().format("YYYY-MM-DD"),
                criticality: 0,
                responsible: [],
                assign_to_all_cars: false,
                car_id: null,
                car_ids: [],
              };
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.maintenance_create"));
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("custom.no_data"), "", "warning");
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveEndMaintenance() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/end_maintenance/${this.maintenance.id}`,
            {
              maintenance: {
                completed: true,
                date_completed: moment().format("DD-MM-YYYY"),
                mileage_completed: this.car.mileage,
                whois_ended: this.$store.getters.getCurrentUser.id,
                description: this.maintenance.description,
                days_step: this.maintenance.days_step,
                last_maintenanced_date: this.maintenance.last_maintenanced_date,
                contractor_id: this.maintenance.contractor_id,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
          .then((response) => {
            this.all_maintenance_items.splice(this.all_maintenance_items.indexOf(this.maintenance), 1, response.data);
            this.$notify(this.$t("maintenance.maintenance_ended"), this.$t("maintenance.maintenance_ended_text"), "success");
            this.showEndMaintenanceDialog = false;
            this.maintenance = {
              maintenance_type: 0,
              title: null,
              description: null,
              mileage_step: 0,
              days_step: 0,
              last_maintenanced_date: moment().format("YYYY-MM-DD"),
              notify_before: 0,
              criticality: 0,
              responsible: [],
              assign_to_all_cars: true,
              car_id: null,
              car_ids: [],
            };
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    saveEditMaintenance() {
      if (this.isStaff) {
        this.isLoading = true;
        let maintenance_data = this.maintenance
        if (maintenance_data.started == false) {
          maintenance_data.date_start = null;
        }
        this.axios
          .patch(`/api/v1/maintenances/${this.maintenance.id}`,
            {
              maintenance: maintenance_data,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
          .then((response) => {
            // change maintenance in array
            this.maintenance_items.splice(this.maintenance_items.indexOf(this.maintenance), 1, response.data);
            this.$notify(this.$t("maintenance.maintenance_updated"), this.$t("maintenance.maintenance_updated_text"), "success");
            this.showEditMaintenanceDialog = false;
            this.maintenance = {
              maintenance_type: 0,
              title: null,
              description: null,
              mileage_step: 0,
              days_step: 0,
              last_maintenanced_date: moment().format("YYYY-MM-DD"),
              notify_before: 0,
              criticality: 0,
              responsible: [],
              assign_to_all_cars: true,
              car_id: null,
              car_ids: [],
            };
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.maintenance_create"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    deleteMaintenance(maintenance_id) {
      if (this.isStaff) {
        let self = this;
        this.$confirm({
          title: this.$t("maintenance.delete_maintenance_title"),
          text: this.$t("maintenance.delete_maintenance_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            this.axios
              .delete(`/api/v1/maintenances/${maintenance_id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then(() => {
                this.all_maintenance_items.splice(
                  this.all_maintenance_items.indexOf(
                    this.all_maintenance_items.find(
                      (maintenance) => maintenance.id == maintenance_id
                    )
                  ),
                  1
                );
                this.$notify(this.$t("maintenance.maintenance_deleted"), "", "success");
              })
              .catch((error) =>
                this.setError(error, this.$t("errors.error"))
              )
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    addStartDateToMaintenance(maintenance) {
      let index = this.all_maintenance_items.findIndex((m) => m.id == maintenance.id)
      if (index > -1) {
        this.all_maintenance_items[index].date_start = moment().format("YYYY-MM-DD");
      }
    },
    selectLastMaintenance(last_maintenanced_date, last_maintenanced_mileage) {
      if (last_maintenanced_date && last_maintenanced_mileage && last_maintenanced_mileage > 0) {
        return `${this.formatLastMaintenancedDate(last_maintenanced_date)} (${last_maintenanced_mileage})`;
      } else if (last_maintenanced_date && last_maintenanced_mileage && last_maintenanced_mileage <= 0) {
        return `${this.formatLastMaintenancedDate(last_maintenanced_date)}`;
      } else if (last_maintenanced_date && !last_maintenanced_mileage) {
        return `${this.formatLastMaintenancedDate(last_maintenanced_date)}`;
      } else if (!last_maintenanced_date && last_maintenanced_mileage) {
        return `(${last_maintenanced_mileage})`;
      } else {
        return "-";
      }
    },
    loadContractors(current = () => true) {
      this.isLoadingContractors = true;
      this.axios
        .get(
          `/api/v1/contractors`,
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          if (!current()) return;
          response.data.data.forEach((element) => {
            this.contractors.push(element.attributes);
          });
        })
        .catch((error) => {
          if (!current()) return;
          this.isLoadingContractors = false;
          this.setError(error, this.$t("errors.error"));
          console.log(error);
        })
        .finally(() => { if (current()) this.isLoadingContractors = false; });
    },
    formatLastMaintenancedDate(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD").format("ll");
      } else {
        return null;
      }
    },
    selectCriticalityClass(criticality) {
      if (criticality == 0) {
        return "secondary white--text";
      } else if (criticality == 1) {
        return "warning white--text";
      } else if (criticality == 2) {
        return "error white--text";
      }
    },
    removeService(index) {
      this.booking_services.splice(index, 1);
    },
    addService() {
      this.booking_services.push({
        id: this.booking_services.length + 1,
        name: null,
        price: null,
      });
    },
    findServiceName(id) {
      let service = this.booking_services.find((service) => service.id == id);
      if (service) {
        return service.name;
      } else {
        return "-";
      }
    },
    createOrUpdateExtra(extra) {
      if (this.isStaff) {
        if (extra.id) {
          this.isLoading = true;
          this.axios
            .patch(`/api/v1/extras/${extra.id}`,
              {
                extras: {
                  active: extra.active,
                  total_min: extra.total_min,
                  total_max: extra.total_max,
                  extra_name: extra.extra_name,
                  price: extra.price,
                  extra_type: extra.extra_type,
                  rental_type: extra.rental_type,
                  quantity_max: extra.quantity_max,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
            .then((response) => {
              this.existing_extras.splice(this.existing_extras.indexOf(extra), 1, response.data);

              this.$notify(this.$t("custom.updated"), "", "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"));
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.isLoading = true;
          this.axios
            .post(`/api/v1/extras`, {
              extras: extra,
              car_id: this.car.id,
            },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
            .then((response) => {
              // заменяем на новый объект с id
              this.existing_extras.splice(this.existing_extras.indexOf(extra), 1, response.data);
              this.$notify(this.$t("custom.saved"), "", "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"));
              console.log(error);
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    publicOnLocalRent(published) {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/localrent/car_public`, {
            public: published,
            car_id: this.car.id,
          },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
          .then((response) => {
            // заменяем на новый объект с id
            this.car.in_localrent = published;
            this.$notify(this.$t("custom.saved"), "", "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkPriceInfo() {
      if (
        Object.keys(this.createPricesInput).length >
        this.periods.length + 1
      ) {
        return false;
      } else {
        return true;
      }
    },
    checkHourlyPriceInfo() {
      if (
        Object.values(this.createHourlyPricesInput).length >
        this.periodsHourly.length + 1
      ) {
        return false;
      } else {
        return true;
      }
    },
    checkWeeklyPriceInfo() {
      if (
        Object.values(this.createWeeklyPricesInput).length >
        this.periodsWeekly.length + 1
      ) {
        return false;
      } else {
        return true;
      }
    },
    checkMonthlyPriceInfo() {
      if (
        Object.values(this.createMonthlyPricesInput).length >
        this.periodsMonthly.length + 1
      ) {
        return false;
      } else {
        return true;
      }
    },
    findStoreLocation(id) {
      let location = this.store_locations.find((location) => location.id == id);
      if (location) {
        return location.name;
      } else {
        return "-";
      }
    },
    findStoreProduct(id) {
      let product = this.store_products.find((product) => product.id == id);
      if (product) {
        return product.name;
      } else {
        return "-";
      }
    },
    findProductArticle(id) {
      let product = this.store_products.find((product) => product.id == id);
      if (product) {
        return product.article;
      } else {
        return "-";
      }
    },
    findProductSku(id) {
      let product = this.store_products.find((product) => product.id == id);
      if (product) {
        return product.sku;
      } else {
        return "-";
      }
    },
    filter_products_groups() {
      let filtered_products = this.store_products;
      // this.products.forEach((product) => {
      //   filtered_products.push(product);
      // });
      if (this.filter_store_product_group && !this.show_only_in_stock) {
        filtered_products = this.store_products.filter((product) => {
          return product.group
            .toLowerCase()
            .includes(this.filter_store_product_group.toLowerCase());
        });
      } else if (!this.filter_store_product_group && this.show_only_in_stock) {
        filtered_products = this.store_products.filter((product) => {
          return product.stock_balance > 0;
        });
      } else if (this.filter_store_product_group && this.show_only_in_stock) {
        filtered_products = this.store_products
          .filter((product) => {
            return product.stock_balance > 0;
          })
          .filter((product) => {
            return product.group
              .toLowerCase()
              .includes(this.filter_store_product_group.toLowerCase());
          });
      }
      if (this.filter_cars && this.filter_cars.length > 0) {
        return filtered_products.filter((product) => {
          return product.cars_ids.find((car_id) => {
            return this.filter_cars.includes(car_id);
          });
        });
      }
      return filtered_products;
    },
    countsByKey(counts, key) {
      let filtered_counts_plus = counts.filter(
        (count) => count.group == key && count.operation == true
      );
      let filtered_counts_minus = counts.filter(
        (count) => count.group == key && count.operation == false
      );

      const sumPropertyValue = (items, prop) =>
        items.reduce((a, b) => a + b[prop], 0);
      const plus_total = sumPropertyValue(filtered_counts_plus, "sum");
      const minus_total = sumPropertyValue(filtered_counts_minus, "sum");

      if (plus_total && minus_total) {
        return `+ ${plus_total} | - ${minus_total}`;
      } else if (plus_total && !minus_total) {
        return `+ ${plus_total}`;
      } else if (!plus_total && minus_total) {
        return `- ${minus_total}`;
      } else {
        return 0;
      }
    },
    selectColorGroup(key) {
      if (key == "Оплата аренды") {
        return "success--text";
      } else if (key == "Выплаты партнёрам") {
        return "red--text";
      }
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    // FT-173 REQ-11: кнопка «Оформить выкуп» ведёт в мастер с car_id — та же
    // форма запроса, что читает ContractWizard.vue (prefillCarFromQuery, REQ-02).
    openRentToOwnWizard() {
      this.$router.push({ path: "/rent_to_own/contracts/new", query: { car_id: this.car.id } });
    },
    includedInPlan(service) {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan) {
          if (this.$store.getters.getMainCompany.plan.included_services) {
            // check trial period
            if (this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment()) && service != 'multicashboxes' && service != 'multicurrency') {
              return true;
            }
            return this.$store.getters.getMainCompany.plan.included_services.includes(service);
          }
        }
      }
      return false;
    },
    getStateIcon(state) {
      switch (state) {
        case 'Новая': return 'mdi-new-box'
        case 'Подтверждена': return 'mdi-check-all'
        case 'Не подтверждена': return 'mdi-cellphone-basic'
        case 'В обработке': return 'mdi-autorenew'
        case 'Отказ клиента': return 'mdi-account-remove-outline'
        case 'Нет машин': return 'mdi-car-off'
        case 'Недозвон': return 'mdi-phone-off-outline'
        case 'Ожидает ответа клиента': return 'mdi-account-question-outline'
        case 'Ожидает оплаты': return 'mdi-currency-usd-off'
        case 'Активная': return 'mdi-alpha-a-circle-outline'
        case 'Отмена': return 'mdi-cancel'
        case 'Отъездила': return 'mdi-garage-variant'
        case 'Вернуть залог': return 'mdi-keyboard-return'
        default: return 'mdi-head-question-outline'
      }
    },
    getStateTooltip(state) {
      const translations = {
        'Новая': this.$t('bookings_states.new'),
        'В обработке': this.$t('bookings_states.in_work'),
        'Отказ клиента': this.$t('bookings_states.decline'),
        'Нет машин': this.$t('bookings_states.no_cars'),
        'Недозвон': this.$t('bookings_states.abandoned'),
        'Ожидает ответа клиента': this.$t('bookings_states.wait_answer'),
        'Ожидает оплаты': this.$t('bookings_states.wait_pay'),
        'Активная': this.$t('bookings_states.active'),
        'Отмена': this.$t('bookings_states.cancel'),
        'Отъездила': this.$t('bookings_states.rided'),
        'Вернуть залог': this.$t('bookings_states.return_deposit'),
        'Подтверждена': this.$t('bookings_states.accepted'),
        'Не подтверждена': this.$t('bookings_states.not_accepted'),
        'Другое': this.$t('bookings_states.other')
      }
      return translations[state] || state
    },
    getStateColor(state) {
      switch (state) {
        case 'Новая': return 'primary'
        case 'Подтверждена': return 'success'
        case 'Не подтверждена': return 'warning'
        case 'В обработке': return 'primary'
        case 'Отказ клиента': return 'error'
        case 'Нет машин': return 'secondary'
        case 'Недозвон': return 'warning'
        case 'Ожидает ответа клиента': return 'pink'
        case 'Ожидает оплаты': return 'lime'
        case 'Активная': return 'light-blue'
        case 'Отмена': return 'brown'
        case 'Отъездила': return 'light-green'
        case 'Вернуть залог': return 'blue'
        default: return 'secondary'
      }
    },
    updateCarsFiles(event) {
      console.log("updateCarsFiles 1", event);
      this.car.cars_files.unshift(event);
    },
    updateSortCarsFiles(event) {
      this.car.cars_files = event;
    },
    nextCar() {
      let next_car_id = null;
      this.cars_ids.forEach((car_id, index) => {
        if (car_id == this.car.id) {
          if (index + 1 < this.cars_ids.length) {
            next_car_id = this.cars_ids[index + 1];
          } else {
            next_car_id = this.cars_ids[0];
          }
        }
      });
      if (next_car_id && next_car_id != this.car.id) {
        this.$router
          .push({ path: `/cars/${next_car_id}` })
          .then(() => { this.$router.go() })
          .catch(() => {})
      }
    },
    prevCar() {
      let prev_car_id = null;
      this.cars_ids.forEach((car_id, index) => {
        if (car_id == this.car.id) {
          if (index - 1 >= 0) {
            prev_car_id = this.cars_ids[index - 1];
          } else {
            prev_car_id = this.cars_ids[this.cars_ids.length - 1];
          }
        }
      });
      if (prev_car_id && prev_car_id != this.car.id) {
        this.$router
          .push({ path: `/cars/${prev_car_id}` })
          .then(() => { this.$router.go() })
          .catch(() => {})
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    formatDateBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("DD MMM");
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("DD MMM H:mm");
    },
    formatDate(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD").format("ll");
      } else {
        return "-";
      }
    },
    formatTimeBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("H:mm");
    },
    shortFormatBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("DD-MM H:mm");
    },
    checkLateDate(date) {
      if (!moment().isSameOrBefore(moment(date, "DD-MM-YYYY H:mm"), "day")) {
        return "color: tomato;";
      }
    },
    replaceToBooking(booking) {
      this.$router.push({ path: `/bookings/${booking.id}` });
    },
    setWorker(id) {
      if (id != null) {
        if (this.workers.find((worker) => worker.id == id)) {
          return this.workers.find((worker) => worker.id == id).name;
        }
      } else {
        return "-";
      }
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    returnDate(item) {
      return moment(item, "YYYY-MM-DD").format("ll");
    },
    returnDateTime(item) {
      return moment(item).format("lll");
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
    CarPassport,
    RentToOwnNumberChip,
    TaskCardSection,
    TaskFormDialog,
    Gallery,
    GalleryBooking,
    CurrentPosition,
    Uppy,
    UppyBooking,
    UppyCarsDoc,
    UppyCarsEntityDoc,
    UppyCarAvatar,
    Doughnut,
    TaxiVehicleInfo,
    StarlineTab,
    WialonTab,
    AutofonTab,
    TraccarTab,
    LoadFailedRetry,
    AgentMarker,
    PriceGroupPicker,
    CarPricingLimitsPanel,
  },
};
</script>
<style lang="css">
table.v-table thead td:not(:nth-child(1)),
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)),
table.v-table tbody th:not(:nth-child(1)),
table.v-table thead td:first-child,
table.v-table tbody td:first-child,
table.v-table thead th:first-child,
table.v-table tbody th:first-child {
  padding: 0 5px;
}

.mobile-price-table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-price-table-wrapper .v-simple-table {
  min-width: max-content;
}

.mobile-price-table-wrapper .v-text-field,
.mobile-price-table-wrapper .v-select {
  min-width: 80px;
  max-width: 120px;
}

.mobile-price-table-wrapper .v-input__control {
  min-height: 36px !important;
}

.mobile-price-table-wrapper td,
.mobile-price-table-wrapper th {
  padding: 2px 4px !important;
  white-space: nowrap;
}

.mobile-price-table-wrapper .v-text-field__details {
  display: none !important;
}
.tag-dimmed {
  opacity: 0.35 !important;
  transition: opacity 0.15s;
}
/* xs: ряд иконок карточки авто с ml-4 не влезает в ширину телефона —
   стрелка «следующее авто» падала на вторую строку; ужимаем межиконные
   отступы и держим ряд одной строкой */
@media (max-width: 599px) {
  .start-tour-car-3 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
  }
  .start-tour-car-3 .ml-4 {
    margin-left: 6px !important;
  }
}
</style>
